
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb8e7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb8e7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


var $7e96a608cb33bf79$exports = {};

$parcel$export($7e96a608cb33bf79$exports, "createRoot", () => $7e96a608cb33bf79$export$882461b6382ed46c, (v) => $7e96a608cb33bf79$export$882461b6382ed46c = v);
$parcel$export($7e96a608cb33bf79$exports, "hydrateRoot", () => $7e96a608cb33bf79$export$757ceba2d55c277e, (v) => $7e96a608cb33bf79$export$757ceba2d55c277e = v);
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


/**
 * React Router DOM v6.20.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.13.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else if (isPathRelative) {
        let fromSegments = routePathnames[routePathnames.length - 1].replace(/^\//, "").split("/");
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // With relative="path", each leading .. segment means "go up one URL segment"
            while(toSegments[0] === ".."){
                toSegments.shift();
                fromSegments.pop();
            }
            to.pathname = toSegments.join("/");
        }
        from = "/" + fromSegments.join("/");
    } else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // With relative="route" (the default), each leading .. segment means
            // "go up one route" instead of "go up one URL segment".  This is a key
            // difference from how <a href> works and a major reason we call this a
            // "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.20.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))))), null);
}
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || "");
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}





const $f9d4140d897bf4e5$export$9e4392141ffe9081 = ()=>{
    const apiBaseUrl = "https://prod.lambertbot.com";
    const authUrl = `${apiBaseUrl}/auth`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "lambert",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "frame",
                src: "/img/frame.svg"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "div",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "frame-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "group",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "overlap-group-wrapper",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "overlap-group",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "/",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: "/img/logo.svg"
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "meet-lambert-your",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "span",
                                children: "Success"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "lambert-is-an-office",
                            children: "Your installation is complete \u2705"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "frame-6",
                        src: "/img/frame-6.svg"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-multiple-features",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Multiple features"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "frame-5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "track-debts-between",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-wrapper-3",
                                            children: "\uD83C\uDFE6\xa0\xa0 Track debts between colleagues"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "span-wrapper",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-wrapper-3",
                                            children: "\uD83E\uDD10\xa0\xa0Swear jar"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-wrapper-3",
                                        children: "\uD83C\uDFB2\xa0\xa0Create poll,\xa0roll, or pick random"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "span-wrapper",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-wrapper-3",
                                            children: "\uD83C\uDF82\xa0\xa0Birthday notifications"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-wrapper-3",
                                        children: "\uD83D\uDCF7\xa0\xa0Search and deliver random images or videos - for fun"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-wrapper-3",
                                        children: "\uD83C\uDF81\xa0\xa0Secret Santa"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-7",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "open-debt-png",
                        src: "/img/open-debt-png.png"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bank-header-text",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bank-header",
                                        children: "Settle debts"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "bank-text",
                                        children: [
                                            "Never lose track of office debts. ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            "Open tabs, track and settle debts all within Slack."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "frame-9",
                                src: "/img/frame-5.svg"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-swear-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-swear-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "swear-header-text",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-wrapper-2",
                                        children: "Swear jar"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "pay-for-your-swears",
                                        children: "Pay for your swears\xa0and improve the office budget."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "overlap-wrapper",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "overlap",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "overlap-group-2",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            className: "overlap-group-swear-jar",
                                            src: "/img/swear-jar.svg"
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-swear-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "stats-no-swears",
                                src: "/img/new-1.png"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "stats-no-swears",
                                src: "/img/stats-no-swears-1.png"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-poll-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "frame-poll-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "poll-examples",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "overlap-group-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "poll",
                                        src: "/img/poll2-1.png"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "roll",
                                        src: "/img/roll3-1.png"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-poll-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "frame-poll-header-text",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "heading-settle",
                                        children: "Create polls,\xa0roll, or pick random"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "poll-text",
                                        children: [
                                            "End indecision about lunch, suggest team building activities?",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            "Resolve disagreement once and for all."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "frame-18",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "overlap-3",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "overlap-group-5",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: "/img/pick-roll.svg"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-santa-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-santa-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "santa-header-text",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-wrapper-2",
                                        children: "Secret Santa"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "pay-for-your-swears",
                                        children: [
                                            "'Tis the season to be jolly, boost the holiday spirit by",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            " organizing Secret \uD83C\uDF85 with your team. ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            "Fa la la la la... \uD83C\uDF81"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "santa-svg",
                                src: "/img/frame-2.svg"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "frame-20",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            className: "secret-santa",
                            src: "/img/answer-1.png"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "div",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-wrapper-9",
                    children: "Add Lambert to your workspace now!"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-21",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "section",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "frame-22",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-wrapper-9",
                                    children: "FAQ"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "frame-23",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "frame-24",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "frame-14",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-wrapper-10",
                                                            children: "How do I install Lambert on my Slack workspace?"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "p",
                                                            children: [
                                                                "It's really simple, just click\xa0",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    href: authUrl,
                                                                    className: "text-wrapper-12",
                                                                    children: "Add to slack"
                                                                }),
                                                                " ",
                                                                "and follow the instructions."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "frame-14",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-wrapper-10",
                                                            children: "Where can I get help if this app doesn\u2019t work?"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "p-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-wrapper-11",
                                                                    children: "Reach out to us at "
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    href: "mailto:lambert@lambdaworks.io",
                                                                    className: "text-wrapper-12",
                                                                    children: "lambert@lambdaworks.io"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "text-wrapper-11",
                                                                    children: [
                                                                        " ",
                                                                        "and we'll help you out as soon as we can."
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "frame-25",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "frame-21",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "frame-26",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-wrapper-10",
                                                                children: "Can I send suggestions?"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                className: "p-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-wrapper-11",
                                                                        children: "For sure, we\u2019d love to hear what you have to say. Just hit us up at"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                        href: "mailto:lambert@lambdaworks.io",
                                                                        className: "text-wrapper-12",
                                                                        children: [
                                                                            " ",
                                                                            "lambert@lambdaworks.io"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "frame-28",
                                                    src: "/img/frame-1.svg"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-29",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "made-with-by",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-wrapper-11",
                                        children: "Made with \uD83E\uDDE1\xa0\xa0by "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "https://lambdaworks.io",
                                        className: "text-wrapper-12",
                                        children: "LambdaWorks.io"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "div-align-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "link-support",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "/support",
                                            className: "link-support",
                                            children: "Support"
                                        }),
                                        " ",
                                        "/",
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "/policy",
                                            className: "link-support",
                                            children: "Terms and Conditions & Privacy Policy"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $a8d3b589a7d6ca32$export$41b6293a43d01328 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9d4140d897bf4e5$export$9e4392141ffe9081), {});
};






var $e444d6404c095fa5$var$t = "undefined" != typeof window ? window : void 0, $e444d6404c095fa5$var$i = "undefined" != typeof globalThis ? globalThis : $e444d6404c095fa5$var$t, $e444d6404c095fa5$var$e = Array.prototype, $e444d6404c095fa5$var$r = $e444d6404c095fa5$var$e.forEach, $e444d6404c095fa5$var$s = $e444d6404c095fa5$var$e.indexOf, $e444d6404c095fa5$var$n = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.navigator, $e444d6404c095fa5$var$o = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.document, $e444d6404c095fa5$var$a = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.location, $e444d6404c095fa5$var$l = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.fetch, $e444d6404c095fa5$var$u = null != $e444d6404c095fa5$var$i && $e444d6404c095fa5$var$i.XMLHttpRequest && "withCredentials" in new $e444d6404c095fa5$var$i.XMLHttpRequest ? $e444d6404c095fa5$var$i.XMLHttpRequest : void 0, $e444d6404c095fa5$var$h = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.AbortController, $e444d6404c095fa5$var$d = null == $e444d6404c095fa5$var$n ? void 0 : $e444d6404c095fa5$var$n.userAgent, $e444d6404c095fa5$var$v = null != $e444d6404c095fa5$var$t ? $e444d6404c095fa5$var$t : {}, $e444d6404c095fa5$var$c = {
    DEBUG: !1,
    LIB_VERSION: "1.268.2"
};
function $e444d6404c095fa5$var$f(t, i, e, r, s, n, o) {
    try {
        var a = t[n](o), l = a.value;
    } catch (t) {
        return void e(t);
    }
    a.done ? i(l) : Promise.resolve(l).then(r, s);
}
function $e444d6404c095fa5$var$p(t) {
    return function() {
        var i = this, e = arguments;
        return new Promise(function(r, s) {
            var n = t.apply(i, e);
            function o(t) {
                $e444d6404c095fa5$var$f(n, r, s, o, a, "next", t);
            }
            function a(t) {
                $e444d6404c095fa5$var$f(n, r, s, o, a, "throw", t);
            }
            o(void 0);
        });
    };
}
function $e444d6404c095fa5$var$g() {
    return $e444d6404c095fa5$var$g = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var e = arguments[i];
            for(var r in e)({}).hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
        return t;
    }, $e444d6404c095fa5$var$g.apply(null, arguments);
}
function $e444d6404c095fa5$var$_(t, i) {
    if (null == t) return {};
    var e = {};
    for(var r in t)if (({}).hasOwnProperty.call(t, r)) {
        if (-1 !== i.indexOf(r)) continue;
        e[r] = t[r];
    }
    return e;
}
var $e444d6404c095fa5$var$m = [
    "$snapshot",
    "$pageview",
    "$pageleave",
    "$set",
    "survey dismissed",
    "survey sent",
    "survey shown",
    "$identify",
    "$groupidentify",
    "$create_alias",
    "$$client_ingestion_warning",
    "$web_experiment_applied",
    "$feature_enrollment_update",
    "$feature_flag_called"
];
function $e444d6404c095fa5$var$y(t, i) {
    return -1 !== t.indexOf(i);
}
var $e444d6404c095fa5$var$b = function(t) {
    return t.trim();
}, $e444d6404c095fa5$var$w = function(t) {
    return t.replace(/^\$/, "");
};
var $e444d6404c095fa5$var$S = Array.isArray, $e444d6404c095fa5$var$k = Object.prototype, $e444d6404c095fa5$var$x = $e444d6404c095fa5$var$k.hasOwnProperty, $e444d6404c095fa5$var$E = $e444d6404c095fa5$var$k.toString, $e444d6404c095fa5$var$P = $e444d6404c095fa5$var$S || function(t) {
    return "[object Array]" === $e444d6404c095fa5$var$E.call(t);
}, $e444d6404c095fa5$var$I = (t)=>"function" == typeof t, $e444d6404c095fa5$var$R = (t)=>t === Object(t) && !$e444d6404c095fa5$var$P(t), $e444d6404c095fa5$var$T = (t)=>{
    if ($e444d6404c095fa5$var$R(t)) {
        for(var i in t)if ($e444d6404c095fa5$var$x.call(t, i)) return !1;
        return !0;
    }
    return !1;
}, $e444d6404c095fa5$var$C = (t)=>void 0 === t, $e444d6404c095fa5$var$M = (t)=>"[object String]" == $e444d6404c095fa5$var$E.call(t), $e444d6404c095fa5$var$O = (t)=>$e444d6404c095fa5$var$M(t) && 0 === t.trim().length, $e444d6404c095fa5$var$F = (t)=>null === t, $e444d6404c095fa5$var$A = (t)=>$e444d6404c095fa5$var$C(t) || $e444d6404c095fa5$var$F(t), $e444d6404c095fa5$var$D = (t)=>"[object Number]" == $e444d6404c095fa5$var$E.call(t), $e444d6404c095fa5$var$j = (t)=>"[object Boolean]" === $e444d6404c095fa5$var$E.call(t), $e444d6404c095fa5$var$L = (t)=>t instanceof FormData, $e444d6404c095fa5$var$N = (t)=>$e444d6404c095fa5$var$y($e444d6404c095fa5$var$m, t);
function $e444d6404c095fa5$var$U(t) {
    return null === t || "object" != typeof t;
}
function $e444d6404c095fa5$var$z(t, i) {
    return Object.prototype.toString.call(t) === "[object " + i + "]";
}
function $e444d6404c095fa5$var$q(t) {
    return !$e444d6404c095fa5$var$C(Event) && function(t, i) {
        try {
            return t instanceof i;
        } catch (t) {
            return !1;
        }
    }(t, Event);
}
var $e444d6404c095fa5$var$B = [
    !0,
    "true",
    1,
    "1",
    "yes"
], $e444d6404c095fa5$var$H = (t)=>$e444d6404c095fa5$var$y($e444d6404c095fa5$var$B, t), $e444d6404c095fa5$var$W = [
    !1,
    "false",
    0,
    "0",
    "no"
];
function $e444d6404c095fa5$var$G(t, i, e, r, s) {
    return i > e && (r.warn("min cannot be greater than max."), i = e), $e444d6404c095fa5$var$D(t) ? t > e ? (r.warn(" cannot be  greater than max: " + e + ". Using max value instead."), e) : t < i ? (r.warn(" cannot be less than min: " + i + ". Using min value instead."), i) : t : (r.warn(" must be a number. using max or fallback. max: " + e + ", fallback: " + s), $e444d6404c095fa5$var$G(s || e, i, e, r));
}
class $e444d6404c095fa5$var$V {
    constructor(t){
        this.t = t, this.i = {}, this.o = ()=>{
            Object.keys(this.i).forEach((t)=>{
                var i = this.h(t) + this.m;
                i >= this.S ? delete this.i[t] : this.k(t, i);
            });
        }, this.h = (t)=>this.i[String(t)], this.k = (t, i)=>{
            this.i[String(t)] = i;
        }, this.consumeRateLimit = (t)=>{
            var i, e, r = null !== (i = this.h(t)) && void 0 !== i ? i : this.S;
            if (0 === (r = Math.max(r - 1, 0))) return !0;
            this.k(t, r);
            var s = 0 === r;
            return s && (null == (e = this.$) || e.call(this, t)), s;
        }, this.$ = this.t.$, this.S = $e444d6404c095fa5$var$G(this.t.bucketSize, 0, 100, this.t.P), this.m = $e444d6404c095fa5$var$G(this.t.refillRate, 0, this.S, this.t.P), this.I = $e444d6404c095fa5$var$G(this.t.refillInterval, 0, 864e5, this.t.P), this.R = setInterval(()=>{
            this.o();
        }, this.I);
    }
    stop() {
        this.R && (clearInterval(this.R), this.R = void 0);
    }
}
var $e444d6404c095fa5$var$J, $e444d6404c095fa5$var$K, $e444d6404c095fa5$var$Y, $e444d6404c095fa5$var$X = (t)=>t instanceof Error;
function $e444d6404c095fa5$var$Q(t) {
    var i = globalThis._posthogChunkIds;
    if (i) {
        var e = Object.keys(i);
        return $e444d6404c095fa5$var$Y && e.length === $e444d6404c095fa5$var$K || ($e444d6404c095fa5$var$K = e.length, $e444d6404c095fa5$var$Y = e.reduce((e, r)=>{
            $e444d6404c095fa5$var$J || ($e444d6404c095fa5$var$J = {});
            var s = $e444d6404c095fa5$var$J[r];
            if (s) e[s[0]] = s[1];
            else for(var n = t(r), o = n.length - 1; o >= 0; o--){
                var a = n[o], l = null == a ? void 0 : a.filename, u = i[r];
                if (l && u) {
                    e[l] = u, $e444d6404c095fa5$var$J[r] = [
                        l,
                        u
                    ];
                    break;
                }
            }
            return e;
        }, {})), $e444d6404c095fa5$var$Y;
    }
}
var $e444d6404c095fa5$var$Z = "?";
function $e444d6404c095fa5$var$tt(t, i, e, r) {
    var s = {
        platform: "web:javascript",
        filename: t,
        function: "<anonymous>" === i ? $e444d6404c095fa5$var$Z : i,
        in_app: !0
    };
    return $e444d6404c095fa5$var$C(e) || (s.lineno = e), $e444d6404c095fa5$var$C(r) || (s.colno = r), s;
}
var $e444d6404c095fa5$var$it = (t, i)=>{
    var e = -1 !== t.indexOf("safari-extension"), r = -1 !== t.indexOf("safari-web-extension");
    return e || r ? [
        -1 !== t.indexOf("@") ? t.split("@")[0] : $e444d6404c095fa5$var$Z,
        e ? "safari-extension:" + i : "safari-web-extension:" + i
    ] : [
        t,
        i
    ];
}, $e444d6404c095fa5$var$et = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, $e444d6404c095fa5$var$rt = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, $e444d6404c095fa5$var$st = /\((\S*)(?::(\d+))(?::(\d+))\)/, $e444d6404c095fa5$var$nt = (t)=>{
    var i = $e444d6404c095fa5$var$et.exec(t);
    if (i) {
        var [, e, r, s] = i;
        return $e444d6404c095fa5$var$tt(e, $e444d6404c095fa5$var$Z, +r, +s);
    }
    var n = $e444d6404c095fa5$var$rt.exec(t);
    if (n) {
        if (n[2] && 0 === n[2].indexOf("eval")) {
            var o = $e444d6404c095fa5$var$st.exec(n[2]);
            o && (n[2] = o[1], n[3] = o[2], n[4] = o[3]);
        }
        var [a, l] = $e444d6404c095fa5$var$it(n[1] || $e444d6404c095fa5$var$Z, n[2]);
        return $e444d6404c095fa5$var$tt(l, a, n[3] ? +n[3] : void 0, n[4] ? +n[4] : void 0);
    }
}, $e444d6404c095fa5$var$ot = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, $e444d6404c095fa5$var$at = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, $e444d6404c095fa5$var$lt = (t)=>{
    var i = $e444d6404c095fa5$var$ot.exec(t);
    if (i) {
        if (i[3] && i[3].indexOf(" > eval") > -1) {
            var e = $e444d6404c095fa5$var$at.exec(i[3]);
            e && (i[1] = i[1] || "eval", i[3] = e[1], i[4] = e[2], i[5] = "");
        }
        var r = i[3], s = i[1] || $e444d6404c095fa5$var$Z;
        return [s, r] = $e444d6404c095fa5$var$it(s, r), $e444d6404c095fa5$var$tt(r, s, i[4] ? +i[4] : void 0, i[5] ? +i[5] : void 0);
    }
}, $e444d6404c095fa5$var$ut = /\(error: (.*)\)/, $e444d6404c095fa5$var$ht = 50;
function $e444d6404c095fa5$var$dt() {
    for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
    return function(t, e) {
        void 0 === e && (e = 0);
        for(var r = [], s = t.split("\n"), n = e; n < s.length; n++){
            var o = s[n];
            if (!(o.length > 1024)) {
                var a = $e444d6404c095fa5$var$ut.test(o) ? o.replace($e444d6404c095fa5$var$ut, "$1") : o;
                if (!a.match(/\S*Error: /)) {
                    for (var l of i){
                        var u = l(a);
                        if (u) {
                            r.push(u);
                            break;
                        }
                    }
                    if (r.length >= $e444d6404c095fa5$var$ht) break;
                }
            }
        }
        return function(t) {
            if (!t.length) return [];
            var i = Array.from(t);
            return i.reverse(), i.slice(0, $e444d6404c095fa5$var$ht).map((t)=>{
                var e;
                return $e444d6404c095fa5$var$g({}, t, {
                    filename: t.filename || (e = i, e[e.length - 1] || {}).filename,
                    function: t.function || $e444d6404c095fa5$var$Z
                });
            });
        }(r);
    };
}
class $e444d6404c095fa5$var$vt {
    constructor(t, i, e){
        void 0 === t && (t = []), void 0 === i && (i = []), void 0 === e && (e = []), this.coercers = t, this.modifiers = e, this.stackParser = $e444d6404c095fa5$var$dt(...i);
    }
    buildFromUnknown(t, i) {
        void 0 === i && (i = {});
        var e = i && i.mechanism || {
            handled: !0,
            type: "generic"
        }, r = this.buildCoercingContext(e, i, 0).apply(t), s = this.buildParsingContext(), n = this.parseStacktrace(r, s);
        return {
            $exception_list: this.convertToExceptionList(n, e),
            $exception_level: "error"
        };
    }
    coerceFallback(t) {
        var i;
        return {
            type: "Error",
            value: "Unknown error",
            stack: null == (i = t.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
    parseStacktrace(t, i) {
        var e, r;
        return null != t.cause && (e = this.parseStacktrace(t.cause, i)), "" != t.stack && null != t.stack && (r = this.applyChunkIds(this.stackParser(t.stack, t.synthetic ? 1 : 0), i.chunkIdMap)), $e444d6404c095fa5$var$g({}, t, {
            cause: e,
            stack: r
        });
    }
    applyChunkIds(t, i) {
        return t.map((t)=>(t.filename && i && (t.chunk_id = i[t.filename]), t));
    }
    applyCoercers(t, i) {
        for (var e of this.coercers)if (e.match(t)) return e.coerce(t, i);
        return this.coerceFallback(i);
    }
    applyModifiers(t) {
        var i = this;
        return $e444d6404c095fa5$var$p(function*() {
            var e = t;
            for (var r of i.modifiers)e = yield r(e);
            return e;
        })();
    }
    modifyFrames(t) {
        var i = this;
        return $e444d6404c095fa5$var$p(function*() {
            var e;
            null != t.cause && (e = yield i.modifyFrames(t.cause));
            var r = [];
            return null != t.stack && (r = yield i.applyModifiers(t.stack)), $e444d6404c095fa5$var$g({}, t, {
                cause: e,
                stack: r
            });
        })();
    }
    convertToExceptionList(t, i) {
        var e, r, s, n = {
            type: t.type,
            value: t.value,
            mechanism: {
                type: null !== (e = i.type) && void 0 !== e ? e : "generic",
                handled: null === (r = i.handled) || void 0 === r || r,
                synthetic: null !== (s = t.synthetic) && void 0 !== s && s
            }
        };
        t.stack && (n.stacktrace = {
            type: "raw",
            frames: t.stack
        });
        var o = [
            n
        ];
        return null != t.cause && o.push(...this.convertToExceptionList(t.cause, $e444d6404c095fa5$var$g({}, i, {
            handled: !0
        }))), o;
    }
    buildParsingContext() {
        return {
            chunkIdMap: $e444d6404c095fa5$var$Q(this.stackParser)
        };
    }
    buildCoercingContext(t, i, e) {
        void 0 === e && (e = 0);
        var r = (e, r)=>{
            if (r <= 4) {
                var s = this.buildCoercingContext(t, i, r);
                return this.applyCoercers(e, s);
            }
        };
        return $e444d6404c095fa5$var$g({}, i, {
            syntheticException: 0 == e ? i.syntheticException : void 0,
            mechanism: t,
            apply: (t)=>r(t, e),
            next: (t)=>r(t, e + 1)
        });
    }
}
class $e444d6404c095fa5$var$ct {
    match(t) {
        return this.isDOMException(t) || this.isDOMError(t);
    }
    coerce(t, i) {
        var e = $e444d6404c095fa5$var$M(t.stack);
        return {
            type: this.getType(t),
            value: this.getValue(t),
            stack: e ? t.stack : void 0,
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return this.isDOMError(t) ? "DOMError" : "DOMException";
    }
    getValue(t) {
        var i = t.name || (this.isDOMError(t) ? "DOMError" : "DOMException");
        return t.message ? i + ": " + t.message : i;
    }
    isDOMException(t) {
        return $e444d6404c095fa5$var$z(t, "DOMException");
    }
    isDOMError(t) {
        return $e444d6404c095fa5$var$z(t, "DOMError");
    }
}
class $e444d6404c095fa5$var$ft {
    match(t) {
        return ((t)=>t instanceof Error)(t);
    }
    coerce(t, i) {
        return {
            type: this.getType(t),
            value: this.getMessage(t, i),
            stack: this.getStack(t),
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return t.name || t.constructor.name;
    }
    getMessage(t, i) {
        var e = t.message;
        return e.error && "string" == typeof e.error.message ? String(e.error.message) : String(e);
    }
    getStack(t) {
        return t.stacktrace || t.stack || void 0;
    }
}
class $e444d6404c095fa5$var$pt {
    constructor(){}
    match(t) {
        return $e444d6404c095fa5$var$z(t, "ErrorEvent") && null != t.error;
    }
    coerce(t, i) {
        var e, r = i.apply(t.error);
        return r || {
            type: "ErrorEvent",
            value: t.message,
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
var $e444d6404c095fa5$var$gt = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
class $e444d6404c095fa5$var$_t {
    match(t) {
        return "string" == typeof t;
    }
    coerce(t, i) {
        var e, [r, s] = this.getInfos(t);
        return {
            type: null != r ? r : "Error",
            value: null != s ? s : t,
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
    getInfos(t) {
        var i = "Error", e = t, r = t.match($e444d6404c095fa5$var$gt);
        return r && (i = r[1], e = r[2]), [
            i,
            e
        ];
    }
}
var $e444d6404c095fa5$var$mt = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function $e444d6404c095fa5$var$yt(t, i) {
    void 0 === i && (i = 40);
    var e = Object.keys(t);
    if (e.sort(), !e.length) return "[object has no keys]";
    for(var r = e.length; r > 0; r--){
        var s = e.slice(0, r).join(", ");
        if (!(s.length > i)) return r === e.length || s.length <= i ? s : s.slice(0, i) + "...";
    }
    return "";
}
class $e444d6404c095fa5$var$bt {
    match(t) {
        return "object" == typeof t && null !== t;
    }
    coerce(t, i) {
        var e, r = this.getErrorPropertyFromObject(t);
        return r ? i.apply(r) : {
            type: this.getType(t),
            value: this.getValue(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            level: this.isSeverityLevel(t.level) ? t.level : "error",
            synthetic: !0
        };
    }
    getType(t) {
        return $e444d6404c095fa5$var$q(t) ? t.constructor.name : "Error";
    }
    getValue(t) {
        if ("name" in t && "string" == typeof t.name) {
            var i = "'" + t.name + "' captured as exception";
            return "message" in t && "string" == typeof t.message && (i += " with message: '" + t.message + "'"), i;
        }
        if ("message" in t && "string" == typeof t.message) return t.message;
        var e = this.getObjectClassName(t);
        return (e && "Object" !== e ? "'" + e + "'" : "Object") + " captured as exception with keys: " + $e444d6404c095fa5$var$yt(t);
    }
    isSeverityLevel(t) {
        return $e444d6404c095fa5$var$M(t) && !$e444d6404c095fa5$var$O(t) && $e444d6404c095fa5$var$mt.indexOf(t) >= 0;
    }
    getErrorPropertyFromObject(t) {
        for(var i in t)if (Object.prototype.hasOwnProperty.call(t, i)) {
            var e = t[i];
            if ($e444d6404c095fa5$var$X(e)) return e;
        }
    }
    getObjectClassName(t) {
        try {
            var i = Object.getPrototypeOf(t);
            return i ? i.constructor.name : void 0;
        } catch (t) {
            return;
        }
    }
}
class $e444d6404c095fa5$var$wt {
    match(t) {
        return $e444d6404c095fa5$var$q(t);
    }
    coerce(t, i) {
        var e, r = t.constructor.name;
        return {
            type: r,
            value: r + " captured as exception with keys: " + $e444d6404c095fa5$var$yt(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
class $e444d6404c095fa5$var$St {
    match(t) {
        return $e444d6404c095fa5$var$U(t);
    }
    coerce(t, i) {
        var e;
        return {
            type: "Error",
            value: "Primitive value captured as exception: " + String(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
class $e444d6404c095fa5$var$kt {
    match(t) {
        return $e444d6404c095fa5$var$z(t, "PromiseRejectionEvent");
    }
    coerce(t, i) {
        var e, r = this.getUnhandledRejectionReason(t);
        return $e444d6404c095fa5$var$U(r) ? {
            type: "UnhandledRejection",
            value: "Non-Error promise rejection captured with value: " + String(r),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        } : i.apply(r);
    }
    getUnhandledRejectionReason(t) {
        if ($e444d6404c095fa5$var$U(t)) return t;
        try {
            if ("reason" in t) return t.reason;
            if ("detail" in t && "reason" in t.detail) return t.detail.reason;
        } catch (t) {}
        return t;
    }
}
var $e444d6404c095fa5$var$$t = (i)=>{
    var e = {
        T: function(e) {
            if ($e444d6404c095fa5$var$t && ($e444d6404c095fa5$var$c.DEBUG || $e444d6404c095fa5$var$v.POSTHOG_DEBUG) && !$e444d6404c095fa5$var$C($e444d6404c095fa5$var$t.console) && $e444d6404c095fa5$var$t.console) {
                for(var r = ("__rrweb_original__" in $e444d6404c095fa5$var$t.console[e]) ? $e444d6404c095fa5$var$t.console[e].__rrweb_original__ : $e444d6404c095fa5$var$t.console[e], s = arguments.length, n = new Array(s > 1 ? s - 1 : 0), o = 1; o < s; o++)n[o - 1] = arguments[o];
                r(i, ...n);
            }
        },
        info: function() {
            for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
            e.T("log", ...i);
        },
        warn: function() {
            for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
            e.T("warn", ...i);
        },
        error: function() {
            for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
            e.T("error", ...i);
        },
        critical: function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            console.error(i, ...e);
        },
        uninitializedWarning: (t)=>{
            e.error("You must initialize PostHog before calling " + t);
        },
        createLogger: (t)=>$e444d6404c095fa5$var$$t(i + " " + t)
    };
    return e;
}, $e444d6404c095fa5$var$xt = $e444d6404c095fa5$var$$t("[PostHog.js]"), $e444d6404c095fa5$var$Et = $e444d6404c095fa5$var$xt.createLogger, $e444d6404c095fa5$var$Pt = $e444d6404c095fa5$var$Et("[ExternalScriptsLoader]"), $e444d6404c095fa5$var$It = (t, i, e)=>{
    if (t.config.disable_external_dependency_loading) return $e444d6404c095fa5$var$Pt.warn(i + " was requested but loading of external scripts is disabled."), e("Loading of external scripts is disabled");
    var r = null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.querySelectorAll("script");
    if (r) {
        for(var s, n = function() {
            if (r[a].src === i) {
                var t = r[a];
                return t.__posthog_loading_callback_fired ? {
                    v: e()
                } : (t.addEventListener("load", (i)=>{
                    t.__posthog_loading_callback_fired = !0, e(void 0, i);
                }), t.onerror = (t)=>e(t), {
                    v: void 0
                });
            }
        }, a = 0; a < r.length; a++)if (s = n()) return s.v;
    }
    var l = ()=>{
        if (!$e444d6404c095fa5$var$o) return e("document not found");
        var r = $e444d6404c095fa5$var$o.createElement("script");
        if (r.type = "text/javascript", r.crossOrigin = "anonymous", r.src = i, r.onload = (t)=>{
            r.__posthog_loading_callback_fired = !0, e(void 0, t);
        }, r.onerror = (t)=>e(t), t.config.prepare_external_dependency_script && (r = t.config.prepare_external_dependency_script(r)), !r) return e("prepare_external_dependency_script returned null");
        var s, n = $e444d6404c095fa5$var$o.querySelectorAll("body > script");
        n.length > 0 ? null == (s = n[0].parentNode) || s.insertBefore(r, n[0]) : $e444d6404c095fa5$var$o.body.appendChild(r);
    };
    null != $e444d6404c095fa5$var$o && $e444d6404c095fa5$var$o.body ? l() : null == $e444d6404c095fa5$var$o || $e444d6404c095fa5$var$o.addEventListener("DOMContentLoaded", l);
};
$e444d6404c095fa5$var$v.__PosthogExtensions__ = $e444d6404c095fa5$var$v.__PosthogExtensions__ || {}, $e444d6404c095fa5$var$v.__PosthogExtensions__.loadExternalDependency = (t, i, e)=>{
    var r = "/static/" + i + ".js?v=" + t.version;
    if ("remote-config" === i && (r = "/array/" + t.config.token + "/config.js"), "toolbar" === i) {
        var s = 3e5;
        r = r + "&t=" + Math.floor(Date.now() / s) * s;
    }
    var n = t.requestRouter.endpointFor("assets", r);
    $e444d6404c095fa5$var$It(t, n, e);
}, $e444d6404c095fa5$var$v.__PosthogExtensions__.loadSiteApp = (t, i, e)=>{
    var r = t.requestRouter.endpointFor("api", i);
    $e444d6404c095fa5$var$It(t, r, e);
};
var $e444d6404c095fa5$var$Rt = {};
function $e444d6404c095fa5$var$Tt(t, i, e) {
    if ($e444d6404c095fa5$var$P(t)) {
        if ($e444d6404c095fa5$var$r && t.forEach === $e444d6404c095fa5$var$r) t.forEach(i, e);
        else if ("length" in t && t.length === +t.length) {
            for(var s = 0, n = t.length; s < n; s++)if (s in t && i.call(e, t[s], s) === $e444d6404c095fa5$var$Rt) return;
        }
    }
}
function $e444d6404c095fa5$var$Ct(t, i, e) {
    if (!$e444d6404c095fa5$var$A(t)) {
        if ($e444d6404c095fa5$var$P(t)) return $e444d6404c095fa5$var$Tt(t, i, e);
        if ($e444d6404c095fa5$var$L(t)) {
            for (var r of t.entries())if (i.call(e, r[1], r[0]) === $e444d6404c095fa5$var$Rt) return;
        } else for(var s in t)if ($e444d6404c095fa5$var$x.call(t, s) && i.call(e, t[s], s) === $e444d6404c095fa5$var$Rt) return;
    }
}
var $e444d6404c095fa5$var$Mt = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $e444d6404c095fa5$var$Tt(e, function(i) {
        for(var e in i)void 0 !== i[e] && (t[e] = i[e]);
    }), t;
}, $e444d6404c095fa5$var$Ot = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $e444d6404c095fa5$var$Tt(e, function(i) {
        $e444d6404c095fa5$var$Tt(i, function(i) {
            t.push(i);
        });
    }), t;
};
function $e444d6404c095fa5$var$Ft(t) {
    for(var i = Object.keys(t), e = i.length, r = new Array(e); e--;)r[e] = [
        i[e],
        t[i[e]]
    ];
    return r;
}
var $e444d6404c095fa5$var$At = function(t) {
    try {
        return t();
    } catch (t) {
        return;
    }
}, $e444d6404c095fa5$var$Dt = function(t) {
    return function() {
        try {
            for(var i = arguments.length, e = new Array(i), r = 0; r < i; r++)e[r] = arguments[r];
            return t.apply(this, e);
        } catch (t) {
            $e444d6404c095fa5$var$xt.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $e444d6404c095fa5$var$xt.critical(t);
        }
    };
}, $e444d6404c095fa5$var$jt = function(t) {
    var i = {};
    return $e444d6404c095fa5$var$Ct(t, function(t, e) {
        ($e444d6404c095fa5$var$M(t) && t.length > 0 || $e444d6404c095fa5$var$D(t)) && (i[e] = t);
    }), i;
};
function $e444d6404c095fa5$var$Lt(t, i) {
    var e, r, s;
    return e = t, r = (t)=>$e444d6404c095fa5$var$M(t) && !$e444d6404c095fa5$var$F(i) ? t.slice(0, i) : t, s = new Set, function t(i, e) {
        var n;
        return i !== Object(i) ? r ? r(i, e) : i : s.has(i) ? void 0 : (s.add(i), $e444d6404c095fa5$var$P(i) ? (n = [], $e444d6404c095fa5$var$Tt(i, (i)=>{
            n.push(t(i));
        })) : (n = {}, $e444d6404c095fa5$var$Ct(i, (i, e)=>{
            s.has(i) || (n[e] = t(i, e));
        })), n);
    }(e);
}
var $e444d6404c095fa5$var$Nt = [
    "herokuapp.com",
    "vercel.app",
    "netlify.app"
];
function $e444d6404c095fa5$var$Ut(t) {
    var i = null == t ? void 0 : t.hostname;
    if (!$e444d6404c095fa5$var$M(i)) return !1;
    var e = i.split(".").slice(-2).join(".");
    for (var r of $e444d6404c095fa5$var$Nt)if (e === r) return !1;
    return !0;
}
function $e444d6404c095fa5$var$zt(t, i) {
    for(var e = 0; e < t.length; e++)if (i(t[e])) return t[e];
}
function $e444d6404c095fa5$var$qt(t, i, e, r) {
    var { capture: s = !1, passive: n = !0 } = null != r ? r : {};
    null == t || t.addEventListener(i, e, {
        capture: s,
        passive: n
    });
}
var $e444d6404c095fa5$var$Bt = "$people_distinct_id", $e444d6404c095fa5$var$Ht = "__alias", $e444d6404c095fa5$var$Wt = "__timers", $e444d6404c095fa5$var$Gt = "$autocapture_disabled_server_side", $e444d6404c095fa5$var$Vt = "$heatmaps_enabled_server_side", $e444d6404c095fa5$var$Jt = "$exception_capture_enabled_server_side", $e444d6404c095fa5$var$Kt = "$error_tracking_suppression_rules", $e444d6404c095fa5$var$Yt = "$error_tracking_capture_extension_exceptions", $e444d6404c095fa5$var$Xt = "$web_vitals_enabled_server_side", $e444d6404c095fa5$var$Qt = "$dead_clicks_enabled_server_side", $e444d6404c095fa5$var$Zt = "$web_vitals_allowed_metrics", $e444d6404c095fa5$var$ti = "$session_recording_remote_config", $e444d6404c095fa5$var$ii = "$session_recording_enabled_server_side", $e444d6404c095fa5$var$ei = "$console_log_recording_enabled_server_side", $e444d6404c095fa5$var$ri = "$session_recording_network_payload_capture", $e444d6404c095fa5$var$si = "$session_recording_masking", $e444d6404c095fa5$var$ni = "$session_recording_canvas_recording", $e444d6404c095fa5$var$oi = "$replay_sample_rate", $e444d6404c095fa5$var$ai = "$replay_minimum_duration", $e444d6404c095fa5$var$li = "$replay_script_config", $e444d6404c095fa5$var$ui = "$sesid", $e444d6404c095fa5$var$hi = "$session_is_sampled", $e444d6404c095fa5$var$di = "$session_recording_url_trigger_activated_session", $e444d6404c095fa5$var$vi = "$session_recording_event_trigger_activated_session", $e444d6404c095fa5$var$ci = "$enabled_feature_flags", $e444d6404c095fa5$var$fi = "$early_access_features", $e444d6404c095fa5$var$pi = "$feature_flag_details", $e444d6404c095fa5$var$gi = "$stored_person_properties", $e444d6404c095fa5$var$_i = "$stored_group_properties", $e444d6404c095fa5$var$mi = "$surveys", $e444d6404c095fa5$var$yi = "$surveys_activated", $e444d6404c095fa5$var$bi = "$flag_call_reported", $e444d6404c095fa5$var$wi = "$user_state", $e444d6404c095fa5$var$Si = "$client_session_props", $e444d6404c095fa5$var$ki = "$capture_rate_limit", $e444d6404c095fa5$var$$i = "$initial_campaign_params", $e444d6404c095fa5$var$xi = "$initial_referrer_info", $e444d6404c095fa5$var$Ei = "$initial_person_info", $e444d6404c095fa5$var$Pi = "$epp", $e444d6404c095fa5$var$Ii = "__POSTHOG_TOOLBAR__", $e444d6404c095fa5$var$Ri = "$posthog_cookieless", $e444d6404c095fa5$var$Ti = [
    $e444d6404c095fa5$var$Bt,
    $e444d6404c095fa5$var$Ht,
    "__cmpns",
    $e444d6404c095fa5$var$Wt,
    $e444d6404c095fa5$var$ii,
    $e444d6404c095fa5$var$Vt,
    $e444d6404c095fa5$var$ui,
    $e444d6404c095fa5$var$ci,
    $e444d6404c095fa5$var$Kt,
    $e444d6404c095fa5$var$wi,
    $e444d6404c095fa5$var$fi,
    $e444d6404c095fa5$var$pi,
    $e444d6404c095fa5$var$_i,
    $e444d6404c095fa5$var$gi,
    $e444d6404c095fa5$var$mi,
    $e444d6404c095fa5$var$bi,
    $e444d6404c095fa5$var$Si,
    $e444d6404c095fa5$var$ki,
    $e444d6404c095fa5$var$$i,
    $e444d6404c095fa5$var$xi,
    $e444d6404c095fa5$var$Pi,
    $e444d6404c095fa5$var$Ei
];
function $e444d6404c095fa5$var$Ci(t) {
    return t instanceof Element && (t.id === $e444d6404c095fa5$var$Ii || !(null == t.closest || !t.closest(".toolbar-global-fade-container")));
}
function $e444d6404c095fa5$var$Mi(t) {
    return !!t && 1 === t.nodeType;
}
function $e444d6404c095fa5$var$Oi(t, i) {
    return !!t && !!t.tagName && t.tagName.toLowerCase() === i.toLowerCase();
}
function $e444d6404c095fa5$var$Fi(t) {
    return !!t && 3 === t.nodeType;
}
function $e444d6404c095fa5$var$Ai(t) {
    return !!t && 11 === t.nodeType;
}
function $e444d6404c095fa5$var$Di(t) {
    return t ? $e444d6404c095fa5$var$b(t).split(/\s+/) : [];
}
function $e444d6404c095fa5$var$ji(i) {
    var e = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.location.href;
    return !!(e && i && i.some((t)=>e.match(t)));
}
function $e444d6404c095fa5$var$Li(t) {
    var i = "";
    switch(typeof t.className){
        case "string":
            i = t.className;
            break;
        case "object":
            i = (t.className && "baseVal" in t.className ? t.className.baseVal : null) || t.getAttribute("class") || "";
            break;
        default:
            i = "";
    }
    return $e444d6404c095fa5$var$Di(i);
}
function $e444d6404c095fa5$var$Ni(t) {
    return $e444d6404c095fa5$var$A(t) ? null : $e444d6404c095fa5$var$b(t).split(/(\s+)/).filter((t)=>$e444d6404c095fa5$var$re(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $e444d6404c095fa5$var$Ui(t) {
    var i = "";
    return $e444d6404c095fa5$var$Ki(t) && !$e444d6404c095fa5$var$Yi(t) && t.childNodes && t.childNodes.length && $e444d6404c095fa5$var$Ct(t.childNodes, function(t) {
        var e;
        $e444d6404c095fa5$var$Fi(t) && t.textContent && (i += null !== (e = $e444d6404c095fa5$var$Ni(t.textContent)) && void 0 !== e ? e : "");
    }), $e444d6404c095fa5$var$b(i);
}
function $e444d6404c095fa5$var$zi(t) {
    var i;
    return $e444d6404c095fa5$var$C(t.target) ? t.srcElement || null : null != (i = t.target) && i.shadowRoot ? t.composedPath()[0] || null : t.target || null;
}
var $e444d6404c095fa5$var$qi = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $e444d6404c095fa5$var$Bi(t, i) {
    if ($e444d6404c095fa5$var$C(i)) return !0;
    var e, r = function(t) {
        if (i.some((i)=>t.matches(i))) return {
            v: !0
        };
    };
    for (var s of t)if (e = r(s)) return e.v;
    return !1;
}
function $e444d6404c095fa5$var$Hi(t) {
    var i = t.parentNode;
    return !(!i || !$e444d6404c095fa5$var$Mi(i)) && i;
}
var $e444d6404c095fa5$var$Wi = [
    ".ph-no-rageclick",
    ".ph-no-capture"
];
var $e444d6404c095fa5$var$Gi = (t)=>!t || $e444d6404c095fa5$var$Oi(t, "html") || !$e444d6404c095fa5$var$Mi(t), $e444d6404c095fa5$var$Vi = (i, e)=>{
    if (!$e444d6404c095fa5$var$t || $e444d6404c095fa5$var$Gi(i)) return {
        parentIsUsefulElement: !1,
        targetElementList: []
    };
    for(var r = !1, s = [
        i
    ], n = i; n.parentNode && !$e444d6404c095fa5$var$Oi(n, "body");)if ($e444d6404c095fa5$var$Ai(n.parentNode)) s.push(n.parentNode.host), n = n.parentNode.host;
    else {
        var o = $e444d6404c095fa5$var$Hi(n);
        if (!o) break;
        if (e || $e444d6404c095fa5$var$qi.indexOf(o.tagName.toLowerCase()) > -1) r = !0;
        else {
            var a = $e444d6404c095fa5$var$t.getComputedStyle(o);
            a && "pointer" === a.getPropertyValue("cursor") && (r = !0);
        }
        s.push(o), n = o;
    }
    return {
        parentIsUsefulElement: r,
        targetElementList: s
    };
};
function $e444d6404c095fa5$var$Ji(i, e, r, s, n) {
    var o, a, l, u;
    if (void 0 === r && (r = void 0), !$e444d6404c095fa5$var$t || $e444d6404c095fa5$var$Gi(i)) return !1;
    if (null != (o = r) && o.url_allowlist && !$e444d6404c095fa5$var$ji(r.url_allowlist)) return !1;
    if (null != (a = r) && a.url_ignorelist && $e444d6404c095fa5$var$ji(r.url_ignorelist)) return !1;
    if (null != (l = r) && l.dom_event_allowlist) {
        var h = r.dom_event_allowlist;
        if (h && !h.some((t)=>e.type === t)) return !1;
    }
    var { parentIsUsefulElement: d, targetElementList: v } = $e444d6404c095fa5$var$Vi(i, s);
    if (!function(t, i) {
        var e = null == i ? void 0 : i.element_allowlist;
        if ($e444d6404c095fa5$var$C(e)) return !0;
        var r, s = function(t) {
            if (e.some((i)=>t.tagName.toLowerCase() === i)) return {
                v: !0
            };
        };
        for (var n of t)if (r = s(n)) return r.v;
        return !1;
    }(v, r)) return !1;
    if (!$e444d6404c095fa5$var$Bi(v, null == (u = r) ? void 0 : u.css_selector_allowlist)) return !1;
    var c = $e444d6404c095fa5$var$t.getComputedStyle(i);
    if (c && "pointer" === c.getPropertyValue("cursor") && "click" === e.type) return !0;
    var f = i.tagName.toLowerCase();
    switch(f){
        case "html":
            return !1;
        case "form":
            return (n || [
                "submit"
            ]).indexOf(e.type) >= 0;
        case "input":
        case "select":
        case "textarea":
            return (n || [
                "change",
                "click"
            ]).indexOf(e.type) >= 0;
        default:
            return d ? (n || [
                "click"
            ]).indexOf(e.type) >= 0 : (n || [
                "click"
            ]).indexOf(e.type) >= 0 && ($e444d6404c095fa5$var$qi.indexOf(f) > -1 || "true" === i.getAttribute("contenteditable"));
    }
}
function $e444d6404c095fa5$var$Ki(t) {
    for(var i = t; i.parentNode && !$e444d6404c095fa5$var$Oi(i, "body"); i = i.parentNode){
        var e = $e444d6404c095fa5$var$Li(i);
        if ($e444d6404c095fa5$var$y(e, "ph-sensitive") || $e444d6404c095fa5$var$y(e, "ph-no-capture")) return !1;
    }
    if ($e444d6404c095fa5$var$y($e444d6404c095fa5$var$Li(t), "ph-include")) return !0;
    var r = t.type || "";
    if ($e444d6404c095fa5$var$M(r)) switch(r.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var s = t.name || t.id || "";
    if ($e444d6404c095fa5$var$M(s)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(s.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function $e444d6404c095fa5$var$Yi(t) {
    return !!($e444d6404c095fa5$var$Oi(t, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(t.type) || $e444d6404c095fa5$var$Oi(t, "select") || $e444d6404c095fa5$var$Oi(t, "textarea") || "true" === t.getAttribute("contenteditable"));
}
var $e444d6404c095fa5$var$Xi = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", $e444d6404c095fa5$var$Qi = new RegExp("^(?:" + $e444d6404c095fa5$var$Xi + ")$"), $e444d6404c095fa5$var$Zi = new RegExp($e444d6404c095fa5$var$Xi), $e444d6404c095fa5$var$te = "\\d{3}-?\\d{2}-?\\d{4}", $e444d6404c095fa5$var$ie = new RegExp("^(" + $e444d6404c095fa5$var$te + ")$"), $e444d6404c095fa5$var$ee = new RegExp("(" + $e444d6404c095fa5$var$te + ")");
function $e444d6404c095fa5$var$re(t, i) {
    if (void 0 === i && (i = !0), $e444d6404c095fa5$var$A(t)) return !1;
    if ($e444d6404c095fa5$var$M(t)) {
        if (t = $e444d6404c095fa5$var$b(t), (i ? $e444d6404c095fa5$var$Qi : $e444d6404c095fa5$var$Zi).test((t || "").replace(/[- ]/g, ""))) return !1;
        if ((i ? $e444d6404c095fa5$var$ie : $e444d6404c095fa5$var$ee).test(t)) return !1;
    }
    return !0;
}
function $e444d6404c095fa5$var$se(t) {
    var i = $e444d6404c095fa5$var$Ui(t);
    return $e444d6404c095fa5$var$re(i = (i + " " + $e444d6404c095fa5$var$ne(t)).trim()) ? i : "";
}
function $e444d6404c095fa5$var$ne(t) {
    var i = "";
    return t && t.childNodes && t.childNodes.length && $e444d6404c095fa5$var$Ct(t.childNodes, function(t) {
        var e;
        if (t && "span" === (null == (e = t.tagName) ? void 0 : e.toLowerCase())) try {
            var r = $e444d6404c095fa5$var$Ui(t);
            i = (i + " " + r).trim(), t.childNodes && t.childNodes.length && (i = (i + " " + $e444d6404c095fa5$var$ne(t)).trim());
        } catch (t) {
            $e444d6404c095fa5$var$xt.error("[AutoCapture]", t);
        }
    }), i;
}
function $e444d6404c095fa5$var$oe(t) {
    return function(t) {
        var i = t.map((t)=>{
            var i, e, r = "";
            if (t.tag_name && (r += t.tag_name), t.attr_class) for (var s of (t.attr_class.sort(), t.attr_class))r += "." + s.replace(/"/g, "");
            var n = $e444d6404c095fa5$var$g({}, t.text ? {
                text: t.text
            } : {}, {
                "nth-child": null !== (i = t.nth_child) && void 0 !== i ? i : 0,
                "nth-of-type": null !== (e = t.nth_of_type) && void 0 !== e ? e : 0
            }, t.href ? {
                href: t.href
            } : {}, t.attr_id ? {
                attr_id: t.attr_id
            } : {}, t.attributes), o = {};
            return $e444d6404c095fa5$var$Ft(n).sort((t, i)=>{
                var [e] = t, [r] = i;
                return e.localeCompare(r);
            }).forEach((t)=>{
                var [i, e] = t;
                return o[$e444d6404c095fa5$var$ae(i.toString())] = $e444d6404c095fa5$var$ae(e.toString());
            }), r += ":", r += $e444d6404c095fa5$var$Ft(o).map((t)=>{
                var [i, e] = t;
                return i + '="' + e + '"';
            }).join("");
        });
        return i.join(";");
    }(function(t) {
        return t.map((t)=>{
            var i, e, r = {
                text: null == (i = t.$el_text) ? void 0 : i.slice(0, 400),
                tag_name: t.tag_name,
                href: null == (e = t.attr__href) ? void 0 : e.slice(0, 2048),
                attr_class: $e444d6404c095fa5$var$le(t),
                attr_id: t.attr__id,
                nth_child: t.nth_child,
                nth_of_type: t.nth_of_type,
                attributes: {}
            };
            return $e444d6404c095fa5$var$Ft(t).filter((t)=>{
                var [i] = t;
                return 0 === i.indexOf("attr__");
            }).forEach((t)=>{
                var [i, e] = t;
                return r.attributes[i] = e;
            }), r;
        });
    }(t));
}
function $e444d6404c095fa5$var$ae(t) {
    return t.replace(/"|\\"/g, '\\"');
}
function $e444d6404c095fa5$var$le(t) {
    var i = t.attr__class;
    return i ? $e444d6404c095fa5$var$P(i) ? i : $e444d6404c095fa5$var$Di(i) : void 0;
}
class $e444d6404c095fa5$var$ue {
    constructor(){
        this.clicks = [];
    }
    isRageClick(t, i, e) {
        var r = this.clicks[this.clicks.length - 1];
        if (r && Math.abs(t - r.x) + Math.abs(i - r.y) < 30 && e - r.timestamp < 1e3) {
            if (this.clicks.push({
                x: t,
                y: i,
                timestamp: e
            }), 3 === this.clicks.length) return !0;
        } else this.clicks = [
            {
                x: t,
                y: i,
                timestamp: e
            }
        ];
        return !1;
    }
}
var $e444d6404c095fa5$export$7bea938663611d9 = "$copy_autocapture", $e444d6404c095fa5$export$6a00d17b5aff0af = function(t) {
    return t.GZipJS = "gzip-js", t.Base64 = "base64", t;
}({}), $e444d6404c095fa5$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
], $e444d6404c095fa5$var$ce = [
    "localhost",
    "127.0.0.1"
], $e444d6404c095fa5$var$fe = (t)=>{
    var i = null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.createElement("a");
    return $e444d6404c095fa5$var$C(i) ? null : (i.href = t, i);
}, $e444d6404c095fa5$var$pe = function(t, i) {
    var e, r;
    void 0 === i && (i = "&");
    var s = [];
    return $e444d6404c095fa5$var$Ct(t, function(t, i) {
        $e444d6404c095fa5$var$C(t) || $e444d6404c095fa5$var$C(i) || "undefined" === i || (e = encodeURIComponent(((t)=>t instanceof File)(t) ? t.name : t.toString()), r = encodeURIComponent(i), s[s.length] = r + "=" + e);
    }), s.join(i);
}, $e444d6404c095fa5$var$ge = function(t, i) {
    for(var e, r = ((t.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&"), s = 0; s < r.length; s++){
        var n = r[s].split("=");
        if (n[0] === i) {
            e = n;
            break;
        }
    }
    if (!$e444d6404c095fa5$var$P(e) || e.length < 2) return "";
    var o = e[1];
    try {
        o = decodeURIComponent(o);
    } catch (t) {
        $e444d6404c095fa5$var$xt.error("Skipping decoding for malformed query param: " + o);
    }
    return o.replace(/\+/g, " ");
}, $e444d6404c095fa5$var$_e = function(t, i, e) {
    if (!t || !i || !i.length) return t;
    for(var r = t.split("#"), s = r[0] || "", n = r[1], o = s.split("?"), a = o[1], l = o[0], u = (a || "").split("&"), h = [], d = 0; d < u.length; d++){
        var v = u[d].split("=");
        $e444d6404c095fa5$var$P(v) && (i.includes(v[0]) ? h.push(v[0] + "=" + e) : h.push(u[d]));
    }
    var c = l;
    return null != a && (c += "?" + h.join("&")), null != n && (c += "#" + n), c;
}, $e444d6404c095fa5$var$me = function(t, i) {
    var e = t.match(new RegExp(i + "=([^&]*)"));
    return e ? e[1] : null;
}, $e444d6404c095fa5$var$ye = $e444d6404c095fa5$var$Et("[AutoCapture]");
function $e444d6404c095fa5$var$be(t, i) {
    return i.length > t ? i.slice(0, t) + "..." : i;
}
function $e444d6404c095fa5$var$we(t) {
    if (t.previousElementSibling) return t.previousElementSibling;
    var i = t;
    do i = i.previousSibling;
    while (i && !$e444d6404c095fa5$var$Mi(i));
    return i;
}
function $e444d6404c095fa5$var$Se(t, i, e, r) {
    var s = t.tagName.toLowerCase(), n = {
        tag_name: s
    };
    $e444d6404c095fa5$var$qi.indexOf(s) > -1 && !e && ("a" === s.toLowerCase() || "button" === s.toLowerCase() ? n.$el_text = $e444d6404c095fa5$var$be(1024, $e444d6404c095fa5$var$se(t)) : n.$el_text = $e444d6404c095fa5$var$be(1024, $e444d6404c095fa5$var$Ui(t)));
    var o = $e444d6404c095fa5$var$Li(t);
    o.length > 0 && (n.classes = o.filter(function(t) {
        return "" !== t;
    })), $e444d6404c095fa5$var$Ct(t.attributes, function(e) {
        var s;
        if ((!$e444d6404c095fa5$var$Yi(t) || -1 !== [
            "name",
            "id",
            "class",
            "aria-label"
        ].indexOf(e.name)) && (null == r || !r.includes(e.name)) && !i && $e444d6404c095fa5$var$re(e.value) && (s = e.name, !$e444d6404c095fa5$var$M(s) || "_ngcontent" !== s.substring(0, 10) && "_nghost" !== s.substring(0, 7))) {
            var o = e.value;
            "class" === e.name && (o = $e444d6404c095fa5$var$Di(o).join(" ")), n["attr__" + e.name] = $e444d6404c095fa5$var$be(1024, o);
        }
    });
    for(var a = 1, l = 1, u = t; u = $e444d6404c095fa5$var$we(u);)a++, u.tagName === t.tagName && l++;
    return n.nth_child = a, n.nth_of_type = l, n;
}
function $e444d6404c095fa5$var$ke(i, e) {
    for(var r, s, { e: n, maskAllElementAttributes: o, maskAllText: a, elementAttributeIgnoreList: l, elementsChainAsString: u } = e, h = [
        i
    ], d = i; d.parentNode && !$e444d6404c095fa5$var$Oi(d, "body");)$e444d6404c095fa5$var$Ai(d.parentNode) ? (h.push(d.parentNode.host), d = d.parentNode.host) : (h.push(d.parentNode), d = d.parentNode);
    var v, c = [], f = {}, p = !1, g = !1;
    if ($e444d6404c095fa5$var$Ct(h, (t)=>{
        var i = $e444d6404c095fa5$var$Ki(t);
        "a" === t.tagName.toLowerCase() && (p = t.getAttribute("href"), p = i && p && $e444d6404c095fa5$var$re(p) && p), $e444d6404c095fa5$var$y($e444d6404c095fa5$var$Li(t), "ph-no-capture") && (g = !0), c.push($e444d6404c095fa5$var$Se(t, o, a, l));
        var e = function(t) {
            if (!$e444d6404c095fa5$var$Ki(t)) return {};
            var i = {};
            return $e444d6404c095fa5$var$Ct(t.attributes, function(t) {
                if (t.name && 0 === t.name.indexOf("data-ph-capture-attribute")) {
                    var e = t.name.replace("data-ph-capture-attribute-", ""), r = t.value;
                    e && r && $e444d6404c095fa5$var$re(r) && (i[e] = r);
                }
            }), i;
        }(t);
        $e444d6404c095fa5$var$Mt(f, e);
    }), g) return {
        props: {},
        explicitNoCapture: g
    };
    if (a || ("a" === i.tagName.toLowerCase() || "button" === i.tagName.toLowerCase() ? c[0].$el_text = $e444d6404c095fa5$var$se(i) : c[0].$el_text = $e444d6404c095fa5$var$Ui(i)), p) {
        var _, m;
        c[0].attr__href = p;
        var b = null == (_ = $e444d6404c095fa5$var$fe(p)) ? void 0 : _.host, w = null == $e444d6404c095fa5$var$t || null == (m = $e444d6404c095fa5$var$t.location) ? void 0 : m.host;
        b && w && b !== w && (v = p);
    }
    return {
        props: $e444d6404c095fa5$var$Mt({
            $event_type: n.type,
            $ce_version: 1
        }, u ? {} : {
            $elements: c
        }, {
            $elements_chain: $e444d6404c095fa5$var$oe(c)
        }, null != (r = c[0]) && r.$el_text ? {
            $el_text: null == (s = c[0]) ? void 0 : s.$el_text
        } : {}, v && "click" === n.type ? {
            $external_click_url: v
        } : {}, f)
    };
}
class $e444d6404c095fa5$var$$e {
    constructor(t){
        this.C = !1, this.M = null, this.rageclicks = new $e444d6404c095fa5$var$ue, this.O = !1, this.instance = t, this.F = null;
    }
    get A() {
        var t, i, e = $e444d6404c095fa5$var$R(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
        return e.url_allowlist = null == (t = e.url_allowlist) ? void 0 : t.map((t)=>new RegExp(t)), e.url_ignorelist = null == (i = e.url_ignorelist) ? void 0 : i.map((t)=>new RegExp(t)), e;
    }
    D() {
        if (this.isBrowserSupported()) {
            if ($e444d6404c095fa5$var$t && $e444d6404c095fa5$var$o) {
                var i = (i)=>{
                    i = i || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event);
                    try {
                        this.j(i);
                    } catch (t) {
                        $e444d6404c095fa5$var$ye.error("Failed to capture event", t);
                    }
                };
                if ($e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "submit", i, {
                    capture: !0
                }), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "change", i, {
                    capture: !0
                }), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "click", i, {
                    capture: !0
                }), this.A.capture_copied_text) {
                    var e = (i)=>{
                        i = i || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event), this.j(i, $e444d6404c095fa5$export$7bea938663611d9);
                    };
                    $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "copy", e, {
                        capture: !0
                    }), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "cut", e, {
                        capture: !0
                    });
                }
            }
        } else $e444d6404c095fa5$var$ye.info("Disabling Automatic Event Collection because this browser is not supported");
    }
    startIfEnabled() {
        this.isEnabled && !this.C && (this.D(), this.C = !0);
    }
    onRemoteConfig(t) {
        t.elementsChainAsString && (this.O = t.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({
            [$e444d6404c095fa5$var$Gt]: !!t.autocapture_opt_out
        }), this.M = !!t.autocapture_opt_out, this.startIfEnabled();
    }
    setElementSelectors(t) {
        this.F = t;
    }
    getElementSelectors(t) {
        var i, e = [];
        return null == (i = this.F) || i.forEach((i)=>{
            var r = null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.querySelectorAll(i);
            null == r || r.forEach((r)=>{
                t === r && e.push(i);
            });
        }), e;
    }
    get isEnabled() {
        var t, i, e = null == (t = this.instance.persistence) ? void 0 : t.props[$e444d6404c095fa5$var$Gt], r = this.M;
        if ($e444d6404c095fa5$var$F(r) && !$e444d6404c095fa5$var$j(e) && !this.instance.L()) return !1;
        var s = null !== (i = this.M) && void 0 !== i ? i : !!e;
        return !!this.instance.config.autocapture && !s;
    }
    j(i, e) {
        if (void 0 === e && (e = "$autocapture"), this.isEnabled) {
            var r, s = $e444d6404c095fa5$var$zi(i);
            if ($e444d6404c095fa5$var$Fi(s) && (s = s.parentNode || null), "$autocapture" === e && "click" === i.type && i instanceof MouseEvent) this.instance.config.rageclick && null != (r = this.rageclicks) && r.isRageClick(i.clientX, i.clientY, (new Date).getTime()) && function(i, e) {
                if (!$e444d6404c095fa5$var$t || $e444d6404c095fa5$var$Gi(i)) return !1;
                var r, s;
                if (!1 === (r = $e444d6404c095fa5$var$j(e) ? !!e && $e444d6404c095fa5$var$Wi : null !== (s = null == e ? void 0 : e.css_selector_ignorelist) && void 0 !== s ? s : $e444d6404c095fa5$var$Wi)) return !1;
                var { targetElementList: n } = $e444d6404c095fa5$var$Vi(i, !1);
                return !$e444d6404c095fa5$var$Bi(n, r);
            }(s, this.instance.config.rageclick) && this.j(i, "$rageclick");
            var n = e === $e444d6404c095fa5$export$7bea938663611d9;
            if (s && $e444d6404c095fa5$var$Ji(s, i, this.A, n, n ? [
                "copy",
                "cut"
            ] : void 0)) {
                var { props: o, explicitNoCapture: a } = $e444d6404c095fa5$var$ke(s, {
                    e: i,
                    maskAllElementAttributes: this.instance.config.mask_all_element_attributes,
                    maskAllText: this.instance.config.mask_all_text,
                    elementAttributeIgnoreList: this.A.element_attribute_ignorelist,
                    elementsChainAsString: this.O
                });
                if (a) return !1;
                var l = this.getElementSelectors(s);
                if (l && l.length > 0 && (o.$element_selectors = l), e === $e444d6404c095fa5$export$7bea938663611d9) {
                    var u, h = $e444d6404c095fa5$var$Ni(null == $e444d6404c095fa5$var$t || null == (u = $e444d6404c095fa5$var$t.getSelection()) ? void 0 : u.toString()), d = i.type || "clipboard";
                    if (!h) return !1;
                    o.$selected_content = h, o.$copy_type = d;
                }
                return this.instance.capture(e, o), !0;
            }
        }
    }
    isBrowserSupported() {
        return $e444d6404c095fa5$var$I(null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.querySelectorAll);
    }
}
Math.trunc || (Math.trunc = function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
}), Number.isInteger || (Number.isInteger = function(t) {
    return $e444d6404c095fa5$var$D(t) && isFinite(t) && Math.floor(t) === t;
});
var $e444d6404c095fa5$var$xe = "0123456789abcdef";
class $e444d6404c095fa5$var$Ee {
    constructor(t){
        if (this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(t, i, e, r) {
        if (!Number.isInteger(t) || !Number.isInteger(i) || !Number.isInteger(e) || !Number.isInteger(r) || t < 0 || i < 0 || e < 0 || r < 0 || t > 0xffffffffffff || i > 4095 || e > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
        var s = new Uint8Array(16);
        return s[0] = t / Math.pow(2, 40), s[1] = t / Math.pow(2, 32), s[2] = t / Math.pow(2, 24), s[3] = t / Math.pow(2, 16), s[4] = t / Math.pow(2, 8), s[5] = t, s[6] = 112 | i >>> 8, s[7] = i, s[8] = 128 | e >>> 24, s[9] = e >>> 16, s[10] = e >>> 8, s[11] = e, s[12] = r >>> 24, s[13] = r >>> 16, s[14] = r >>> 8, s[15] = r, new $e444d6404c095fa5$var$Ee(s);
    }
    toString() {
        for(var t = "", i = 0; i < this.bytes.length; i++)t = t + $e444d6404c095fa5$var$xe.charAt(this.bytes[i] >>> 4) + $e444d6404c095fa5$var$xe.charAt(15 & this.bytes[i]), 3 !== i && 5 !== i && 7 !== i && 9 !== i || (t += "-");
        if (36 !== t.length) throw new Error("Invalid UUIDv7 was generated");
        return t;
    }
    clone() {
        return new $e444d6404c095fa5$var$Ee(this.bytes.slice(0));
    }
    equals(t) {
        return 0 === this.compareTo(t);
    }
    compareTo(t) {
        for(var i = 0; i < 16; i++){
            var e = this.bytes[i] - t.bytes[i];
            if (0 !== e) return Math.sign(e);
        }
        return 0;
    }
}
class $e444d6404c095fa5$var$Pe {
    constructor(){
        this.N = 0, this.U = 0, this.q = new $e444d6404c095fa5$var$Te;
    }
    generate() {
        var t = this.generateOrAbort();
        if ($e444d6404c095fa5$var$C(t)) {
            this.N = 0;
            var i = this.generateOrAbort();
            if ($e444d6404c095fa5$var$C(i)) throw new Error("Could not generate UUID after timestamp reset");
            return i;
        }
        return t;
    }
    generateOrAbort() {
        var t = Date.now();
        if (t > this.N) this.N = t, this.B();
        else {
            if (!(t + 1e4 > this.N)) return;
            this.U++, this.U > 4398046511103 && (this.N++, this.B());
        }
        return $e444d6404c095fa5$var$Ee.fromFieldsV7(this.N, Math.trunc(this.U / Math.pow(2, 30)), this.U & Math.pow(2, 30) - 1, this.q.nextUint32());
    }
    B() {
        this.U = 1024 * this.q.nextUint32() + (1023 & this.q.nextUint32());
    }
}
var $e444d6404c095fa5$var$Ie, $e444d6404c095fa5$var$Re = (t)=>{
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var i = 0; i < t.length; i++)t[i] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return t;
};
$e444d6404c095fa5$var$t && !$e444d6404c095fa5$var$C($e444d6404c095fa5$var$t.crypto) && crypto.getRandomValues && ($e444d6404c095fa5$var$Re = (t)=>crypto.getRandomValues(t));
class $e444d6404c095fa5$var$Te {
    constructor(){
        this.H = new Uint32Array(8), this.W = 1 / 0;
    }
    nextUint32() {
        return this.W >= this.H.length && ($e444d6404c095fa5$var$Re(this.H), this.W = 0), this.H[this.W++];
    }
}
var $e444d6404c095fa5$var$Ce = ()=>$e444d6404c095fa5$var$Me().toString(), $e444d6404c095fa5$var$Me = ()=>($e444d6404c095fa5$var$Ie || ($e444d6404c095fa5$var$Ie = new $e444d6404c095fa5$var$Pe)).generate(), $e444d6404c095fa5$var$Oe = "";
var $e444d6404c095fa5$var$Fe = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function $e444d6404c095fa5$var$Ae(t, i) {
    if (i) {
        var e = function(t, i) {
            if (void 0 === i && (i = $e444d6404c095fa5$var$o), $e444d6404c095fa5$var$Oe) return $e444d6404c095fa5$var$Oe;
            if (!i) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(t)) return "";
            for(var e = t.split("."), r = Math.min(e.length, 8), s = "dmn_chk_" + $e444d6404c095fa5$var$Ce(); !$e444d6404c095fa5$var$Oe && r--;){
                var n = e.slice(r).join("."), a = s + "=1;domain=." + n + ";path=/";
                i.cookie = a + ";max-age=3", i.cookie.includes(s) && (i.cookie = a + ";max-age=0", $e444d6404c095fa5$var$Oe = n);
            }
            return $e444d6404c095fa5$var$Oe;
        }(t);
        if (!e) {
            var r = ((t)=>{
                var i = t.match($e444d6404c095fa5$var$Fe);
                return i ? i[0] : "";
            })(t);
            r !== e && $e444d6404c095fa5$var$xt.info("Warning: cookie subdomain discovery mismatch", r, e), e = r;
        }
        return e ? "; domain=." + e : "";
    }
    return "";
}
var $e444d6404c095fa5$var$De = {
    G: ()=>!!$e444d6404c095fa5$var$o,
    V: function(t) {
        $e444d6404c095fa5$var$xt.error("cookieStore error: " + t);
    },
    J: function(t) {
        if ($e444d6404c095fa5$var$o) {
            try {
                for(var i = t + "=", e = $e444d6404c095fa5$var$o.cookie.split(";").filter((t)=>t.length), r = 0; r < e.length; r++){
                    for(var s = e[r]; " " == s.charAt(0);)s = s.substring(1, s.length);
                    if (0 === s.indexOf(i)) return decodeURIComponent(s.substring(i.length, s.length));
                }
            } catch (t) {}
            return null;
        }
    },
    K: function(t) {
        var i;
        try {
            i = JSON.parse($e444d6404c095fa5$var$De.J(t)) || {};
        } catch (t) {}
        return i;
    },
    Y: function(t, i, e, r, s) {
        if ($e444d6404c095fa5$var$o) try {
            var n = "", a = "", l = $e444d6404c095fa5$var$Ae($e444d6404c095fa5$var$o.location.hostname, r);
            if (e) {
                var u = new Date;
                u.setTime(u.getTime() + 24 * e * 3600000), n = "; expires=" + u.toUTCString();
            }
            s && (a = "; secure");
            var h = t + "=" + encodeURIComponent(JSON.stringify(i)) + n + "; SameSite=Lax; path=/" + l + a;
            return h.length > 3686.4 && $e444d6404c095fa5$var$xt.warn("cookieStore warning: large cookie, len=" + h.length), $e444d6404c095fa5$var$o.cookie = h, h;
        } catch (t) {
            return;
        }
    },
    X: function(t, i) {
        if (null != $e444d6404c095fa5$var$o && $e444d6404c095fa5$var$o.cookie) try {
            $e444d6404c095fa5$var$De.Y(t, "", -1, i);
        } catch (t) {
            return;
        }
    }
}, $e444d6404c095fa5$var$je = null, $e444d6404c095fa5$var$Le = {
    G: function() {
        if (!$e444d6404c095fa5$var$F($e444d6404c095fa5$var$je)) return $e444d6404c095fa5$var$je;
        var i = !0;
        if ($e444d6404c095fa5$var$C($e444d6404c095fa5$var$t)) i = !1;
        else try {
            var e = "__mplssupport__";
            $e444d6404c095fa5$var$Le.Y(e, "xyz"), '"xyz"' !== $e444d6404c095fa5$var$Le.J(e) && (i = !1), $e444d6404c095fa5$var$Le.X(e);
        } catch (t) {
            i = !1;
        }
        return i || $e444d6404c095fa5$var$xt.error("localStorage unsupported; falling back to cookie store"), $e444d6404c095fa5$var$je = i, i;
    },
    V: function(t) {
        $e444d6404c095fa5$var$xt.error("localStorage error: " + t);
    },
    J: function(i) {
        try {
            return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.localStorage.getItem(i);
        } catch (t) {
            $e444d6404c095fa5$var$Le.V(t);
        }
        return null;
    },
    K: function(t) {
        try {
            return JSON.parse($e444d6404c095fa5$var$Le.J(t)) || {};
        } catch (t) {}
        return null;
    },
    Y: function(i, e) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.localStorage.setItem(i, JSON.stringify(e));
        } catch (t) {
            $e444d6404c095fa5$var$Le.V(t);
        }
    },
    X: function(i) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.localStorage.removeItem(i);
        } catch (t) {
            $e444d6404c095fa5$var$Le.V(t);
        }
    }
}, $e444d6404c095fa5$var$Ne = [
    "distinct_id",
    $e444d6404c095fa5$var$ui,
    $e444d6404c095fa5$var$hi,
    $e444d6404c095fa5$var$Pi,
    $e444d6404c095fa5$var$Ei
], $e444d6404c095fa5$var$Ue = $e444d6404c095fa5$var$g({}, $e444d6404c095fa5$var$Le, {
    K: function(t) {
        try {
            var i = {};
            try {
                i = $e444d6404c095fa5$var$De.K(t) || {};
            } catch (t) {}
            var e = $e444d6404c095fa5$var$Mt(i, JSON.parse($e444d6404c095fa5$var$Le.J(t) || "{}"));
            return $e444d6404c095fa5$var$Le.Y(t, e), e;
        } catch (t) {}
        return null;
    },
    Y: function(t, i, e, r, s, n) {
        try {
            $e444d6404c095fa5$var$Le.Y(t, i, void 0, void 0, n);
            var o = {};
            $e444d6404c095fa5$var$Ne.forEach((t)=>{
                i[t] && (o[t] = i[t]);
            }), Object.keys(o).length && $e444d6404c095fa5$var$De.Y(t, o, e, r, s, n);
        } catch (t) {
            $e444d6404c095fa5$var$Le.V(t);
        }
    },
    X: function(i, e) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.localStorage.removeItem(i), $e444d6404c095fa5$var$De.X(i, e);
        } catch (t) {
            $e444d6404c095fa5$var$Le.V(t);
        }
    }
}), $e444d6404c095fa5$var$ze = {}, $e444d6404c095fa5$var$qe = {
    G: function() {
        return !0;
    },
    V: function(t) {
        $e444d6404c095fa5$var$xt.error("memoryStorage error: " + t);
    },
    J: function(t) {
        return $e444d6404c095fa5$var$ze[t] || null;
    },
    K: function(t) {
        return $e444d6404c095fa5$var$ze[t] || null;
    },
    Y: function(t, i) {
        $e444d6404c095fa5$var$ze[t] = i;
    },
    X: function(t) {
        delete $e444d6404c095fa5$var$ze[t];
    }
}, $e444d6404c095fa5$var$Be = null, $e444d6404c095fa5$var$He = {
    G: function() {
        if (!$e444d6404c095fa5$var$F($e444d6404c095fa5$var$Be)) return $e444d6404c095fa5$var$Be;
        if ($e444d6404c095fa5$var$Be = !0, $e444d6404c095fa5$var$C($e444d6404c095fa5$var$t)) $e444d6404c095fa5$var$Be = !1;
        else try {
            var i = "__support__";
            $e444d6404c095fa5$var$He.Y(i, "xyz"), '"xyz"' !== $e444d6404c095fa5$var$He.J(i) && ($e444d6404c095fa5$var$Be = !1), $e444d6404c095fa5$var$He.X(i);
        } catch (t) {
            $e444d6404c095fa5$var$Be = !1;
        }
        return $e444d6404c095fa5$var$Be;
    },
    V: function(t) {
        $e444d6404c095fa5$var$xt.error("sessionStorage error: ", t);
    },
    J: function(i) {
        try {
            return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.sessionStorage.getItem(i);
        } catch (t) {
            $e444d6404c095fa5$var$He.V(t);
        }
        return null;
    },
    K: function(t) {
        try {
            return JSON.parse($e444d6404c095fa5$var$He.J(t)) || null;
        } catch (t) {}
        return null;
    },
    Y: function(i, e) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.sessionStorage.setItem(i, JSON.stringify(e));
        } catch (t) {
            $e444d6404c095fa5$var$He.V(t);
        }
    },
    X: function(i) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.sessionStorage.removeItem(i);
        } catch (t) {
            $e444d6404c095fa5$var$He.V(t);
        }
    }
}, $e444d6404c095fa5$var$We = function(t) {
    return t[t.PENDING = -1] = "PENDING", t[t.DENIED = 0] = "DENIED", t[t.GRANTED = 1] = "GRANTED", t;
}({});
class $e444d6404c095fa5$var$Ge {
    constructor(t){
        this._instance = t;
    }
    get A() {
        return this._instance.config;
    }
    get consent() {
        return this.Z() ? $e444d6404c095fa5$var$We.DENIED : this.tt;
    }
    isOptedOut() {
        return "always" === this.A.cookieless_mode || this.consent === $e444d6404c095fa5$var$We.DENIED || this.consent === $e444d6404c095fa5$var$We.PENDING && (this.A.opt_out_capturing_by_default || "on_reject" === this.A.cookieless_mode);
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    isExplicitlyOptedOut() {
        return this.consent === $e444d6404c095fa5$var$We.DENIED;
    }
    optInOut(t) {
        this.it.Y(this.et, t ? 1 : 0, this.A.cookie_expiration, this.A.cross_subdomain_cookie, this.A.secure_cookie);
    }
    reset() {
        this.it.X(this.et, this.A.cross_subdomain_cookie);
    }
    get et() {
        var { token: t, opt_out_capturing_cookie_prefix: i, consent_persistence_name: e } = this._instance.config;
        return e || (i ? i + t : "__ph_opt_in_out_" + t);
    }
    get tt() {
        var t = this.it.J(this.et);
        return $e444d6404c095fa5$var$H(t) ? $e444d6404c095fa5$var$We.GRANTED : $e444d6404c095fa5$var$y($e444d6404c095fa5$var$W, t) ? $e444d6404c095fa5$var$We.DENIED : $e444d6404c095fa5$var$We.PENDING;
    }
    get it() {
        if (!this.rt) {
            var t = this.A.opt_out_capturing_persistence_type;
            this.rt = "localStorage" === t ? $e444d6404c095fa5$var$Le : $e444d6404c095fa5$var$De;
            var i = "localStorage" === t ? $e444d6404c095fa5$var$De : $e444d6404c095fa5$var$Le;
            i.J(this.et) && (this.rt.J(this.et) || this.optInOut($e444d6404c095fa5$var$H(i.J(this.et))), i.X(this.et, this.A.cross_subdomain_cookie));
        }
        return this.rt;
    }
    Z() {
        return !!this.A.respect_dnt && !!$e444d6404c095fa5$var$zt([
            null == $e444d6404c095fa5$var$n ? void 0 : $e444d6404c095fa5$var$n.doNotTrack,
            null == $e444d6404c095fa5$var$n ? void 0 : $e444d6404c095fa5$var$n.msDoNotTrack,
            $e444d6404c095fa5$var$v.doNotTrack
        ], (t)=>$e444d6404c095fa5$var$H(t));
    }
}
var $e444d6404c095fa5$var$Ve = $e444d6404c095fa5$var$Et("[Dead Clicks]"), $e444d6404c095fa5$var$Je = ()=>!0, $e444d6404c095fa5$var$Ke = (t)=>{
    var i, e = !(null == (i = t.instance.persistence) || !i.get_property($e444d6404c095fa5$var$Qt)), r = t.instance.config.capture_dead_clicks;
    return $e444d6404c095fa5$var$j(r) ? r : e;
};
class $e444d6404c095fa5$var$Ye {
    get lazyLoadedDeadClicksAutocapture() {
        return this.st;
    }
    constructor(t, i, e){
        this.instance = t, this.isEnabled = i, this.onCapture = e, this.startIfEnabled();
    }
    onRemoteConfig(t) {
        this.instance.persistence && this.instance.persistence.register({
            [$e444d6404c095fa5$var$Qt]: null == t ? void 0 : t.captureDeadClicks
        }), this.startIfEnabled();
    }
    startIfEnabled() {
        this.isEnabled(this) && this.nt(()=>{
            this.ot();
        });
    }
    nt(t) {
        var i, e;
        null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.initDeadClicksAutocapture && t(), null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.instance, "dead-clicks-autocapture", (i)=>{
            i ? $e444d6404c095fa5$var$Ve.error("failed to load script", i) : t();
        });
    }
    ot() {
        var t;
        if ($e444d6404c095fa5$var$o) {
            if (!this.st && null != (t = $e444d6404c095fa5$var$v.__PosthogExtensions__) && t.initDeadClicksAutocapture) {
                var i = $e444d6404c095fa5$var$R(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
                i.__onCapture = this.onCapture, this.st = $e444d6404c095fa5$var$v.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, i), this.st.start($e444d6404c095fa5$var$o), $e444d6404c095fa5$var$Ve.info("starting...");
            }
        } else $e444d6404c095fa5$var$Ve.error("`document` not found. Cannot start.");
    }
    stop() {
        this.st && (this.st.stop(), this.st = void 0, $e444d6404c095fa5$var$Ve.info("stopping..."));
    }
}
var $e444d6404c095fa5$var$Xe = $e444d6404c095fa5$var$Et("[ExceptionAutocapture]");
class $e444d6404c095fa5$var$Qe {
    constructor(i){
        var e, r, s;
        this.lt = ()=>{
            var i;
            if ($e444d6404c095fa5$var$t && this.isEnabled && null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.errorWrappingFunctions) {
                var e = $e444d6404c095fa5$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, r = $e444d6404c095fa5$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, s = $e444d6404c095fa5$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
                try {
                    !this.ut && this.A.capture_unhandled_errors && (this.ut = e(this.captureException.bind(this))), !this.ht && this.A.capture_unhandled_rejections && (this.ht = r(this.captureException.bind(this))), !this.dt && this.A.capture_console_errors && (this.dt = s(this.captureException.bind(this)));
                } catch (t) {
                    $e444d6404c095fa5$var$Xe.error("failed to start", t), this.vt();
                }
            }
        }, this._instance = i, this.ct = !(null == (e = this._instance.persistence) || !e.props[$e444d6404c095fa5$var$Jt]), this.A = this.ft(), this.gt = new $e444d6404c095fa5$var$V({
            refillRate: null !== (r = this._instance.config.error_tracking.__exceptionRateLimiterRefillRate) && void 0 !== r ? r : 1,
            bucketSize: null !== (s = this._instance.config.error_tracking.__exceptionRateLimiterBucketSize) && void 0 !== s ? s : 10,
            refillInterval: 1e4,
            P: $e444d6404c095fa5$var$Xe
        }), this.startIfEnabled();
    }
    ft() {
        var t = this._instance.config.capture_exceptions, i = {
            capture_unhandled_errors: !1,
            capture_unhandled_rejections: !1,
            capture_console_errors: !1
        };
        return $e444d6404c095fa5$var$R(t) ? i = $e444d6404c095fa5$var$g({}, i, t) : ($e444d6404c095fa5$var$C(t) ? this.ct : t) && (i = $e444d6404c095fa5$var$g({}, i, {
            capture_unhandled_errors: !0,
            capture_unhandled_rejections: !0
        })), i;
    }
    get isEnabled() {
        return this.A.capture_console_errors || this.A.capture_unhandled_errors || this.A.capture_unhandled_rejections;
    }
    startIfEnabled() {
        this.isEnabled && ($e444d6404c095fa5$var$Xe.info("enabled"), this.nt(this.lt));
    }
    nt(t) {
        var i, e;
        null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.errorWrappingFunctions && t(), null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "exception-autocapture", (i)=>{
            if (i) return $e444d6404c095fa5$var$Xe.error("failed to load script", i);
            t();
        });
    }
    vt() {
        var t, i, e;
        null == (t = this.ut) || t.call(this), this.ut = void 0, null == (i = this.ht) || i.call(this), this.ht = void 0, null == (e = this.dt) || e.call(this), this.dt = void 0;
    }
    onRemoteConfig(t) {
        var i = t.autocaptureExceptions;
        this.ct = !!i || !1, this.A = this.ft(), this._instance.persistence && this._instance.persistence.register({
            [$e444d6404c095fa5$var$Jt]: this.ct
        }), this.startIfEnabled();
    }
    captureException(t) {
        var i, e, r = null !== (i = null == t || null == (e = t.$exception_list) || null == (e = e[0]) ? void 0 : e.type) && void 0 !== i ? i : "Exception";
        this.gt.consumeRateLimit(r) ? $e444d6404c095fa5$var$Xe.info("Skipping exception capture because of client rate limiting.", {
            exception: r
        }) : this._instance.exceptions.sendExceptionEvent(t);
    }
}
function $e444d6404c095fa5$var$Ze(t, i, e) {
    try {
        if (!(i in t)) return ()=>{};
        var r = t[i], s = e(r);
        return $e444d6404c095fa5$var$I(s) && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
            __posthog_wrapped__: {
                enumerable: !1,
                value: !0
            }
        })), t[i] = s, ()=>{
            t[i] = r;
        };
    } catch (t) {
        return ()=>{};
    }
}
class $e444d6404c095fa5$var$tr {
    constructor(i){
        var e;
        this._instance = i, this._t = (null == $e444d6404c095fa5$var$t || null == (e = $e444d6404c095fa5$var$t.location) ? void 0 : e.pathname) || "";
    }
    get isEnabled() {
        return "history_change" === this._instance.config.capture_pageview;
    }
    startIfEnabled() {
        this.isEnabled && ($e444d6404c095fa5$var$xt.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
    }
    stop() {
        this.yt && this.yt(), this.yt = void 0, $e444d6404c095fa5$var$xt.info("History API monitoring stopped");
    }
    monitorHistoryChanges() {
        var i, e;
        if ($e444d6404c095fa5$var$t && $e444d6404c095fa5$var$t.history) {
            var r = this;
            null != (i = $e444d6404c095fa5$var$t.history.pushState) && i.__posthog_wrapped__ || $e444d6404c095fa5$var$Ze($e444d6404c095fa5$var$t.history, "pushState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r.bt("pushState");
                }), null != (e = $e444d6404c095fa5$var$t.history.replaceState) && e.__posthog_wrapped__ || $e444d6404c095fa5$var$Ze($e444d6404c095fa5$var$t.history, "replaceState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r.bt("replaceState");
                }), this.wt();
        }
    }
    bt(i) {
        try {
            var e, r = null == $e444d6404c095fa5$var$t || null == (e = $e444d6404c095fa5$var$t.location) ? void 0 : e.pathname;
            if (!r) return;
            r !== this._t && this.isEnabled && this._instance.capture("$pageview", {
                navigation_type: i
            }), this._t = r;
        } catch (t) {
            $e444d6404c095fa5$var$xt.error("Error capturing " + i + " pageview", t);
        }
    }
    wt() {
        if (!this.yt) {
            var i = ()=>{
                this.bt("popstate");
            };
            $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "popstate", i), this.yt = ()=>{
                $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$t.removeEventListener("popstate", i);
            };
        }
    }
}
function $e444d6404c095fa5$var$ir(t) {
    var i, e;
    return (null == (i = JSON.stringify(t, (e = [], function(t, i) {
        if ($e444d6404c095fa5$var$R(i)) {
            for(; e.length > 0 && e[e.length - 1] !== this;)e.pop();
            return e.includes(i) ? "[Circular]" : (e.push(i), i);
        }
        return i;
    }))) ? void 0 : i.length) || 0;
}
function $e444d6404c095fa5$var$er(t, i) {
    if (void 0 === i && (i = 6606028.8), t.size >= i && t.data.length > 1) {
        var e = Math.floor(t.data.length / 2), r = t.data.slice(0, e), s = t.data.slice(e);
        return [
            $e444d6404c095fa5$var$er({
                size: $e444d6404c095fa5$var$ir(r),
                data: r,
                sessionId: t.sessionId,
                windowId: t.windowId
            }),
            $e444d6404c095fa5$var$er({
                size: $e444d6404c095fa5$var$ir(s),
                data: s,
                sessionId: t.sessionId,
                windowId: t.windowId
            })
        ].flatMap((t)=>t);
    }
    return [
        t
    ];
}
var $e444d6404c095fa5$var$rr = ((t)=>(t[t.DomContentLoaded = 0] = "DomContentLoaded", t[t.Load = 1] = "Load", t[t.FullSnapshot = 2] = "FullSnapshot", t[t.IncrementalSnapshot = 3] = "IncrementalSnapshot", t[t.Meta = 4] = "Meta", t[t.Custom = 5] = "Custom", t[t.Plugin = 6] = "Plugin", t))($e444d6404c095fa5$var$rr || {}), $e444d6404c095fa5$var$sr = ((t)=>(t[t.Mutation = 0] = "Mutation", t[t.MouseMove = 1] = "MouseMove", t[t.MouseInteraction = 2] = "MouseInteraction", t[t.Scroll = 3] = "Scroll", t[t.ViewportResize = 4] = "ViewportResize", t[t.Input = 5] = "Input", t[t.TouchMove = 6] = "TouchMove", t[t.MediaInteraction = 7] = "MediaInteraction", t[t.StyleSheetRule = 8] = "StyleSheetRule", t[t.CanvasMutation = 9] = "CanvasMutation", t[t.Font = 10] = "Font", t[t.Log = 11] = "Log", t[t.Drag = 12] = "Drag", t[t.StyleDeclaration = 13] = "StyleDeclaration", t[t.Selection = 14] = "Selection", t[t.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", t[t.CustomElement = 16] = "CustomElement", t))($e444d6404c095fa5$var$sr || {}), $e444d6404c095fa5$var$nr = "[SessionRecording]", $e444d6404c095fa5$var$or = "redacted", $e444d6404c095fa5$var$ar = {
    initiatorTypes: [
        "audio",
        "beacon",
        "body",
        "css",
        "early-hint",
        "embed",
        "fetch",
        "frame",
        "iframe",
        "icon",
        "image",
        "img",
        "input",
        "link",
        "navigation",
        "object",
        "ping",
        "script",
        "track",
        "video",
        "xmlhttprequest"
    ],
    maskRequestFn: (t)=>t,
    recordHeaders: !1,
    recordBody: !1,
    recordInitialRequests: !1,
    recordPerformance: !1,
    performanceEntryTypeToObserve: [
        "first-input",
        "navigation",
        "paint",
        "resource"
    ],
    payloadSizeLimitBytes: 1e6,
    payloadHostDenyList: [
        ".lr-ingest.io",
        ".ingest.sentry.io",
        ".clarity.ms",
        "analytics.google.com",
        "bam.nr-data.net"
    ]
}, $e444d6404c095fa5$var$lr = [
    "authorization",
    "x-forwarded-for",
    "authorization",
    "cookie",
    "set-cookie",
    "x-api-key",
    "x-real-ip",
    "remote-addr",
    "forwarded",
    "proxy-authorization",
    "x-csrf-token",
    "x-csrftoken",
    "x-xsrf-token"
], $e444d6404c095fa5$var$ur = [
    "password",
    "secret",
    "passwd",
    "api_key",
    "apikey",
    "auth",
    "credentials",
    "mysql_pwd",
    "privatekey",
    "private_key",
    "token"
], $e444d6404c095fa5$var$hr = [
    "/s/",
    "/e/",
    "/i/"
];
function $e444d6404c095fa5$var$dr(t, i, e, r) {
    if ($e444d6404c095fa5$var$A(t)) return t;
    var s = (null == i ? void 0 : i["content-length"]) || function(t) {
        return new Blob([
            t
        ]).size;
    }(t);
    return $e444d6404c095fa5$var$M(s) && (s = parseInt(s)), s > e ? $e444d6404c095fa5$var$nr + " " + r + " body too large to record (" + s + " bytes)" : t;
}
function $e444d6404c095fa5$var$vr(t, i) {
    if ($e444d6404c095fa5$var$A(t)) return t;
    var e = t;
    return $e444d6404c095fa5$var$re(e, !1) || (e = $e444d6404c095fa5$var$nr + " " + i + " body " + $e444d6404c095fa5$var$or), $e444d6404c095fa5$var$Ct($e444d6404c095fa5$var$ur, (t)=>{
        var r, s;
        null != (r = e) && r.length && -1 !== (null == (s = e) ? void 0 : s.indexOf(t)) && (e = $e444d6404c095fa5$var$nr + " " + i + " body " + $e444d6404c095fa5$var$or + " as might contain: " + t);
    }), e;
}
var $e444d6404c095fa5$var$cr = (t, i)=>{
    var e, r, s, n = {
        payloadSizeLimitBytes: $e444d6404c095fa5$var$ar.payloadSizeLimitBytes,
        performanceEntryTypeToObserve: [
            ...$e444d6404c095fa5$var$ar.performanceEntryTypeToObserve
        ],
        payloadHostDenyList: [
            ...i.payloadHostDenyList || [],
            ...$e444d6404c095fa5$var$ar.payloadHostDenyList
        ]
    }, o = !1 !== t.session_recording.recordHeaders && i.recordHeaders, a = !1 !== t.session_recording.recordBody && i.recordBody, l = !1 !== t.capture_performance && i.recordPerformance, u = (e = n, s = Math.min(1e6, null !== (r = e.payloadSizeLimitBytes) && void 0 !== r ? r : 1e6), (t)=>(null != t && t.requestBody && (t.requestBody = $e444d6404c095fa5$var$dr(t.requestBody, t.requestHeaders, s, "Request")), null != t && t.responseBody && (t.responseBody = $e444d6404c095fa5$var$dr(t.responseBody, t.responseHeaders, s, "Response")), t)), h = (i)=>{
        var e, r;
        return u(((t, i)=>{
            var e, r = $e444d6404c095fa5$var$fe(t.name), s = 0 === i.indexOf("http") ? null == (e = $e444d6404c095fa5$var$fe(i)) ? void 0 : e.pathname : i;
            "/" === s && (s = "");
            var n = null == r ? void 0 : r.pathname.replace(s || "", "");
            if (!(r && n && $e444d6404c095fa5$var$hr.some((t)=>0 === n.indexOf(t)))) return t;
        })((r = (e = i).requestHeaders, $e444d6404c095fa5$var$A(r) || $e444d6404c095fa5$var$Ct(Object.keys(null != r ? r : {}), (t)=>{
            $e444d6404c095fa5$var$lr.includes(t.toLowerCase()) && (r[t] = $e444d6404c095fa5$var$or);
        }), e), t.api_host));
    }, d = $e444d6404c095fa5$var$I(t.session_recording.maskNetworkRequestFn);
    return d && $e444d6404c095fa5$var$I(t.session_recording.maskCapturedNetworkRequestFn) && $e444d6404c095fa5$var$xt.warn("Both `maskNetworkRequestFn` and `maskCapturedNetworkRequestFn` are defined. `maskNetworkRequestFn` will be ignored."), d && (t.session_recording.maskCapturedNetworkRequestFn = (i)=>{
        var e = t.session_recording.maskNetworkRequestFn({
            url: i.name
        });
        return $e444d6404c095fa5$var$g({}, i, {
            name: null == e ? void 0 : e.url
        });
    }), n.maskRequestFn = $e444d6404c095fa5$var$I(t.session_recording.maskCapturedNetworkRequestFn) ? (i)=>{
        var e, r = h(i);
        return r && null !== (e = null == t.session_recording.maskCapturedNetworkRequestFn ? void 0 : t.session_recording.maskCapturedNetworkRequestFn(r)) && void 0 !== e ? e : void 0;
    } : (t)=>(function(t) {
            if (!$e444d6404c095fa5$var$C(t)) return t.requestBody = $e444d6404c095fa5$var$vr(t.requestBody, "Request"), t.responseBody = $e444d6404c095fa5$var$vr(t.responseBody, "Response"), t;
        })(h(t)), $e444d6404c095fa5$var$g({}, $e444d6404c095fa5$var$ar, n, {
        recordHeaders: o,
        recordBody: a,
        recordPerformance: l,
        recordInitialRequests: l
    });
};
class $e444d6404c095fa5$var$fr {
    constructor(t, i){
        var e, r;
        void 0 === i && (i = {}), this.St = {}, this.kt = (t)=>{
            if (!this.St[t]) {
                var i, e;
                this.St[t] = !0;
                var r = this.$t(t);
                null == (i = (e = this.t).onBlockedNode) || i.call(e, t, r);
            }
        }, this.xt = (t)=>{
            var i = this.$t(t);
            if ("svg" !== (null == i ? void 0 : i.nodeName) && i instanceof Element) {
                var e = i.closest("svg");
                if (e) return [
                    this._rrweb.mirror.getId(e),
                    e
                ];
            }
            return [
                t,
                i
            ];
        }, this.$t = (t)=>this._rrweb.mirror.getNode(t), this.Et = (t)=>{
            var i, e, r, s, n, o, a, l;
            return (null !== (i = null == (e = t.removes) ? void 0 : e.length) && void 0 !== i ? i : 0) + (null !== (r = null == (s = t.attributes) ? void 0 : s.length) && void 0 !== r ? r : 0) + (null !== (n = null == (o = t.texts) ? void 0 : o.length) && void 0 !== n ? n : 0) + (null !== (a = null == (l = t.adds) ? void 0 : l.length) && void 0 !== a ? a : 0);
        }, this.throttleMutations = (t)=>{
            if (3 !== t.type || 0 !== t.data.source) return t;
            var i = t.data, e = this.Et(i);
            i.attributes && (i.attributes = i.attributes.filter((t)=>{
                var [i] = this.xt(t.id);
                return !this.gt.consumeRateLimit(i) && t;
            }));
            var r = this.Et(i);
            return 0 !== r || e === r ? t : void 0;
        }, this._rrweb = t, this.t = i, this.gt = new $e444d6404c095fa5$var$V({
            bucketSize: null !== (e = this.t.bucketSize) && void 0 !== e ? e : 100,
            refillRate: null !== (r = this.t.refillRate) && void 0 !== r ? r : 10,
            refillInterval: 1e3,
            $: this.kt,
            P: $e444d6404c095fa5$var$xt
        });
    }
}
var $e444d6404c095fa5$var$pr = Uint8Array, $e444d6404c095fa5$var$gr = Uint16Array, $e444d6404c095fa5$var$_r = Uint32Array, $e444d6404c095fa5$var$mr = new $e444d6404c095fa5$var$pr([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $e444d6404c095fa5$var$yr = new $e444d6404c095fa5$var$pr([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $e444d6404c095fa5$var$br = new $e444d6404c095fa5$var$pr([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $e444d6404c095fa5$var$wr = function(t, i) {
    for(var e = new $e444d6404c095fa5$var$gr(31), r = 0; r < 31; ++r)e[r] = i += 1 << t[r - 1];
    var s = new $e444d6404c095fa5$var$_r(e[30]);
    for(r = 1; r < 30; ++r)for(var n = e[r]; n < e[r + 1]; ++n)s[n] = n - e[r] << 5 | r;
    return [
        e,
        s
    ];
}, $e444d6404c095fa5$var$Sr = $e444d6404c095fa5$var$wr($e444d6404c095fa5$var$mr, 2), $e444d6404c095fa5$var$kr = $e444d6404c095fa5$var$Sr[0], $e444d6404c095fa5$var$$r = $e444d6404c095fa5$var$Sr[1];
$e444d6404c095fa5$var$kr[28] = 258, $e444d6404c095fa5$var$$r[258] = 28;
for(var $e444d6404c095fa5$var$xr = $e444d6404c095fa5$var$wr($e444d6404c095fa5$var$yr, 0)[1], $e444d6404c095fa5$var$Er = new $e444d6404c095fa5$var$gr(32768), $e444d6404c095fa5$var$Pr = 0; $e444d6404c095fa5$var$Pr < 32768; ++$e444d6404c095fa5$var$Pr){
    var $e444d6404c095fa5$var$Ir = (43690 & $e444d6404c095fa5$var$Pr) >>> 1 | (21845 & $e444d6404c095fa5$var$Pr) << 1;
    $e444d6404c095fa5$var$Ir = (61680 & ($e444d6404c095fa5$var$Ir = (52428 & $e444d6404c095fa5$var$Ir) >>> 2 | (13107 & $e444d6404c095fa5$var$Ir) << 2)) >>> 4 | (3855 & $e444d6404c095fa5$var$Ir) << 4, $e444d6404c095fa5$var$Er[$e444d6404c095fa5$var$Pr] = ((65280 & $e444d6404c095fa5$var$Ir) >>> 8 | (255 & $e444d6404c095fa5$var$Ir) << 8) >>> 1;
}
var $e444d6404c095fa5$var$Rr = function(t, i, e) {
    for(var r = t.length, s = 0, n = new $e444d6404c095fa5$var$gr(i); s < r; ++s)++n[t[s] - 1];
    var o, a = new $e444d6404c095fa5$var$gr(i);
    for(s = 0; s < i; ++s)a[s] = a[s - 1] + n[s - 1] << 1;
    if (e) {
        o = new $e444d6404c095fa5$var$gr(1 << i);
        var l = 15 - i;
        for(s = 0; s < r; ++s)if (t[s]) for(var u = s << 4 | t[s], h = i - t[s], d = a[t[s] - 1]++ << h, v = d | (1 << h) - 1; d <= v; ++d)o[$e444d6404c095fa5$var$Er[d] >>> l] = u;
    } else for(o = new $e444d6404c095fa5$var$gr(r), s = 0; s < r; ++s)o[s] = $e444d6404c095fa5$var$Er[a[t[s] - 1]++] >>> 15 - t[s];
    return o;
}, $e444d6404c095fa5$var$Tr = new $e444d6404c095fa5$var$pr(288);
for($e444d6404c095fa5$var$Pr = 0; $e444d6404c095fa5$var$Pr < 144; ++$e444d6404c095fa5$var$Pr)$e444d6404c095fa5$var$Tr[$e444d6404c095fa5$var$Pr] = 8;
for($e444d6404c095fa5$var$Pr = 144; $e444d6404c095fa5$var$Pr < 256; ++$e444d6404c095fa5$var$Pr)$e444d6404c095fa5$var$Tr[$e444d6404c095fa5$var$Pr] = 9;
for($e444d6404c095fa5$var$Pr = 256; $e444d6404c095fa5$var$Pr < 280; ++$e444d6404c095fa5$var$Pr)$e444d6404c095fa5$var$Tr[$e444d6404c095fa5$var$Pr] = 7;
for($e444d6404c095fa5$var$Pr = 280; $e444d6404c095fa5$var$Pr < 288; ++$e444d6404c095fa5$var$Pr)$e444d6404c095fa5$var$Tr[$e444d6404c095fa5$var$Pr] = 8;
var $e444d6404c095fa5$var$Cr = new $e444d6404c095fa5$var$pr(32);
for($e444d6404c095fa5$var$Pr = 0; $e444d6404c095fa5$var$Pr < 32; ++$e444d6404c095fa5$var$Pr)$e444d6404c095fa5$var$Cr[$e444d6404c095fa5$var$Pr] = 5;
var $e444d6404c095fa5$var$Mr = $e444d6404c095fa5$var$Rr($e444d6404c095fa5$var$Tr, 9, 0), $e444d6404c095fa5$var$Or = $e444d6404c095fa5$var$Rr($e444d6404c095fa5$var$Cr, 5, 0), $e444d6404c095fa5$var$Fr = function(t) {
    return (t / 8 >> 0) + (7 & t && 1);
}, $e444d6404c095fa5$var$Ar = function(t, i, e) {
    (null == e || e > t.length) && (e = t.length);
    var r = new (t instanceof $e444d6404c095fa5$var$gr ? $e444d6404c095fa5$var$gr : t instanceof $e444d6404c095fa5$var$_r ? $e444d6404c095fa5$var$_r : $e444d6404c095fa5$var$pr)(e - i);
    return r.set(t.subarray(i, e)), r;
}, $e444d6404c095fa5$var$Dr = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8;
}, $e444d6404c095fa5$var$jr = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8, t[r + 2] |= e >>> 16;
}, $e444d6404c095fa5$var$Lr = function(t, i) {
    for(var e = [], r = 0; r < t.length; ++r)t[r] && e.push({
        s: r,
        f: t[r]
    });
    var s = e.length, n = e.slice();
    if (!s) return [
        new $e444d6404c095fa5$var$pr(0),
        0
    ];
    if (1 == s) {
        var o = new $e444d6404c095fa5$var$pr(e[0].s + 1);
        return o[e[0].s] = 1, [
            o,
            1
        ];
    }
    e.sort(function(t, i) {
        return t.f - i.f;
    }), e.push({
        s: -1,
        f: 25001
    });
    var a = e[0], l = e[1], u = 0, h = 1, d = 2;
    for(e[0] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    }; h != s - 1;)a = e[e[u].f < e[d].f ? u++ : d++], l = e[u != h && e[u].f < e[d].f ? u++ : d++], e[h++] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    };
    var v = n[0].s;
    for(r = 1; r < s; ++r)n[r].s > v && (v = n[r].s);
    var c = new $e444d6404c095fa5$var$gr(v + 1), f = $e444d6404c095fa5$var$Nr(e[h - 1], c, 0);
    if (f > i) {
        r = 0;
        var p = 0, g = f - i, _ = 1 << g;
        for(n.sort(function(t, i) {
            return c[i.s] - c[t.s] || t.f - i.f;
        }); r < s; ++r){
            var m = n[r].s;
            if (!(c[m] > i)) break;
            p += _ - (1 << f - c[m]), c[m] = i;
        }
        for(p >>>= g; p > 0;){
            var y = n[r].s;
            c[y] < i ? p -= 1 << i - c[y]++ - 1 : ++r;
        }
        for(; r >= 0 && p; --r){
            var b = n[r].s;
            c[b] == i && (--c[b], ++p);
        }
        f = i;
    }
    return [
        new $e444d6404c095fa5$var$pr(c),
        f
    ];
}, $e444d6404c095fa5$var$Nr = function(t, i, e) {
    return -1 == t.s ? Math.max($e444d6404c095fa5$var$Nr(t.l, i, e + 1), $e444d6404c095fa5$var$Nr(t.r, i, e + 1)) : i[t.s] = e;
}, $e444d6404c095fa5$var$Ur = function(t) {
    for(var i = t.length; i && !t[--i];);
    for(var e = new $e444d6404c095fa5$var$gr(++i), r = 0, s = t[0], n = 1, o = function(t) {
        e[r++] = t;
    }, a = 1; a <= i; ++a)if (t[a] == s && a != i) ++n;
    else {
        if (!s && n > 2) {
            for(; n > 138; n -= 138)o(32754);
            n > 2 && (o(n > 10 ? n - 11 << 5 | 28690 : n - 3 << 5 | 12305), n = 0);
        } else if (n > 3) {
            for(o(s), --n; n > 6; n -= 6)o(8304);
            n > 2 && (o(n - 3 << 5 | 8208), n = 0);
        }
        for(; n--;)o(s);
        n = 1, s = t[a];
    }
    return [
        e.subarray(0, r),
        i
    ];
}, $e444d6404c095fa5$var$zr = function(t, i) {
    for(var e = 0, r = 0; r < i.length; ++r)e += t[r] * i[r];
    return e;
}, $e444d6404c095fa5$var$qr = function(t, i, e) {
    var r = e.length, s = $e444d6404c095fa5$var$Fr(i + 2);
    t[s] = 255 & r, t[s + 1] = r >>> 8, t[s + 2] = 255 ^ t[s], t[s + 3] = 255 ^ t[s + 1];
    for(var n = 0; n < r; ++n)t[s + n + 4] = e[n];
    return 8 * (s + 4 + r);
}, $e444d6404c095fa5$var$Br = function(t, i, e, r, s, n, o, a, l, u, h) {
    $e444d6404c095fa5$var$Dr(i, h++, e), ++s[256];
    for(var d = $e444d6404c095fa5$var$Lr(s, 15), v = d[0], c = d[1], f = $e444d6404c095fa5$var$Lr(n, 15), p = f[0], g = f[1], _ = $e444d6404c095fa5$var$Ur(v), m = _[0], y = _[1], b = $e444d6404c095fa5$var$Ur(p), w = b[0], S = b[1], k = new $e444d6404c095fa5$var$gr(19), x = 0; x < m.length; ++x)k[31 & m[x]]++;
    for(x = 0; x < w.length; ++x)k[31 & w[x]]++;
    for(var E = $e444d6404c095fa5$var$Lr(k, 7), P = E[0], I = E[1], R = 19; R > 4 && !P[$e444d6404c095fa5$var$br[R - 1]]; --R);
    var T, C, M, O, F = u + 5 << 3, A = $e444d6404c095fa5$var$zr(s, $e444d6404c095fa5$var$Tr) + $e444d6404c095fa5$var$zr(n, $e444d6404c095fa5$var$Cr) + o, D = $e444d6404c095fa5$var$zr(s, v) + $e444d6404c095fa5$var$zr(n, p) + o + 14 + 3 * R + $e444d6404c095fa5$var$zr(k, P) + (2 * k[16] + 3 * k[17] + 7 * k[18]);
    if (F <= A && F <= D) return $e444d6404c095fa5$var$qr(i, h, t.subarray(l, l + u));
    if ($e444d6404c095fa5$var$Dr(i, h, 1 + (D < A)), h += 2, D < A) {
        T = $e444d6404c095fa5$var$Rr(v, c, 0), C = v, M = $e444d6404c095fa5$var$Rr(p, g, 0), O = p;
        var j = $e444d6404c095fa5$var$Rr(P, I, 0);
        $e444d6404c095fa5$var$Dr(i, h, y - 257), $e444d6404c095fa5$var$Dr(i, h + 5, S - 1), $e444d6404c095fa5$var$Dr(i, h + 10, R - 4), h += 14;
        for(x = 0; x < R; ++x)$e444d6404c095fa5$var$Dr(i, h + 3 * x, P[$e444d6404c095fa5$var$br[x]]);
        h += 3 * R;
        for(var L = [
            m,
            w
        ], N = 0; N < 2; ++N){
            var U = L[N];
            for(x = 0; x < U.length; ++x){
                var z = 31 & U[x];
                $e444d6404c095fa5$var$Dr(i, h, j[z]), h += P[z], z > 15 && ($e444d6404c095fa5$var$Dr(i, h, U[x] >>> 5 & 127), h += U[x] >>> 12);
            }
        }
    } else T = $e444d6404c095fa5$var$Mr, C = $e444d6404c095fa5$var$Tr, M = $e444d6404c095fa5$var$Or, O = $e444d6404c095fa5$var$Cr;
    for(x = 0; x < a; ++x)if (r[x] > 255) {
        z = r[x] >>> 18 & 31;
        $e444d6404c095fa5$var$jr(i, h, T[z + 257]), h += C[z + 257], z > 7 && ($e444d6404c095fa5$var$Dr(i, h, r[x] >>> 23 & 31), h += $e444d6404c095fa5$var$mr[z]);
        var q = 31 & r[x];
        $e444d6404c095fa5$var$jr(i, h, M[q]), h += O[q], q > 3 && ($e444d6404c095fa5$var$jr(i, h, r[x] >>> 5 & 8191), h += $e444d6404c095fa5$var$yr[q]);
    } else $e444d6404c095fa5$var$jr(i, h, T[r[x]]), h += C[r[x]];
    return $e444d6404c095fa5$var$jr(i, h, T[256]), h + C[256];
}, $e444d6404c095fa5$var$Hr = new $e444d6404c095fa5$var$_r([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $e444d6404c095fa5$var$Wr = function() {
    for(var t = new $e444d6404c095fa5$var$_r(256), i = 0; i < 256; ++i){
        for(var e = i, r = 9; --r;)e = (1 & e && 3988292384) ^ e >>> 1;
        t[i] = e;
    }
    return t;
}(), $e444d6404c095fa5$var$Gr = function() {
    var t = 4294967295;
    return {
        p: function(i) {
            for(var e = t, r = 0; r < i.length; ++r)e = $e444d6404c095fa5$var$Wr[255 & e ^ i[r]] ^ e >>> 8;
            t = e;
        },
        d: function() {
            return 4294967295 ^ t;
        }
    };
}, $e444d6404c095fa5$var$Vr = function(t, i, e, r, s) {
    return function(t, i, e, r, s, n) {
        var o = t.length, a = new $e444d6404c095fa5$var$pr(r + o + 5 * (1 + Math.floor(o / 7e3)) + s), l = a.subarray(r, a.length - s), u = 0;
        if (!i || o < 8) for(var h = 0; h <= o; h += 65535){
            var d = h + 65535;
            d < o ? u = $e444d6404c095fa5$var$qr(l, u, t.subarray(h, d)) : (l[h] = n, u = $e444d6404c095fa5$var$qr(l, u, t.subarray(h, o)));
        }
        else {
            for(var v = $e444d6404c095fa5$var$Hr[i - 1], c = v >>> 13, f = 8191 & v, p = (1 << e) - 1, g = new $e444d6404c095fa5$var$gr(32768), _ = new $e444d6404c095fa5$var$gr(p + 1), m = Math.ceil(e / 3), y = 2 * m, b = function(i) {
                return (t[i] ^ t[i + 1] << m ^ t[i + 2] << y) & p;
            }, w = new $e444d6404c095fa5$var$_r(25e3), S = new $e444d6404c095fa5$var$gr(288), k = new $e444d6404c095fa5$var$gr(32), x = 0, E = 0, P = (h = 0, 0), I = 0, R = 0; h < o; ++h){
                var T = b(h), C = 32767 & h, M = _[T];
                if (g[C] = M, _[T] = C, I <= h) {
                    var O = o - h;
                    if ((x > 7e3 || P > 24576) && O > 423) {
                        u = $e444d6404c095fa5$var$Br(t, l, 0, w, S, k, E, P, R, h - R, u), P = x = E = 0, R = h;
                        for(var F = 0; F < 286; ++F)S[F] = 0;
                        for(F = 0; F < 30; ++F)k[F] = 0;
                    }
                    var A = 2, D = 0, j = f, L = C - M & 32767;
                    if (O > 2 && T == b(h - L)) for(var N = Math.min(c, O) - 1, U = Math.min(32767, h), z = Math.min(258, O); L <= U && --j && C != M;){
                        if (t[h + A] == t[h + A - L]) {
                            for(var q = 0; q < z && t[h + q] == t[h + q - L]; ++q);
                            if (q > A) {
                                if (A = q, D = L, q > N) break;
                                var B = Math.min(L, q - 2), H = 0;
                                for(F = 0; F < B; ++F){
                                    var W = h - L + F + 32768 & 32767, G = W - g[W] + 32768 & 32767;
                                    G > H && (H = G, M = W);
                                }
                            }
                        }
                        L += (C = M) - (M = g[C]) + 32768 & 32767;
                    }
                    if (D) {
                        w[P++] = 268435456 | $e444d6404c095fa5$var$$r[A] << 18 | $e444d6404c095fa5$var$xr[D];
                        var V = 31 & $e444d6404c095fa5$var$$r[A], J = 31 & $e444d6404c095fa5$var$xr[D];
                        E += $e444d6404c095fa5$var$mr[V] + $e444d6404c095fa5$var$yr[J], ++S[257 + V], ++k[J], I = h + A, ++x;
                    } else w[P++] = t[h], ++S[t[h]];
                }
            }
            u = $e444d6404c095fa5$var$Br(t, l, n, w, S, k, E, P, R, h - R, u);
        }
        return $e444d6404c095fa5$var$Ar(a, 0, r + $e444d6404c095fa5$var$Fr(u) + s);
    }(t, null == i.level ? 6 : i.level, null == i.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(t.length)))) : 12 + i.mem, e, r, !0);
}, $e444d6404c095fa5$var$Jr = function(t, i, e) {
    for(; e; ++i)t[i] = e, e >>>= 8;
}, $e444d6404c095fa5$var$Kr = function(t, i) {
    var e = i.filename;
    if (t[0] = 31, t[1] = 139, t[2] = 8, t[8] = i.level < 2 ? 4 : 9 == i.level ? 2 : 0, t[9] = 3, 0 != i.mtime && $e444d6404c095fa5$var$Jr(t, 4, Math.floor(new Date(i.mtime || Date.now()) / 1e3)), e) {
        t[3] = 8;
        for(var r = 0; r <= e.length; ++r)t[r + 10] = e.charCodeAt(r);
    }
}, $e444d6404c095fa5$var$Yr = function(t) {
    return 10 + (t.filename && t.filename.length + 1 || 0);
};
function $e444d6404c095fa5$var$Xr(t, i) {
    void 0 === i && (i = {});
    var e = $e444d6404c095fa5$var$Gr(), r = t.length;
    e.p(t);
    var s = $e444d6404c095fa5$var$Vr(t, i, $e444d6404c095fa5$var$Yr(i), 8), n = s.length;
    return $e444d6404c095fa5$var$Kr(s, i), $e444d6404c095fa5$var$Jr(s, n - 8, e.d()), $e444d6404c095fa5$var$Jr(s, n - 4, r), s;
}
function $e444d6404c095fa5$var$Qr(t, i) {
    var e = t.length;
    if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t);
    for(var r = new $e444d6404c095fa5$var$pr(t.length + (t.length >>> 1)), s = 0, n = function(t) {
        r[s++] = t;
    }, o = 0; o < e; ++o){
        if (s + 5 > r.length) {
            var a = new $e444d6404c095fa5$var$pr(s + 8 + (e - o << 1));
            a.set(r), r = a;
        }
        var l = t.charCodeAt(o);
        l < 128 || i ? n(l) : l < 2048 ? (n(192 | l >>> 6), n(128 | 63 & l)) : l > 55295 && l < 57344 ? (n(240 | (l = 65536 + (1047552 & l) | 1023 & t.charCodeAt(++o)) >>> 18), n(128 | l >>> 12 & 63), n(128 | l >>> 6 & 63), n(128 | 63 & l)) : (n(224 | l >>> 12), n(128 | l >>> 6 & 63), n(128 | 63 & l));
    }
    return $e444d6404c095fa5$var$Ar(r, 0, s);
}
function $e444d6404c095fa5$var$Zr(t, i) {
    return function(t) {
        for(var i = 0, e = 0; e < t.length; e++)i = (i << 5) - i + t.charCodeAt(e), i |= 0;
        return Math.abs(i);
    }(t) % 100 < $e444d6404c095fa5$var$G(100 * i, 0, 100, $e444d6404c095fa5$var$xt);
}
var $e444d6404c095fa5$var$ts = "disabled", $e444d6404c095fa5$var$is = "sampled", $e444d6404c095fa5$var$es = "active", $e444d6404c095fa5$var$rs = "buffering", $e444d6404c095fa5$var$ss = "paused", $e444d6404c095fa5$var$ns = "trigger", $e444d6404c095fa5$var$os = $e444d6404c095fa5$var$ns + "_activated", $e444d6404c095fa5$var$as = $e444d6404c095fa5$var$ns + "_pending", $e444d6404c095fa5$var$ls = $e444d6404c095fa5$var$ns + "_" + $e444d6404c095fa5$var$ts;
function $e444d6404c095fa5$var$us(t, i) {
    return i.some((i)=>"regex" === i.matching && new RegExp(i.url).test(t));
}
class $e444d6404c095fa5$var$hs {
    constructor(t){
        this.Pt = t;
    }
    triggerStatus(t) {
        var i = this.Pt.map((i)=>i.triggerStatus(t));
        return i.includes($e444d6404c095fa5$var$os) ? $e444d6404c095fa5$var$os : i.includes($e444d6404c095fa5$var$as) ? $e444d6404c095fa5$var$as : $e444d6404c095fa5$var$ls;
    }
    stop() {
        this.Pt.forEach((t)=>t.stop());
    }
}
class $e444d6404c095fa5$var$ds {
    constructor(t){
        this.Pt = t;
    }
    triggerStatus(t) {
        var i = new Set;
        for (var e of this.Pt)i.add(e.triggerStatus(t));
        switch(i.delete($e444d6404c095fa5$var$ls), i.size){
            case 0:
                return $e444d6404c095fa5$var$ls;
            case 1:
                return Array.from(i)[0];
            default:
                return $e444d6404c095fa5$var$as;
        }
    }
    stop() {
        this.Pt.forEach((t)=>t.stop());
    }
}
class $e444d6404c095fa5$var$vs {
    triggerStatus() {
        return $e444d6404c095fa5$var$as;
    }
    stop() {}
}
var $e444d6404c095fa5$var$cs = (t)=>"sessionRecording" in t;
class $e444d6404c095fa5$var$fs {
    constructor(t){
        this.It = [], this.Rt = [], this.urlBlocked = !1, this._instance = t;
    }
    onConfig(t) {
        var i, e;
        this.It = ($e444d6404c095fa5$var$cs(t) ? null == (i = t.sessionRecording) ? void 0 : i.urlTriggers : null == t ? void 0 : t.urlTriggers) || [], this.Rt = ($e444d6404c095fa5$var$cs(t) ? null == (e = t.sessionRecording) ? void 0 : e.urlBlocklist : null == t ? void 0 : t.urlBlocklist) || [];
    }
    Tt(t) {
        var i;
        return 0 === this.It.length ? $e444d6404c095fa5$var$ls : (null == (i = this._instance) ? void 0 : i.get_property($e444d6404c095fa5$var$di)) === t ? $e444d6404c095fa5$var$os : $e444d6404c095fa5$var$as;
    }
    triggerStatus(t) {
        var i = this.Tt(t), e = i === $e444d6404c095fa5$var$os ? $e444d6404c095fa5$var$os : i === $e444d6404c095fa5$var$as ? $e444d6404c095fa5$var$as : $e444d6404c095fa5$var$ls;
        return this._instance.register_for_session({
            $sdk_debug_replay_url_trigger_status: e
        }), e;
    }
    checkUrlTriggerConditions(i, e, r) {
        if (void 0 !== $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$t.location.href) {
            var s = $e444d6404c095fa5$var$t.location.href, n = this.urlBlocked, o = $e444d6404c095fa5$var$us(s, this.Rt);
            n && o || (o && !n ? i() : !o && n && e(), $e444d6404c095fa5$var$us(s, this.It) && r("url"));
        }
    }
    stop() {}
}
class $e444d6404c095fa5$var$ps {
    constructor(t){
        this.linkedFlag = null, this.linkedFlagSeen = !1, this.Ct = ()=>{}, this._instance = t;
    }
    triggerStatus() {
        var t = $e444d6404c095fa5$var$as;
        return $e444d6404c095fa5$var$A(this.linkedFlag) && (t = $e444d6404c095fa5$var$ls), this.linkedFlagSeen && (t = $e444d6404c095fa5$var$os), this._instance.register_for_session({
            $sdk_debug_replay_linked_flag_trigger_status: t
        }), t;
    }
    onConfig(t, i) {
        var e;
        if (this.linkedFlag = ($e444d6404c095fa5$var$cs(t) ? null == (e = t.sessionRecording) ? void 0 : e.linkedFlag : null == t ? void 0 : t.linkedFlag) || null, !$e444d6404c095fa5$var$A(this.linkedFlag) && !this.linkedFlagSeen) {
            var r = $e444d6404c095fa5$var$M(this.linkedFlag) ? this.linkedFlag : this.linkedFlag.flag, s = $e444d6404c095fa5$var$M(this.linkedFlag) ? null : this.linkedFlag.variant;
            this.Ct = this._instance.onFeatureFlags((t, e)=>{
                var n = !1;
                if ($e444d6404c095fa5$var$R(e) && r in e) {
                    var o = e[r];
                    n = $e444d6404c095fa5$var$j(o) ? !0 === o : s ? o === s : !!o;
                }
                this.linkedFlagSeen = n, n && i(r, s);
            });
        }
    }
    stop() {
        this.Ct();
    }
}
class $e444d6404c095fa5$var$gs {
    constructor(t){
        this.Mt = [], this._instance = t;
    }
    onConfig(t) {
        var i;
        this.Mt = ($e444d6404c095fa5$var$cs(t) ? null == (i = t.sessionRecording) ? void 0 : i.eventTriggers : null == t ? void 0 : t.eventTriggers) || [];
    }
    Ot(t) {
        var i;
        return 0 === this.Mt.length ? $e444d6404c095fa5$var$ls : (null == (i = this._instance) ? void 0 : i.get_property($e444d6404c095fa5$var$vi)) === t ? $e444d6404c095fa5$var$os : $e444d6404c095fa5$var$as;
    }
    triggerStatus(t) {
        var i = this.Ot(t), e = i === $e444d6404c095fa5$var$os ? $e444d6404c095fa5$var$os : i === $e444d6404c095fa5$var$as ? $e444d6404c095fa5$var$as : $e444d6404c095fa5$var$ls;
        return this._instance.register_for_session({
            $sdk_debug_replay_event_trigger_status: e
        }), e;
    }
    stop() {}
}
function $e444d6404c095fa5$var$_s(t) {
    return t.isRecordingEnabled ? $e444d6404c095fa5$var$rs : $e444d6404c095fa5$var$ts;
}
function $e444d6404c095fa5$var$ms(t) {
    if (!t.receivedFlags) return $e444d6404c095fa5$var$rs;
    if (!t.isRecordingEnabled) return $e444d6404c095fa5$var$ts;
    if (t.urlTriggerMatching.urlBlocked) return $e444d6404c095fa5$var$ss;
    var i = !0 === t.isSampled, e = new $e444d6404c095fa5$var$hs([
        t.eventTriggerMatching,
        t.urlTriggerMatching,
        t.linkedFlagMatching
    ]).triggerStatus(t.sessionId);
    return i ? $e444d6404c095fa5$var$is : e === $e444d6404c095fa5$var$os ? $e444d6404c095fa5$var$es : e === $e444d6404c095fa5$var$as ? $e444d6404c095fa5$var$rs : !1 === t.isSampled ? $e444d6404c095fa5$var$ts : $e444d6404c095fa5$var$es;
}
function $e444d6404c095fa5$var$ys(t) {
    if (!t.receivedFlags) return $e444d6404c095fa5$var$rs;
    if (!t.isRecordingEnabled) return $e444d6404c095fa5$var$ts;
    if (t.urlTriggerMatching.urlBlocked) return $e444d6404c095fa5$var$ss;
    var i = new $e444d6404c095fa5$var$ds([
        t.eventTriggerMatching,
        t.urlTriggerMatching,
        t.linkedFlagMatching
    ]).triggerStatus(t.sessionId), e = i !== $e444d6404c095fa5$var$ls, r = $e444d6404c095fa5$var$j(t.isSampled);
    return e && i === $e444d6404c095fa5$var$as ? $e444d6404c095fa5$var$rs : e && i === $e444d6404c095fa5$var$ls || r && !t.isSampled ? $e444d6404c095fa5$var$ts : !0 === t.isSampled ? $e444d6404c095fa5$var$is : $e444d6404c095fa5$var$es;
}
var $e444d6404c095fa5$var$bs = "[SessionRecording]", $e444d6404c095fa5$var$ws = $e444d6404c095fa5$var$Et($e444d6404c095fa5$var$bs);
function $e444d6404c095fa5$var$Ss() {
    var t;
    return null == $e444d6404c095fa5$var$v || null == (t = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (t = t.rrweb) ? void 0 : t.record;
}
var $e444d6404c095fa5$var$ks = 3e5, $e444d6404c095fa5$var$$s = [
    $e444d6404c095fa5$var$sr.MouseMove,
    $e444d6404c095fa5$var$sr.MouseInteraction,
    $e444d6404c095fa5$var$sr.Scroll,
    $e444d6404c095fa5$var$sr.ViewportResize,
    $e444d6404c095fa5$var$sr.Input,
    $e444d6404c095fa5$var$sr.TouchMove,
    $e444d6404c095fa5$var$sr.MediaInteraction,
    $e444d6404c095fa5$var$sr.Drag
], $e444d6404c095fa5$var$xs = (t)=>({
        rrwebMethod: t,
        enqueuedAt: Date.now(),
        attempt: 1
    });
function $e444d6404c095fa5$var$Es(t) {
    return function(t, i) {
        for(var e = "", r = 0; r < t.length;){
            var s = t[r++];
            e += String.fromCharCode(s);
        }
        return e;
    }($e444d6404c095fa5$var$Xr($e444d6404c095fa5$var$Qr(JSON.stringify(t))));
}
function $e444d6404c095fa5$var$Ps(t) {
    return t.type === $e444d6404c095fa5$var$rr.Custom && "sessionIdle" === t.data.tag;
}
class $e444d6404c095fa5$var$Is {
    get sessionId() {
        return this.Ft;
    }
    get At() {
        return this._instance.config.session_recording.session_idle_threshold_ms || 3e5;
    }
    get started() {
        return this.Dt;
    }
    get jt() {
        if (!this._instance.sessionManager) throw new Error($e444d6404c095fa5$var$bs + " must be started with a valid sessionManager.");
        return this._instance.sessionManager;
    }
    get Lt() {
        var t, i;
        return this.Nt.triggerStatus(this.sessionId) === $e444d6404c095fa5$var$as ? 6e4 : null !== (t = null == (i = this._instance.config.session_recording) ? void 0 : i.full_snapshot_interval_millis) && void 0 !== t ? t : $e444d6404c095fa5$var$ks;
    }
    get Ut() {
        var t = this._instance.get_property($e444d6404c095fa5$var$hi);
        return $e444d6404c095fa5$var$j(t) ? t : null;
    }
    get zt() {
        var t, i, e = null == (t = this.H) ? void 0 : t.data[(null == (i = this.H) ? void 0 : i.data.length) - 1], { sessionStartTimestamp: r } = this.jt.checkAndGetSessionAndWindowId(!0);
        return e ? e.timestamp - r : null;
    }
    get qt() {
        var i = !!this._instance.get_property($e444d6404c095fa5$var$ii), e = !this._instance.config.disable_session_recording;
        return $e444d6404c095fa5$var$t && i && e;
    }
    get Bt() {
        var t = !!this._instance.get_property($e444d6404c095fa5$var$ei), i = this._instance.config.enable_recording_console_log;
        return null != i ? i : t;
    }
    get Ht() {
        var t, i, e, r, s, n, o = this._instance.config.session_recording.captureCanvas, a = this._instance.get_property($e444d6404c095fa5$var$ni), l = null !== (t = null !== (i = null == o ? void 0 : o.recordCanvas) && void 0 !== i ? i : null == a ? void 0 : a.enabled) && void 0 !== t && t, u = null !== (e = null !== (r = null == o ? void 0 : o.canvasFps) && void 0 !== r ? r : null == a ? void 0 : a.fps) && void 0 !== e ? e : 4, h = null !== (s = null !== (n = null == o ? void 0 : o.canvasQuality) && void 0 !== n ? n : null == a ? void 0 : a.quality) && void 0 !== s ? s : .4;
        if ("string" == typeof h) {
            var d = parseFloat(h);
            h = isNaN(d) ? .4 : d;
        }
        return {
            enabled: l,
            fps: $e444d6404c095fa5$var$G(u, 0, 12, $e444d6404c095fa5$var$ws.createLogger("canvas recording fps"), 4),
            quality: $e444d6404c095fa5$var$G(h, 0, 1, $e444d6404c095fa5$var$ws.createLogger("canvas recording quality"), .4)
        };
    }
    get Wt() {
        var t, i, e = this._instance.get_property($e444d6404c095fa5$var$ri), r = {
            recordHeaders: null == (t = this._instance.config.session_recording) ? void 0 : t.recordHeaders,
            recordBody: null == (i = this._instance.config.session_recording) ? void 0 : i.recordBody
        }, s = (null == r ? void 0 : r.recordHeaders) || (null == e ? void 0 : e.recordHeaders), n = (null == r ? void 0 : r.recordBody) || (null == e ? void 0 : e.recordBody), o = $e444d6404c095fa5$var$R(this._instance.config.capture_performance) ? this._instance.config.capture_performance.network_timing : this._instance.config.capture_performance, a = !!($e444d6404c095fa5$var$j(o) ? o : null == e ? void 0 : e.capturePerformance);
        return s || n || a ? {
            recordHeaders: s,
            recordBody: n,
            recordPerformance: a
        } : void 0;
    }
    get Gt() {
        var t, i, e, r, s, n, o = this._instance.get_property($e444d6404c095fa5$var$si), a = {
            maskAllInputs: null == (t = this._instance.config.session_recording) ? void 0 : t.maskAllInputs,
            maskTextSelector: null == (i = this._instance.config.session_recording) ? void 0 : i.maskTextSelector,
            blockSelector: null == (e = this._instance.config.session_recording) ? void 0 : e.blockSelector
        }, l = null !== (r = null == a ? void 0 : a.maskAllInputs) && void 0 !== r ? r : null == o ? void 0 : o.maskAllInputs, u = null !== (s = null == a ? void 0 : a.maskTextSelector) && void 0 !== s ? s : null == o ? void 0 : o.maskTextSelector, h = null !== (n = null == a ? void 0 : a.blockSelector) && void 0 !== n ? n : null == o ? void 0 : o.blockSelector;
        return $e444d6404c095fa5$var$C(l) && $e444d6404c095fa5$var$C(u) && $e444d6404c095fa5$var$C(h) ? void 0 : {
            maskAllInputs: null == l || l,
            maskTextSelector: u,
            blockSelector: h
        };
    }
    get Vt() {
        var t = this._instance.get_property($e444d6404c095fa5$var$oi);
        return $e444d6404c095fa5$var$D(t) ? t : null;
    }
    get Jt() {
        var t = this._instance.get_property($e444d6404c095fa5$var$ai);
        return $e444d6404c095fa5$var$D(t) ? t : null;
    }
    get status() {
        return this.Kt ? this.Yt({
            receivedFlags: this.Kt,
            isRecordingEnabled: this.qt,
            isSampled: this.Ut,
            urlTriggerMatching: this.Xt,
            eventTriggerMatching: this.Qt,
            linkedFlagMatching: this.Zt,
            sessionId: this.sessionId
        }) : $e444d6404c095fa5$var$rs;
    }
    constructor(t){
        if (this.Yt = $e444d6404c095fa5$var$_s, this.Kt = !1, this.ti = [], this.ii = "unknown", this.ei = Date.now(), this.Nt = new $e444d6404c095fa5$var$vs, this.ri = void 0, this.si = void 0, this.ni = void 0, this.oi = void 0, this.ai = void 0, this._forceAllowLocalhostNetworkCapture = !1, this.li = ()=>{
            this.ui();
        }, this.hi = ()=>{
            this.tryAddCustomEvent("browser offline", {});
        }, this.di = ()=>{
            this.tryAddCustomEvent("browser online", {});
        }, this.vi = ()=>{
            if (null != $e444d6404c095fa5$var$o && $e444d6404c095fa5$var$o.visibilityState) {
                var t = "window " + $e444d6404c095fa5$var$o.visibilityState;
                this.tryAddCustomEvent(t, {});
            }
        }, this._instance = t, this.Dt = !1, this.ci = "/s/", this.fi = void 0, this.Kt = !1, !this._instance.sessionManager) throw $e444d6404c095fa5$var$ws.error("started without valid sessionManager"), new Error($e444d6404c095fa5$var$bs + " started without valid sessionManager. This is a bug.");
        if ("always" === this._instance.config.cookieless_mode) throw new Error($e444d6404c095fa5$var$bs + ' cannot be used with cookieless_mode="always"');
        this.Zt = new $e444d6404c095fa5$var$ps(this._instance), this.Xt = new $e444d6404c095fa5$var$fs(this._instance), this.Qt = new $e444d6404c095fa5$var$gs(this._instance);
        var { sessionId: i, windowId: e } = this.jt.checkAndGetSessionAndWindowId();
        this.Ft = i, this.pi = e, this.H = this.gi(), this.At >= this.jt.sessionTimeoutMs && $e444d6404c095fa5$var$ws.warn("session_idle_threshold_ms (" + this.At + ") is greater than the session timeout (" + this.jt.sessionTimeoutMs + "). Session will never be detected as idle");
    }
    startIfEnabledOrStop(i) {
        this.qt ? (this.mi(i), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "beforeunload", this.li), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "offline", this.hi), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "online", this.di), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "visibilitychange", this.vi), this.yi(), this.bi(), $e444d6404c095fa5$var$A(this.ri) && (this.ri = this._instance.on("eventCaptured", (t)=>{
            try {
                if ("$pageview" === t.event) {
                    var i = null != t && t.properties.$current_url ? this.wi(null == t ? void 0 : t.properties.$current_url) : "";
                    if (!i) return;
                    this.tryAddCustomEvent("$pageview", {
                        href: i
                    });
                }
            } catch (t) {
                $e444d6404c095fa5$var$ws.error("Could not add $pageview to rrweb session", t);
            }
        })), this.si || (this.si = this.jt.onSessionId((t, i, e)=>{
            var r, s;
            e && (this.tryAddCustomEvent("$session_id_change", {
                sessionId: t,
                windowId: i,
                changeReason: e
            }), null == (r = this._instance) || null == (r = r.persistence) || r.unregister($e444d6404c095fa5$var$vi), null == (s = this._instance) || null == (s = s.persistence) || s.unregister($e444d6404c095fa5$var$di));
        }))) : this.stopRecording();
    }
    stopRecording() {
        var i, e, r, s;
        this.Dt && this.fi && (this.fi(), this.fi = void 0, this.Dt = !1, null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.removeEventListener("beforeunload", this.li), null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.removeEventListener("offline", this.hi), null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.removeEventListener("online", this.di), null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.removeEventListener("visibilitychange", this.vi), this.gi(), clearInterval(this.Si), null == (i = this.ri) || i.call(this), this.ri = void 0, null == (e = this.ai) || e.call(this), this.ai = void 0, null == (r = this.si) || r.call(this), this.si = void 0, null == (s = this.oi) || s.call(this), this.oi = void 0, this.Qt.stop(), this.Xt.stop(), this.Zt.stop(), $e444d6404c095fa5$var$ws.info("stopped"));
    }
    ki() {
        var t;
        null == (t = this._instance.persistence) || t.unregister($e444d6404c095fa5$var$hi);
    }
    $i(t) {
        var i, e = this.Ft !== t, r = this.Vt;
        if ($e444d6404c095fa5$var$D(r)) {
            var s = this.Ut, n = e || !$e444d6404c095fa5$var$j(s), o = n ? $e444d6404c095fa5$var$Zr(t, r) : s;
            n && (o ? this.xi($e444d6404c095fa5$var$is) : $e444d6404c095fa5$var$ws.warn("Sample rate (" + r + ") has determined that this sessionId (" + t + ") will not be sent to the server."), this.tryAddCustomEvent("samplingDecisionMade", {
                sampleRate: r,
                isSampled: o
            })), null == (i = this._instance.persistence) || i.register({
                [$e444d6404c095fa5$var$hi]: o
            });
        } else this.ki();
    }
    onRemoteConfig(t) {
        var i, e, r, s;
        (this.tryAddCustomEvent("$remote_config_received", t), this.Ei(t), null != (i = t.sessionRecording) && i.endpoint) && (this.ci = null == (s = t.sessionRecording) ? void 0 : s.endpoint);
        this.yi(), "any" === (null == (e = t.sessionRecording) ? void 0 : e.triggerMatchType) ? (this.Yt = $e444d6404c095fa5$var$ms, this.Nt = new $e444d6404c095fa5$var$hs([
            this.Qt,
            this.Xt
        ])) : (this.Yt = $e444d6404c095fa5$var$ys, this.Nt = new $e444d6404c095fa5$var$ds([
            this.Qt,
            this.Xt
        ])), this._instance.register_for_session({
            $sdk_debug_replay_remote_trigger_matching_config: null == (r = t.sessionRecording) ? void 0 : r.triggerMatchType
        }), this.Xt.onConfig(t), this.Qt.onConfig(t), this.Zt.onConfig(t, (t, i)=>{
            this.xi("linked_flag_matched", {
                flag: t,
                variant: i
            });
        }), this.Kt = !0, this.startIfEnabledOrStop();
    }
    yi() {
        $e444d6404c095fa5$var$D(this.Vt) && $e444d6404c095fa5$var$A(this.oi) && (this.oi = this.jt.onSessionId((t)=>{
            this.$i(t);
        }));
    }
    Ei(t) {
        if (this._instance.persistence) {
            var i, e = this._instance.persistence, r = ()=>{
                var i, r, s, n, o, a, l, u, h, d = null == (i = t.sessionRecording) ? void 0 : i.sampleRate, v = $e444d6404c095fa5$var$A(d) ? null : parseFloat(d);
                $e444d6404c095fa5$var$A(v) && this.ki();
                var c = null == (r = t.sessionRecording) ? void 0 : r.minimumDurationMilliseconds;
                e.register({
                    [$e444d6404c095fa5$var$ii]: !!t.sessionRecording,
                    [$e444d6404c095fa5$var$ei]: null == (s = t.sessionRecording) ? void 0 : s.consoleLogRecordingEnabled,
                    [$e444d6404c095fa5$var$ri]: $e444d6404c095fa5$var$g({
                        capturePerformance: t.capturePerformance
                    }, null == (n = t.sessionRecording) ? void 0 : n.networkPayloadCapture),
                    [$e444d6404c095fa5$var$si]: null == (o = t.sessionRecording) ? void 0 : o.masking,
                    [$e444d6404c095fa5$var$ni]: {
                        enabled: null == (a = t.sessionRecording) ? void 0 : a.recordCanvas,
                        fps: null == (l = t.sessionRecording) ? void 0 : l.canvasFps,
                        quality: null == (u = t.sessionRecording) ? void 0 : u.canvasQuality
                    },
                    [$e444d6404c095fa5$var$oi]: v,
                    [$e444d6404c095fa5$var$ai]: $e444d6404c095fa5$var$C(c) ? null : c,
                    [$e444d6404c095fa5$var$li]: null == (h = t.sessionRecording) ? void 0 : h.scriptConfig
                });
            };
            r(), null == (i = this.ni) || i.call(this), this.ni = this.jt.onSessionId(r);
        }
    }
    log(t, i) {
        var e;
        void 0 === i && (i = "log"), null == (e = this._instance.sessionRecording) || e.onRRwebEmit({
            type: 6,
            data: {
                plugin: "rrweb/console@1",
                payload: {
                    level: i,
                    trace: [],
                    payload: [
                        JSON.stringify(t)
                    ]
                }
            },
            timestamp: Date.now()
        });
    }
    mi(t) {
        if (!$e444d6404c095fa5$var$C(Object.assign) && !$e444d6404c095fa5$var$C(Array.from) && !(this.Dt || this._instance.config.disable_session_recording || this._instance.consent.isOptedOut())) {
            var i;
            if (this.Dt = !0, this.jt.checkAndGetSessionAndWindowId(), $e444d6404c095fa5$var$Ss()) this.Pi();
            else null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, this.Ii, (t)=>{
                if (t) return $e444d6404c095fa5$var$ws.error("could not load recorder", t);
                this.Pi();
            });
            $e444d6404c095fa5$var$ws.info("starting"), this.status === $e444d6404c095fa5$var$es && this.xi(t || "recording_initialized");
        }
    }
    get Ii() {
        var t;
        return (null == (t = this._instance) || null == (t = t.persistence) || null == (t = t.get_property($e444d6404c095fa5$var$li)) ? void 0 : t.script) || "recorder";
    }
    Ri(t) {
        var i;
        return 3 === t.type && -1 !== $e444d6404c095fa5$var$$s.indexOf(null == (i = t.data) ? void 0 : i.source);
    }
    Ti(t) {
        var i = this.Ri(t);
        i || this.ii || t.timestamp - this.ei > this.At && (this.ii = !0, clearInterval(this.Si), this.tryAddCustomEvent("sessionIdle", {
            eventTimestamp: t.timestamp,
            lastActivityTimestamp: this.ei,
            threshold: this.At,
            bufferLength: this.H.data.length,
            bufferSize: this.H.size
        }), this.ui());
        var e = !1;
        if (i && (this.ei = t.timestamp, this.ii)) {
            var r = "unknown" === this.ii;
            this.ii = !1, r || (this.tryAddCustomEvent("sessionNoLongerIdle", {
                reason: "user activity",
                type: t.type
            }), e = !0);
        }
        if (!this.ii) {
            var { windowId: s, sessionId: n } = this.jt.checkAndGetSessionAndWindowId(!i, t.timestamp), o = this.Ft !== n, a = this.pi !== s;
            this.pi = s, this.Ft = n, o || a ? (this.stopRecording(), this.startIfEnabledOrStop("session_id_changed")) : e && this.Ci();
        }
    }
    Mi(t) {
        try {
            return t.rrwebMethod(), !0;
        } catch (i) {
            return this.ti.length < 10 ? this.ti.push({
                enqueuedAt: t.enqueuedAt || Date.now(),
                attempt: t.attempt++,
                rrwebMethod: t.rrwebMethod
            }) : $e444d6404c095fa5$var$ws.warn("could not emit queued rrweb event.", i, t), !1;
        }
    }
    tryAddCustomEvent(t, i) {
        return this.Mi($e444d6404c095fa5$var$xs(()=>$e444d6404c095fa5$var$Ss().addCustomEvent(t, i)));
    }
    Oi() {
        return this.Mi($e444d6404c095fa5$var$xs(()=>$e444d6404c095fa5$var$Ss().takeFullSnapshot()));
    }
    Pi() {
        var t, i, e, r, s = {
            blockClass: "ph-no-capture",
            blockSelector: void 0,
            ignoreClass: "ph-ignore-input",
            maskTextClass: "ph-mask",
            maskTextSelector: void 0,
            maskTextFn: void 0,
            maskAllInputs: !0,
            maskInputOptions: {
                password: !0
            },
            maskInputFn: void 0,
            slimDOMOptions: {},
            collectFonts: !1,
            inlineStylesheet: !0,
            recordCrossOriginIframes: !1
        }, n = this._instance.config.session_recording;
        for (var [o, a] of Object.entries(n || {}))o in s && ("maskInputOptions" === o ? s.maskInputOptions = $e444d6404c095fa5$var$g({
            password: !0
        }, a) : s[o] = a);
        (this.Ht && this.Ht.enabled && (s.recordCanvas = !0, s.sampling = {
            canvas: this.Ht.fps
        }, s.dataURLOptions = {
            type: "image/webp",
            quality: this.Ht.quality
        }), this.Gt) && (s.maskAllInputs = null === (i = this.Gt.maskAllInputs) || void 0 === i || i, s.maskTextSelector = null !== (e = this.Gt.maskTextSelector) && void 0 !== e ? e : void 0, s.blockSelector = null !== (r = this.Gt.blockSelector) && void 0 !== r ? r : void 0);
        var l = $e444d6404c095fa5$var$Ss();
        if (l) {
            this.Fi = null !== (t = this.Fi) && void 0 !== t ? t : new $e444d6404c095fa5$var$fr(l, {
                refillRate: this._instance.config.session_recording.__mutationThrottlerRefillRate,
                bucketSize: this._instance.config.session_recording.__mutationThrottlerBucketSize,
                onBlockedNode: (t, i)=>{
                    var e = "Too many mutations on node '" + t + "'. Rate limiting. This could be due to SVG animations or something similar";
                    $e444d6404c095fa5$var$ws.info(e, {
                        node: i
                    }), this.log($e444d6404c095fa5$var$bs + " " + e, "warn");
                }
            });
            var u = this.Ai();
            this.fi = l($e444d6404c095fa5$var$g({
                emit: (t)=>{
                    this.onRRwebEmit(t);
                },
                plugins: u
            }, s)), this.ei = Date.now(), this.ii = $e444d6404c095fa5$var$j(this.ii) ? this.ii : "unknown", this.tryAddCustomEvent("$session_options", {
                sessionRecordingOptions: s,
                activePlugins: u.map((t)=>null == t ? void 0 : t.name)
            }), this.tryAddCustomEvent("$posthog_config", {
                config: this._instance.config
            });
        } else $e444d6404c095fa5$var$ws.error("onScriptLoaded was called but rrwebRecord is not available. This indicates something has gone wrong.");
    }
    Ci() {
        if (this.Si && clearInterval(this.Si), !0 !== this.ii) {
            var t = this.Lt;
            t && (this.Si = setInterval(()=>{
                this.Oi();
            }, t));
        }
    }
    Ai() {
        var t, i, e = [], r = null == (t = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (t = t.rrwebPlugins) ? void 0 : t.getRecordConsolePlugin;
        r && this.Bt && e.push(r());
        var s = null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (i = i.rrwebPlugins) ? void 0 : i.getRecordNetworkPlugin;
        this.Wt && $e444d6404c095fa5$var$I(s) && (!$e444d6404c095fa5$var$ce.includes(location.hostname) || this._forceAllowLocalhostNetworkCapture ? e.push(s($e444d6404c095fa5$var$cr(this._instance.config, this.Wt))) : $e444d6404c095fa5$var$ws.info("NetworkCapture not started because we are on localhost."));
        return e;
    }
    onRRwebEmit(t) {
        var i;
        if (this.Di(), t && $e444d6404c095fa5$var$R(t)) {
            if (t.type === $e444d6404c095fa5$var$rr.Meta) {
                var e = this.wi(t.data.href);
                if (this.ji = e, !e) return;
                t.data.href = e;
            } else this.Li();
            if (this.Xt.checkUrlTriggerConditions(()=>this.Ni(), ()=>this.Ui(), (t)=>this.zi(t)), !this.Xt.urlBlocked || (r = t).type === $e444d6404c095fa5$var$rr.Custom && "recording paused" === r.data.tag) {
                var r;
                t.type === $e444d6404c095fa5$var$rr.FullSnapshot && this.Ci(), t.type === $e444d6404c095fa5$var$rr.FullSnapshot && this.Kt && this.Nt.triggerStatus(this.sessionId) === $e444d6404c095fa5$var$as && this.gi();
                var s = this.Fi ? this.Fi.throttleMutations(t) : t;
                if (s) {
                    var n = function(t) {
                        var i = t;
                        if (i && $e444d6404c095fa5$var$R(i) && 6 === i.type && $e444d6404c095fa5$var$R(i.data) && "rrweb/console@1" === i.data.plugin) {
                            i.data.payload.payload.length > 10 && (i.data.payload.payload = i.data.payload.payload.slice(0, 10), i.data.payload.payload.push("...[truncated]"));
                            for(var e = [], r = 0; r < i.data.payload.payload.length; r++)i.data.payload.payload[r] && i.data.payload.payload[r].length > 2e3 ? e.push(i.data.payload.payload[r].slice(0, 2e3) + "...[truncated]") : e.push(i.data.payload.payload[r]);
                            return i.data.payload.payload = e, t;
                        }
                        return t;
                    }(s);
                    if (this.Ti(n), !0 !== this.ii || $e444d6404c095fa5$var$Ps(n)) {
                        if ($e444d6404c095fa5$var$Ps(n)) {
                            var o = n.data.payload;
                            if (o) {
                                var a = o.lastActivityTimestamp, l = o.threshold;
                                n.timestamp = a + l;
                            }
                        }
                        var u = null === (i = this._instance.config.session_recording.compress_events) || void 0 === i || i ? function(t) {
                            if ($e444d6404c095fa5$var$ir(t) < 1024) return t;
                            try {
                                if (t.type === $e444d6404c095fa5$var$rr.FullSnapshot) return $e444d6404c095fa5$var$g({}, t, {
                                    data: $e444d6404c095fa5$var$Es(t.data),
                                    cv: "2024-10"
                                });
                                if (t.type === $e444d6404c095fa5$var$rr.IncrementalSnapshot && t.data.source === $e444d6404c095fa5$var$sr.Mutation) return $e444d6404c095fa5$var$g({}, t, {
                                    cv: "2024-10",
                                    data: $e444d6404c095fa5$var$g({}, t.data, {
                                        texts: $e444d6404c095fa5$var$Es(t.data.texts),
                                        attributes: $e444d6404c095fa5$var$Es(t.data.attributes),
                                        removes: $e444d6404c095fa5$var$Es(t.data.removes),
                                        adds: $e444d6404c095fa5$var$Es(t.data.adds)
                                    })
                                });
                                if (t.type === $e444d6404c095fa5$var$rr.IncrementalSnapshot && t.data.source === $e444d6404c095fa5$var$sr.StyleSheetRule) return $e444d6404c095fa5$var$g({}, t, {
                                    cv: "2024-10",
                                    data: $e444d6404c095fa5$var$g({}, t.data, {
                                        adds: t.data.adds ? $e444d6404c095fa5$var$Es(t.data.adds) : void 0,
                                        removes: t.data.removes ? $e444d6404c095fa5$var$Es(t.data.removes) : void 0
                                    })
                                });
                            } catch (t) {
                                $e444d6404c095fa5$var$ws.error("could not compress event - will use uncompressed event", t);
                            }
                            return t;
                        }(n) : n, h = {
                            $snapshot_bytes: $e444d6404c095fa5$var$ir(u),
                            $snapshot_data: u,
                            $session_id: this.Ft,
                            $window_id: this.pi
                        };
                        this.status !== $e444d6404c095fa5$var$ts ? this.qi(h) : this.gi();
                    }
                }
            }
        }
    }
    Li() {
        if (!this._instance.config.capture_pageview && $e444d6404c095fa5$var$t) {
            var i = this.wi($e444d6404c095fa5$var$t.location.href);
            this.ji !== i && (this.tryAddCustomEvent("$url_changed", {
                href: i
            }), this.ji = i);
        }
    }
    Di() {
        if (this.ti.length) {
            var t = [
                ...this.ti
            ];
            this.ti = [], t.forEach((t)=>{
                Date.now() - t.enqueuedAt <= 2e3 && this.Mi(t);
            });
        }
    }
    wi(t) {
        var i = this._instance.config.session_recording;
        if (i.maskNetworkRequestFn) {
            var e, r = {
                url: t
            };
            return null == (e = r = i.maskNetworkRequestFn(r)) ? void 0 : e.url;
        }
        return t;
    }
    gi() {
        return this.H = {
            size: 0,
            data: [],
            sessionId: this.Ft,
            windowId: this.pi
        }, this.H;
    }
    ui() {
        this.Bi && (clearTimeout(this.Bi), this.Bi = void 0);
        var t = this.Jt, i = this.zt, e = $e444d6404c095fa5$var$D(i) && i >= 0, r = $e444d6404c095fa5$var$D(t) && e && i < t;
        if (this.status === $e444d6404c095fa5$var$rs || this.status === $e444d6404c095fa5$var$ss || this.status === $e444d6404c095fa5$var$ts || r) return this.Bi = setTimeout(()=>{
            this.ui();
        }, 2e3), this.H;
        this.H.data.length > 0 && $e444d6404c095fa5$var$er(this.H).forEach((t)=>{
            this.Hi({
                $snapshot_bytes: t.size,
                $snapshot_data: t.data,
                $session_id: t.sessionId,
                $window_id: t.windowId,
                $lib: "web",
                $lib_version: $e444d6404c095fa5$var$c.LIB_VERSION
            });
        });
        return this.gi();
    }
    qi(t) {
        var i, e = 2 + ((null == (i = this.H) ? void 0 : i.data.length) || 0);
        !this.ii && (this.H.size + t.$snapshot_bytes + e > 943718.4 || this.H.sessionId !== this.Ft) && (this.H = this.ui()), this.H.size += t.$snapshot_bytes, this.H.data.push(t.$snapshot_data), this.Bi || this.ii || (this.Bi = setTimeout(()=>{
            this.ui();
        }, 2e3));
    }
    Hi(t) {
        this._instance.capture("$snapshot", t, {
            _url: this._instance.requestRouter.endpointFor("api", this.ci),
            _noTruncate: !0,
            _batchKey: "recordings",
            skip_client_rate_limiting: !0
        });
    }
    zi(t) {
        var i;
        this.Nt.triggerStatus(this.sessionId) === $e444d6404c095fa5$var$as && (null == (i = this._instance) || null == (i = i.persistence) || i.register({
            ["url" === t ? $e444d6404c095fa5$var$di : $e444d6404c095fa5$var$vi]: this.Ft
        }), this.ui(), this.xi(t + "_trigger_matched"));
    }
    Ni() {
        this.Xt.urlBlocked || (this.Xt.urlBlocked = !0, clearInterval(this.Si), $e444d6404c095fa5$var$ws.info("recording paused due to URL blocker"), this.tryAddCustomEvent("recording paused", {
            reason: "url blocker"
        }));
    }
    Ui() {
        this.Xt.urlBlocked && (this.Xt.urlBlocked = !1, this.Oi(), this.Ci(), this.tryAddCustomEvent("recording resumed", {
            reason: "left blocked url"
        }), $e444d6404c095fa5$var$ws.info("recording resumed"));
    }
    bi() {
        0 !== this.Qt.Mt.length && $e444d6404c095fa5$var$A(this.ai) && (this.ai = this._instance.on("eventCaptured", (t)=>{
            try {
                this.Qt.Mt.includes(t.event) && this.zi("event");
            } catch (t) {
                $e444d6404c095fa5$var$ws.error("Could not activate event trigger", t);
            }
        }));
    }
    overrideLinkedFlag() {
        this.Zt.linkedFlagSeen = !0, this.Oi(), this.xi("linked_flag_overridden");
    }
    overrideSampling() {
        var t;
        null == (t = this._instance.persistence) || t.register({
            [$e444d6404c095fa5$var$hi]: !0
        }), this.Oi(), this.xi("sampling_overridden");
    }
    overrideTrigger(t) {
        this.zi(t);
    }
    xi(t, i) {
        this._instance.register_for_session({
            $session_recording_start_reason: t
        }), $e444d6404c095fa5$var$ws.info(t.replace("_", " "), i), $e444d6404c095fa5$var$y([
            "recording_initialized",
            "session_id_changed"
        ], t) || this.tryAddCustomEvent(t, i);
    }
    get sdkDebugProperties() {
        var { sessionStartTimestamp: t } = this.jt.checkAndGetSessionAndWindowId(!0);
        return {
            $recording_status: this.status,
            $sdk_debug_replay_internal_buffer_length: this.H.data.length,
            $sdk_debug_replay_internal_buffer_size: this.H.size,
            $sdk_debug_current_session_duration: this.zt,
            $sdk_debug_session_start: t
        };
    }
}
var $e444d6404c095fa5$var$Rs = $e444d6404c095fa5$var$Et("[SegmentIntegration]");
function $e444d6404c095fa5$var$Ts(t, i) {
    var e = t.config.segment;
    if (!e) return i();
    !function(t, i) {
        var e = t.config.segment;
        if (!e) return i();
        var r = (e)=>{
            var r = ()=>e.anonymousId() || $e444d6404c095fa5$var$Ce();
            t.config.get_device_id = r, e.id() && (t.register({
                distinct_id: e.id(),
                $device_id: r()
            }), t.persistence.set_property($e444d6404c095fa5$var$wi, "identified")), i();
        }, s = e.user();
        "then" in s && $e444d6404c095fa5$var$I(s.then) ? s.then((t)=>r(t)) : r(s);
    }(t, ()=>{
        e.register(((t)=>{
            Promise && Promise.resolve || $e444d6404c095fa5$var$Rs.warn("This browser does not have Promise support, and can not use the segment integration");
            var i = (i, e)=>{
                if (!e) return i;
                i.event.userId || i.event.anonymousId === t.get_distinct_id() || ($e444d6404c095fa5$var$Rs.info("No userId set, resetting PostHog"), t.reset()), i.event.userId && i.event.userId !== t.get_distinct_id() && ($e444d6404c095fa5$var$Rs.info("UserId set, identifying with PostHog"), t.identify(i.event.userId));
                var r = t.calculateEventProperties(e, i.event.properties);
                return i.event.properties = Object.assign({}, r, i.event.properties), i;
            };
            return {
                name: "PostHog JS",
                type: "enrichment",
                version: "1.0.0",
                isLoaded: ()=>!0,
                load: ()=>Promise.resolve(),
                track: (t)=>i(t, t.event.event),
                page: (t)=>i(t, "$pageview"),
                identify: (t)=>i(t, "$identify"),
                screen: (t)=>i(t, "$screen")
            };
        })(t)).then(()=>{
            i();
        });
    });
}
var $e444d6404c095fa5$var$Cs = "posthog-js";
function $e444d6404c095fa5$var$Ms(t, i) {
    var { organization: e, projectId: r, prefix: s, severityAllowList: n = [
        "error"
    ], sendExceptionsToPostHog: o = !0 } = void 0 === i ? {} : i;
    return (i)=>{
        var a, l, u, h, d;
        if (!("*" === n || n.includes(i.level)) || !t.__loaded) return i;
        i.tags || (i.tags = {});
        var v = t.requestRouter.endpointFor("ui", "/project/" + t.config.token + "/person/" + t.get_distinct_id());
        i.tags["PostHog Person URL"] = v, t.sessionRecordingStarted() && (i.tags["PostHog Recording URL"] = t.get_session_replay_url({
            withTimestamp: !0
        }));
        var c = (null == (a = i.exception) ? void 0 : a.values) || [], f = c.map((t)=>$e444d6404c095fa5$var$g({}, t, {
                stacktrace: t.stacktrace ? $e444d6404c095fa5$var$g({}, t.stacktrace, {
                    type: "raw",
                    frames: (t.stacktrace.frames || []).map((t)=>$e444d6404c095fa5$var$g({}, t, {
                            platform: "web:javascript"
                        }))
                }) : void 0
            })), p = {
            $exception_message: (null == (l = c[0]) ? void 0 : l.value) || i.message,
            $exception_type: null == (u = c[0]) ? void 0 : u.type,
            $exception_personURL: v,
            $exception_level: i.level,
            $exception_list: f,
            $sentry_event_id: i.event_id,
            $sentry_exception: i.exception,
            $sentry_exception_message: (null == (h = c[0]) ? void 0 : h.value) || i.message,
            $sentry_exception_type: null == (d = c[0]) ? void 0 : d.type,
            $sentry_tags: i.tags
        };
        return e && r && (p.$sentry_url = (s || "https://sentry.io/organizations/") + e + "/issues/?project=" + r + "&query=" + i.event_id), o && t.exceptions.sendExceptionEvent(p), i;
    };
}
class $e444d6404c095fa5$var$Os {
    constructor(t, i, e, r, s, n){
        this.name = $e444d6404c095fa5$var$Cs, this.setupOnce = function(o) {
            o($e444d6404c095fa5$var$Ms(t, {
                organization: i,
                projectId: e,
                prefix: r,
                severityAllowList: s,
                sendExceptionsToPostHog: null == n || n
            }));
        };
    }
}
var $e444d6404c095fa5$var$Fs = null != $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$t.location ? $e444d6404c095fa5$var$me($e444d6404c095fa5$var$t.location.hash, "__posthog") || $e444d6404c095fa5$var$me(location.hash, "state") : null, $e444d6404c095fa5$var$As = "_postHogToolbarParams", $e444d6404c095fa5$var$Ds = $e444d6404c095fa5$var$Et("[Toolbar]"), $e444d6404c095fa5$var$js = function(t) {
    return t[t.UNINITIALIZED = 0] = "UNINITIALIZED", t[t.LOADING = 1] = "LOADING", t[t.LOADED = 2] = "LOADED", t;
}($e444d6404c095fa5$var$js || {});
class $e444d6404c095fa5$var$Ls {
    constructor(t){
        this.instance = t;
    }
    Wi(t) {
        $e444d6404c095fa5$var$v.ph_toolbar_state = t;
    }
    Gi() {
        var t;
        return null !== (t = $e444d6404c095fa5$var$v.ph_toolbar_state) && void 0 !== t ? t : $e444d6404c095fa5$var$js.UNINITIALIZED;
    }
    maybeLoadToolbar(i, e, r) {
        if (void 0 === i && (i = void 0), void 0 === e && (e = void 0), void 0 === r && (r = void 0), !$e444d6404c095fa5$var$t || !$e444d6404c095fa5$var$o) return !1;
        i = null != i ? i : $e444d6404c095fa5$var$t.location, r = null != r ? r : $e444d6404c095fa5$var$t.history;
        try {
            if (!e) {
                try {
                    $e444d6404c095fa5$var$t.localStorage.setItem("test", "test"), $e444d6404c095fa5$var$t.localStorage.removeItem("test");
                } catch (t) {
                    return !1;
                }
                e = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.localStorage;
            }
            var s, n = $e444d6404c095fa5$var$Fs || $e444d6404c095fa5$var$me(i.hash, "__posthog") || $e444d6404c095fa5$var$me(i.hash, "state"), a = n ? $e444d6404c095fa5$var$At(()=>JSON.parse(atob(decodeURIComponent(n)))) || $e444d6404c095fa5$var$At(()=>JSON.parse(decodeURIComponent(n))) : null;
            return a && "ph_authorize" === a.action ? ((s = a).source = "url", s && Object.keys(s).length > 0 && (a.desiredHash ? i.hash = a.desiredHash : r ? r.replaceState(r.state, "", i.pathname + i.search) : i.hash = "")) : ((s = JSON.parse(e.getItem($e444d6404c095fa5$var$As) || "{}")).source = "localstorage", delete s.userIntent), !(!s.token || this.instance.config.token !== s.token) && (this.loadToolbar(s), !0);
        } catch (t) {
            return !1;
        }
    }
    Vi(t) {
        var i = $e444d6404c095fa5$var$v.ph_load_toolbar || $e444d6404c095fa5$var$v.ph_load_editor;
        !$e444d6404c095fa5$var$A(i) && $e444d6404c095fa5$var$I(i) ? i(t, this.instance) : $e444d6404c095fa5$var$Ds.warn("No toolbar load function found");
    }
    loadToolbar(i) {
        var e = !(null == $e444d6404c095fa5$var$o || !$e444d6404c095fa5$var$o.getElementById($e444d6404c095fa5$var$Ii));
        if (!$e444d6404c095fa5$var$t || e) return !1;
        var r = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, s = $e444d6404c095fa5$var$g({
            token: this.instance.config.token
        }, i, {
            apiURL: this.instance.requestRouter.endpointFor("ui")
        }, r ? {
            instrument: !1
        } : {});
        if ($e444d6404c095fa5$var$t.localStorage.setItem($e444d6404c095fa5$var$As, JSON.stringify($e444d6404c095fa5$var$g({}, s, {
            source: void 0
        }))), this.Gi() === $e444d6404c095fa5$var$js.LOADED) this.Vi(s);
        else if (this.Gi() === $e444d6404c095fa5$var$js.UNINITIALIZED) {
            var n;
            this.Wi($e444d6404c095fa5$var$js.LOADING), null == (n = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == n.loadExternalDependency || n.loadExternalDependency(this.instance, "toolbar", (t)=>{
                if (t) return $e444d6404c095fa5$var$Ds.error("[Toolbar] Failed to load", t), void this.Wi($e444d6404c095fa5$var$js.UNINITIALIZED);
                this.Wi($e444d6404c095fa5$var$js.LOADED), this.Vi(s);
            }), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "turbolinks:load", ()=>{
                this.Wi($e444d6404c095fa5$var$js.UNINITIALIZED), this.loadToolbar(s);
            });
        }
        return !0;
    }
    Ji(t) {
        return this.loadToolbar(t);
    }
    maybeLoadEditor(t, i, e) {
        return void 0 === t && (t = void 0), void 0 === i && (i = void 0), void 0 === e && (e = void 0), this.maybeLoadToolbar(t, i, e);
    }
}
var $e444d6404c095fa5$var$Ns = $e444d6404c095fa5$var$Et("[TracingHeaders]");
class $e444d6404c095fa5$var$Us {
    constructor(t){
        this.Ki = void 0, this.Yi = void 0, this.lt = ()=>{
            var t, i;
            $e444d6404c095fa5$var$C(this.Ki) && (null == (t = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (t = t.tracingHeadersPatchFns) || t._patchXHR(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager));
            $e444d6404c095fa5$var$C(this.Yi) && (null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (i = i.tracingHeadersPatchFns) || i._patchFetch(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager));
        }, this._instance = t;
    }
    nt(t) {
        var i, e;
        null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.tracingHeadersPatchFns && t(), null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "tracing-headers", (i)=>{
            if (i) return $e444d6404c095fa5$var$Ns.error("failed to load script", i);
            t();
        });
    }
    startIfEnabledOrStop() {
        var t, i;
        this._instance.config.__add_tracing_headers ? this.nt(this.lt) : (null == (t = this.Ki) || t.call(this), null == (i = this.Yi) || i.call(this), this.Ki = void 0, this.Yi = void 0);
    }
}
var $e444d6404c095fa5$var$zs = $e444d6404c095fa5$var$Et("[Web Vitals]"), $e444d6404c095fa5$var$qs = 9e5;
class $e444d6404c095fa5$var$Bs {
    constructor(t){
        var i;
        this.Xi = !1, this.C = !1, this.H = {
            url: void 0,
            metrics: [],
            firstMetricTimestamp: void 0
        }, this.Qi = ()=>{
            clearTimeout(this.Zi), 0 !== this.H.metrics.length && (this._instance.capture("$web_vitals", this.H.metrics.reduce((t, i)=>$e444d6404c095fa5$var$g({}, t, {
                    ["$web_vitals_" + i.name + "_event"]: $e444d6404c095fa5$var$g({}, i),
                    ["$web_vitals_" + i.name + "_value"]: i.value
                }), {})), this.H = {
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            });
        }, this.te = (t)=>{
            var i, e = null == (i = this._instance.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0);
            if ($e444d6404c095fa5$var$C(e)) $e444d6404c095fa5$var$zs.error("Could not read session ID. Dropping metrics!");
            else {
                this.H = this.H || {
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                };
                var r = this.ie();
                if (!$e444d6404c095fa5$var$C(r)) {
                    if ($e444d6404c095fa5$var$A(null == t ? void 0 : t.name) || $e444d6404c095fa5$var$A(null == t ? void 0 : t.value)) $e444d6404c095fa5$var$zs.error("Invalid metric received", t);
                    else if (this.ee && t.value >= this.ee) $e444d6404c095fa5$var$zs.error("Ignoring metric with value >= " + this.ee, t);
                    else this.H.url !== r && (this.Qi(), this.Zi = setTimeout(this.Qi, this.flushToCaptureTimeoutMs)), $e444d6404c095fa5$var$C(this.H.url) && (this.H.url = r), this.H.firstMetricTimestamp = $e444d6404c095fa5$var$C(this.H.firstMetricTimestamp) ? Date.now() : this.H.firstMetricTimestamp, t.attribution && t.attribution.interactionTargetElement && (t.attribution.interactionTargetElement = void 0), this.H.metrics.push($e444d6404c095fa5$var$g({}, t, {
                        $current_url: r,
                        $session_id: e.sessionId,
                        $window_id: e.windowId,
                        timestamp: Date.now()
                    })), this.H.metrics.length === this.allowedMetrics.length && this.Qi();
                }
            }
        }, this.lt = ()=>{
            var t, i, e, r, s = $e444d6404c095fa5$var$v.__PosthogExtensions__;
            $e444d6404c095fa5$var$C(s) || $e444d6404c095fa5$var$C(s.postHogWebVitalsCallbacks) || ({ onLCP: t, onCLS: i, onFCP: e, onINP: r } = s.postHogWebVitalsCallbacks), t && i && e && r ? (this.allowedMetrics.indexOf("LCP") > -1 && t(this.te.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && i(this.te.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && e(this.te.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && r(this.te.bind(this)), this.C = !0) : $e444d6404c095fa5$var$zs.error("web vitals callbacks not loaded - not starting");
        }, this._instance = t, this.Xi = !(null == (i = this._instance.persistence) || !i.props[$e444d6404c095fa5$var$Xt]), this.startIfEnabled();
    }
    get allowedMetrics() {
        var t, i, e = $e444d6404c095fa5$var$R(this._instance.config.capture_performance) ? null == (t = this._instance.config.capture_performance) ? void 0 : t.web_vitals_allowed_metrics : void 0;
        return $e444d6404c095fa5$var$C(e) ? (null == (i = this._instance.persistence) ? void 0 : i.props[$e444d6404c095fa5$var$Zt]) || [
            "CLS",
            "FCP",
            "INP",
            "LCP"
        ] : e;
    }
    get flushToCaptureTimeoutMs() {
        return ($e444d6404c095fa5$var$R(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals_delayed_flush_ms : void 0) || 5e3;
    }
    get ee() {
        var t = $e444d6404c095fa5$var$R(this._instance.config.capture_performance) && $e444d6404c095fa5$var$D(this._instance.config.capture_performance.__web_vitals_max_value) ? this._instance.config.capture_performance.__web_vitals_max_value : $e444d6404c095fa5$var$qs;
        return 0 < t && t <= 6e4 ? $e444d6404c095fa5$var$qs : t;
    }
    get isEnabled() {
        var t = null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.protocol;
        if ("http:" !== t && "https:" !== t) return $e444d6404c095fa5$var$zs.info("Web Vitals are disabled on non-http/https protocols"), !1;
        var i = $e444d6404c095fa5$var$R(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals : $e444d6404c095fa5$var$j(this._instance.config.capture_performance) ? this._instance.config.capture_performance : void 0;
        return $e444d6404c095fa5$var$j(i) ? i : this.Xi;
    }
    startIfEnabled() {
        this.isEnabled && !this.C && ($e444d6404c095fa5$var$zs.info("enabled, starting..."), this.nt(this.lt));
    }
    onRemoteConfig(t) {
        var i = $e444d6404c095fa5$var$R(t.capturePerformance) && !!t.capturePerformance.web_vitals, e = $e444d6404c095fa5$var$R(t.capturePerformance) ? t.capturePerformance.web_vitals_allowed_metrics : void 0;
        this._instance.persistence && (this._instance.persistence.register({
            [$e444d6404c095fa5$var$Xt]: i
        }), this._instance.persistence.register({
            [$e444d6404c095fa5$var$Zt]: e
        })), this.Xi = i, this.startIfEnabled();
    }
    nt(t) {
        var i, e;
        null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.postHogWebVitalsCallbacks && t(), null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "web-vitals", (i)=>{
            i ? $e444d6404c095fa5$var$zs.error("failed to load script", i) : t();
        });
    }
    ie() {
        var i = $e444d6404c095fa5$var$t ? $e444d6404c095fa5$var$t.location.href : void 0;
        return i || $e444d6404c095fa5$var$zs.error("Could not determine current URL"), i;
    }
}
var $e444d6404c095fa5$var$Hs = $e444d6404c095fa5$var$Et("[Heatmaps]");
function $e444d6404c095fa5$var$Ws(t) {
    return $e444d6404c095fa5$var$R(t) && "clientX" in t && "clientY" in t && $e444d6404c095fa5$var$D(t.clientX) && $e444d6404c095fa5$var$D(t.clientY);
}
class $e444d6404c095fa5$var$Gs {
    constructor(t){
        var i;
        this.rageclicks = new $e444d6404c095fa5$var$ue, this.Xi = !1, this.C = !1, this.re = null, this.instance = t, this.Xi = !(null == (i = this.instance.persistence) || !i.props[$e444d6404c095fa5$var$Vt]);
    }
    get flushIntervalMilliseconds() {
        var t = 5e3;
        return $e444d6404c095fa5$var$R(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (t = this.instance.config.capture_heatmaps.flush_interval_milliseconds), t;
    }
    get isEnabled() {
        return $e444d6404c095fa5$var$C(this.instance.config.capture_heatmaps) ? $e444d6404c095fa5$var$C(this.instance.config.enable_heatmaps) ? this.Xi : this.instance.config.enable_heatmaps : !1 !== this.instance.config.capture_heatmaps;
    }
    startIfEnabled() {
        if (this.isEnabled) {
            if (this.C) return;
            $e444d6404c095fa5$var$Hs.info("starting..."), this.se(), this.re = setInterval(this.ne.bind(this), this.flushIntervalMilliseconds);
        } else {
            var t, i;
            clearInterval(null !== (t = this.re) && void 0 !== t ? t : void 0), null == (i = this.oe) || i.stop(), this.getAndClearBuffer();
        }
    }
    onRemoteConfig(t) {
        var i = !!t.heatmaps;
        this.instance.persistence && this.instance.persistence.register({
            [$e444d6404c095fa5$var$Vt]: i
        }), this.Xi = i, this.startIfEnabled();
    }
    getAndClearBuffer() {
        var t = this.H;
        return this.H = void 0, t;
    }
    ae(t) {
        this.le(t.originalEvent, "deadclick");
    }
    se() {
        $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$o && ($e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "beforeunload", this.ne.bind(this)), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "click", (i)=>this.le(i || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event)), {
            capture: !0
        }), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "mousemove", (i)=>this.ue(i || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event)), {
            capture: !0
        }), this.oe = new $e444d6404c095fa5$var$Ye(this.instance, $e444d6404c095fa5$var$Je, this.ae.bind(this)), this.oe.startIfEnabled(), this.C = !0);
    }
    he(i, e) {
        var r = this.instance.scrollManager.scrollY(), s = this.instance.scrollManager.scrollX(), n = this.instance.scrollManager.scrollElement(), o = function(i, e, r) {
            for(var s = i; s && $e444d6404c095fa5$var$Mi(s) && !$e444d6404c095fa5$var$Oi(s, "body");){
                if (s === r) return !1;
                if ($e444d6404c095fa5$var$y(e, null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.getComputedStyle(s).position)) return !0;
                s = $e444d6404c095fa5$var$Hi(s);
            }
            return !1;
        }($e444d6404c095fa5$var$zi(i), [
            "fixed",
            "sticky"
        ], n);
        return {
            x: i.clientX + (o ? 0 : s),
            y: i.clientY + (o ? 0 : r),
            target_fixed: o,
            type: e
        };
    }
    le(t, i) {
        var e;
        if (void 0 === i && (i = "click"), !$e444d6404c095fa5$var$Ci(t.target) && $e444d6404c095fa5$var$Ws(t)) {
            var r = this.he(t, i);
            null != (e = this.rageclicks) && e.isRageClick(t.clientX, t.clientY, (new Date).getTime()) && this.de($e444d6404c095fa5$var$g({}, r, {
                type: "rageclick"
            })), this.de(r);
        }
    }
    ue(t) {
        !$e444d6404c095fa5$var$Ci(t.target) && $e444d6404c095fa5$var$Ws(t) && (clearTimeout(this.ve), this.ve = setTimeout(()=>{
            this.de(this.he(t, "mousemove"));
        }, 500));
    }
    de(i) {
        if ($e444d6404c095fa5$var$t) {
            var e = $e444d6404c095fa5$var$t.location.href;
            this.H = this.H || {}, this.H[e] || (this.H[e] = []), this.H[e].push(i);
        }
    }
    ne() {
        this.H && !$e444d6404c095fa5$var$T(this.H) && this.instance.capture("$$heatmap", {
            $heatmap_data: this.getAndClearBuffer()
        });
    }
}
class $e444d6404c095fa5$var$Vs {
    constructor(t){
        this._instance = t;
    }
    doPageView(i, e) {
        var r, s = this.ce(i, e);
        return this.fe = {
            pathname: null !== (r = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.location.pathname) && void 0 !== r ? r : "",
            pageViewId: e,
            timestamp: i
        }, this._instance.scrollManager.resetContext(), s;
    }
    doPageLeave(t) {
        var i;
        return this.ce(t, null == (i = this.fe) ? void 0 : i.pageViewId);
    }
    doEvent() {
        var t;
        return {
            $pageview_id: null == (t = this.fe) ? void 0 : t.pageViewId
        };
    }
    ce(t, i) {
        var e = this.fe;
        if (!e) return {
            $pageview_id: i
        };
        var r = {
            $pageview_id: i,
            $prev_pageview_id: e.pageViewId
        }, s = this._instance.scrollManager.getContext();
        if (s && !this._instance.config.disable_scroll_properties) {
            var { maxScrollHeight: n, lastScrollY: o, maxScrollY: a, maxContentHeight: l, lastContentY: u, maxContentY: h } = s;
            if (!($e444d6404c095fa5$var$C(n) || $e444d6404c095fa5$var$C(o) || $e444d6404c095fa5$var$C(a) || $e444d6404c095fa5$var$C(l) || $e444d6404c095fa5$var$C(u) || $e444d6404c095fa5$var$C(h))) {
                n = Math.ceil(n), o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), u = Math.ceil(u), h = Math.ceil(h);
                var d = n <= 1 ? 1 : $e444d6404c095fa5$var$G(o / n, 0, 1, $e444d6404c095fa5$var$xt), v = n <= 1 ? 1 : $e444d6404c095fa5$var$G(a / n, 0, 1, $e444d6404c095fa5$var$xt), c = l <= 1 ? 1 : $e444d6404c095fa5$var$G(u / l, 0, 1, $e444d6404c095fa5$var$xt), f = l <= 1 ? 1 : $e444d6404c095fa5$var$G(h / l, 0, 1, $e444d6404c095fa5$var$xt);
                r = $e444d6404c095fa5$var$Mt(r, {
                    $prev_pageview_last_scroll: o,
                    $prev_pageview_last_scroll_percentage: d,
                    $prev_pageview_max_scroll: a,
                    $prev_pageview_max_scroll_percentage: v,
                    $prev_pageview_last_content: u,
                    $prev_pageview_last_content_percentage: c,
                    $prev_pageview_max_content: h,
                    $prev_pageview_max_content_percentage: f
                });
            }
        }
        return e.pathname && (r.$prev_pageview_pathname = e.pathname), e.timestamp && (r.$prev_pageview_duration = (t.getTime() - e.timestamp.getTime()) / 1e3), r;
    }
}
var $e444d6404c095fa5$var$Js = function(t) {
    var i, e, r, s, n = "";
    for(i = e = 0, r = (t = (t + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, s = 0; s < r; s++){
        var o = t.charCodeAt(s), a = null;
        o < 128 ? e++ : a = o > 127 && o < 2048 ? String.fromCharCode(o >> 6 | 192, 63 & o | 128) : String.fromCharCode(o >> 12 | 224, o >> 6 & 63 | 128, 63 & o | 128), $e444d6404c095fa5$var$F(a) || (e > i && (n += t.substring(i, e)), n += a, i = e = s + 1);
    }
    return e > i && (n += t.substring(i, t.length)), n;
}, $e444d6404c095fa5$var$Ks = !!$e444d6404c095fa5$var$u || !!$e444d6404c095fa5$var$l, $e444d6404c095fa5$var$Ys = "text/plain", $e444d6404c095fa5$var$Xs = (t, i)=>{
    var [e, r] = t.split("?"), s = $e444d6404c095fa5$var$g({}, i);
    null == r || r.split("&").forEach((t)=>{
        var [i] = t.split("=");
        delete s[i];
    });
    var n = $e444d6404c095fa5$var$pe(s);
    return e + "?" + (n = n ? (r ? r + "&" : "") + n : r);
}, $e444d6404c095fa5$var$Qs = (t, i)=>JSON.stringify(t, (t, i)=>"bigint" == typeof i ? i.toString() : i, i), $e444d6404c095fa5$var$Zs = (t)=>{
    var { data: i, compression: e } = t;
    if (i) {
        if (e === $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS) {
            var r = $e444d6404c095fa5$var$Xr($e444d6404c095fa5$var$Qr($e444d6404c095fa5$var$Qs(i)), {
                mtime: 0
            }), s = new Blob([
                r
            ], {
                type: $e444d6404c095fa5$var$Ys
            });
            return {
                contentType: $e444d6404c095fa5$var$Ys,
                body: s,
                estimatedSize: s.size
            };
        }
        if (e === $e444d6404c095fa5$export$6a00d17b5aff0af.Base64) {
            var n = function(t) {
                var i, e, r, s, n, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = 0, l = 0, u = "", h = [];
                if (!t) return t;
                t = $e444d6404c095fa5$var$Js(t);
                do i = (n = t.charCodeAt(a++) << 16 | t.charCodeAt(a++) << 8 | t.charCodeAt(a++)) >> 18 & 63, e = n >> 12 & 63, r = n >> 6 & 63, s = 63 & n, h[l++] = o.charAt(i) + o.charAt(e) + o.charAt(r) + o.charAt(s);
                while (a < t.length);
                switch(u = h.join(""), t.length % 3){
                    case 1:
                        u = u.slice(0, -2) + "==";
                        break;
                    case 2:
                        u = u.slice(0, -1) + "=";
                }
                return u;
            }($e444d6404c095fa5$var$Qs(i)), o = ((t)=>"data=" + encodeURIComponent("string" == typeof t ? t : $e444d6404c095fa5$var$Qs(t)))(n);
            return {
                contentType: "application/x-www-form-urlencoded",
                body: o,
                estimatedSize: new Blob([
                    o
                ]).size
            };
        }
        var a = $e444d6404c095fa5$var$Qs(i);
        return {
            contentType: "application/json",
            body: a,
            estimatedSize: new Blob([
                a
            ]).size
        };
    }
}, $e444d6404c095fa5$var$tn = [];
$e444d6404c095fa5$var$l && $e444d6404c095fa5$var$tn.push({
    transport: "fetch",
    method: (t)=>{
        var i, e, { contentType: r, body: s, estimatedSize: n } = null !== (i = $e444d6404c095fa5$var$Zs(t)) && void 0 !== i ? i : {}, o = new Headers;
        $e444d6404c095fa5$var$Ct(t.headers, function(t, i) {
            o.append(i, t);
        }), r && o.append("Content-Type", r);
        var a = t.url, u = null;
        if ($e444d6404c095fa5$var$h) {
            var d = new $e444d6404c095fa5$var$h;
            u = {
                signal: d.signal,
                timeout: setTimeout(()=>d.abort(), t.timeout)
            };
        }
        $e444d6404c095fa5$var$l(a, $e444d6404c095fa5$var$g({
            method: (null == t ? void 0 : t.method) || "GET",
            headers: o,
            keepalive: "POST" === t.method && (n || 0) < 52428.8,
            body: s,
            signal: null == (e = u) ? void 0 : e.signal
        }, t.fetchOptions)).then((i)=>i.text().then((e)=>{
                var r = {
                    statusCode: i.status,
                    text: e
                };
                if (200 === i.status) try {
                    r.json = JSON.parse(e);
                } catch (t) {
                    $e444d6404c095fa5$var$xt.error(t);
                }
                null == t.callback || t.callback(r);
            })).catch((i)=>{
            $e444d6404c095fa5$var$xt.error(i), null == t.callback || t.callback({
                statusCode: 0,
                text: i
            });
        }).finally(()=>u ? clearTimeout(u.timeout) : null);
    }
}), $e444d6404c095fa5$var$u && $e444d6404c095fa5$var$tn.push({
    transport: "XHR",
    method: (t)=>{
        var i, e = new $e444d6404c095fa5$var$u;
        e.open(t.method || "GET", t.url, !0);
        var { contentType: r, body: s } = null !== (i = $e444d6404c095fa5$var$Zs(t)) && void 0 !== i ? i : {};
        $e444d6404c095fa5$var$Ct(t.headers, function(t, i) {
            e.setRequestHeader(i, t);
        }), r && e.setRequestHeader("Content-Type", r), t.timeout && (e.timeout = t.timeout), t.disableXHRCredentials || (e.withCredentials = !0), e.onreadystatechange = ()=>{
            if (4 === e.readyState) {
                var i = {
                    statusCode: e.status,
                    text: e.responseText
                };
                if (200 === e.status) try {
                    i.json = JSON.parse(e.responseText);
                } catch (t) {}
                null == t.callback || t.callback(i);
            }
        }, e.send(s);
    }
}), null != $e444d6404c095fa5$var$n && $e444d6404c095fa5$var$n.sendBeacon && $e444d6404c095fa5$var$tn.push({
    transport: "sendBeacon",
    method: (t)=>{
        var i = $e444d6404c095fa5$var$Xs(t.url, {
            beacon: "1"
        });
        try {
            var e, { contentType: r, body: s } = null !== (e = $e444d6404c095fa5$var$Zs(t)) && void 0 !== e ? e : {}, o = "string" == typeof s ? new Blob([
                s
            ], {
                type: r
            }) : s;
            $e444d6404c095fa5$var$n.sendBeacon(i, o);
        } catch (t) {}
    }
});
var $e444d6404c095fa5$var$en = function(t, i) {
    if (!function(t) {
        try {
            new RegExp(t);
        } catch (t) {
            return !1;
        }
        return !0;
    }(i)) return !1;
    try {
        return new RegExp(i).test(t);
    } catch (t) {
        return !1;
    }
};
function $e444d6404c095fa5$var$rn(t, i, e) {
    return $e444d6404c095fa5$var$Qs({
        distinct_id: t,
        userPropertiesToSet: i,
        userPropertiesToSetOnce: e
    });
}
var $e444d6404c095fa5$var$sn = {
    exact: (t, i)=>i.some((i)=>t.some((t)=>i === t)),
    is_not: (t, i)=>i.every((i)=>t.every((t)=>i !== t)),
    regex: (t, i)=>i.some((i)=>t.some((t)=>$e444d6404c095fa5$var$en(i, t))),
    not_regex: (t, i)=>i.every((i)=>t.every((t)=>!$e444d6404c095fa5$var$en(i, t))),
    icontains: (t, i)=>i.map($e444d6404c095fa5$var$nn).some((i)=>t.map($e444d6404c095fa5$var$nn).some((t)=>i.includes(t))),
    not_icontains: (t, i)=>i.map($e444d6404c095fa5$var$nn).every((i)=>t.map($e444d6404c095fa5$var$nn).every((t)=>!i.includes(t)))
}, $e444d6404c095fa5$var$nn = (t)=>t.toLowerCase(), $e444d6404c095fa5$var$on = $e444d6404c095fa5$var$Et("[Error tracking]");
class $e444d6404c095fa5$var$an {
    constructor(t){
        var i, e;
        this.pe = [], this.ge = new $e444d6404c095fa5$var$vt([
            new $e444d6404c095fa5$var$ct,
            new $e444d6404c095fa5$var$kt,
            new $e444d6404c095fa5$var$pt,
            new $e444d6404c095fa5$var$ft,
            new $e444d6404c095fa5$var$wt,
            new $e444d6404c095fa5$var$bt,
            new $e444d6404c095fa5$var$_t,
            new $e444d6404c095fa5$var$St
        ], [
            $e444d6404c095fa5$var$nt,
            $e444d6404c095fa5$var$lt
        ]), this._instance = t, this.pe = null !== (i = null == (e = this._instance.persistence) ? void 0 : e.get_property($e444d6404c095fa5$var$Kt)) && void 0 !== i ? i : [];
    }
    onRemoteConfig(t) {
        var i, e, r, s = null !== (i = null == (e = t.errorTracking) ? void 0 : e.suppressionRules) && void 0 !== i ? i : [], n = null == (r = t.errorTracking) ? void 0 : r.captureExtensionExceptions;
        this.pe = s, this._instance.persistence && this._instance.persistence.register({
            [$e444d6404c095fa5$var$Kt]: this.pe,
            [$e444d6404c095fa5$var$Yt]: n
        });
    }
    get _e() {
        var t, i = !!this._instance.get_property($e444d6404c095fa5$var$Yt), e = this._instance.config.error_tracking.captureExtensionExceptions;
        return null !== (t = null != e ? e : i) && void 0 !== t && t;
    }
    buildProperties(t, i) {
        return this.ge.buildFromUnknown(t, {
            syntheticException: null == i ? void 0 : i.syntheticException,
            mechanism: {
                handled: null == i ? void 0 : i.handled
            }
        });
    }
    sendExceptionEvent(t) {
        if (this.me(t)) $e444d6404c095fa5$var$on.info("Skipping exception capture because a suppression rule matched");
        else {
            if (this._e || !this.ye(t)) return this._instance.capture("$exception", t, {
                _noTruncate: !0,
                _batchKey: "exceptionEvent"
            });
            $e444d6404c095fa5$var$on.info("Skipping exception capture because it was thrown by an extension");
        }
    }
    me(t) {
        var i = t.$exception_list;
        if (!i || !$e444d6404c095fa5$var$P(i) || 0 === i.length) return !1;
        var e = i.reduce((t, i)=>{
            var { type: e, value: r } = i;
            return $e444d6404c095fa5$var$M(e) && e.length > 0 && t.$exception_types.push(e), $e444d6404c095fa5$var$M(r) && r.length > 0 && t.$exception_values.push(r), t;
        }, {
            $exception_types: [],
            $exception_values: []
        });
        return this.pe.some((t)=>{
            var i = t.values.map((t)=>{
                var i, r = $e444d6404c095fa5$var$sn[t.operator], s = $e444d6404c095fa5$var$P(t.value) ? t.value : [
                    t.value
                ], n = null !== (i = e[t.key]) && void 0 !== i ? i : [];
                return s.length > 0 && r(s, n);
            });
            return "OR" === t.type ? i.some(Boolean) : i.every(Boolean);
        });
    }
    ye(t) {
        var i = t.$exception_list;
        return !(!i || !$e444d6404c095fa5$var$P(i)) && i.flatMap((t)=>{
            var i, e;
            return null !== (i = null == (e = t.stacktrace) ? void 0 : e.frames) && void 0 !== i ? i : [];
        }).some((t)=>t.filename && t.filename.startsWith("chrome-extension://"));
    }
}
var $e444d6404c095fa5$var$ln = "Mobile", $e444d6404c095fa5$var$un = "iOS", $e444d6404c095fa5$var$hn = "Android", $e444d6404c095fa5$var$dn = "Tablet", $e444d6404c095fa5$var$vn = $e444d6404c095fa5$var$hn + " " + $e444d6404c095fa5$var$dn, $e444d6404c095fa5$var$cn = "iPad", $e444d6404c095fa5$var$fn = "Apple", $e444d6404c095fa5$var$pn = $e444d6404c095fa5$var$fn + " Watch", $e444d6404c095fa5$var$gn = "Safari", $e444d6404c095fa5$var$_n = "BlackBerry", $e444d6404c095fa5$var$mn = "Samsung", $e444d6404c095fa5$var$yn = $e444d6404c095fa5$var$mn + "Browser", $e444d6404c095fa5$var$bn = $e444d6404c095fa5$var$mn + " Internet", $e444d6404c095fa5$var$wn = "Chrome", $e444d6404c095fa5$var$Sn = $e444d6404c095fa5$var$wn + " OS", $e444d6404c095fa5$var$kn = $e444d6404c095fa5$var$wn + " " + $e444d6404c095fa5$var$un, $e444d6404c095fa5$var$$n = "Internet Explorer", $e444d6404c095fa5$var$xn = $e444d6404c095fa5$var$$n + " " + $e444d6404c095fa5$var$ln, $e444d6404c095fa5$var$En = "Opera", $e444d6404c095fa5$var$Pn = $e444d6404c095fa5$var$En + " Mini", $e444d6404c095fa5$var$In = "Edge", $e444d6404c095fa5$var$Rn = "Microsoft " + $e444d6404c095fa5$var$In, $e444d6404c095fa5$var$Tn = "Firefox", $e444d6404c095fa5$var$Cn = $e444d6404c095fa5$var$Tn + " " + $e444d6404c095fa5$var$un, $e444d6404c095fa5$var$Mn = "Nintendo", $e444d6404c095fa5$var$On = "PlayStation", $e444d6404c095fa5$var$Fn = "Xbox", $e444d6404c095fa5$var$An = $e444d6404c095fa5$var$hn + " " + $e444d6404c095fa5$var$ln, $e444d6404c095fa5$var$Dn = $e444d6404c095fa5$var$ln + " " + $e444d6404c095fa5$var$gn, $e444d6404c095fa5$var$jn = "Windows", $e444d6404c095fa5$var$Ln = $e444d6404c095fa5$var$jn + " Phone", $e444d6404c095fa5$var$Nn = "Nokia", $e444d6404c095fa5$var$Un = "Ouya", $e444d6404c095fa5$var$zn = "Generic", $e444d6404c095fa5$var$qn = $e444d6404c095fa5$var$zn + " " + $e444d6404c095fa5$var$ln.toLowerCase(), $e444d6404c095fa5$var$Bn = $e444d6404c095fa5$var$zn + " " + $e444d6404c095fa5$var$dn.toLowerCase(), $e444d6404c095fa5$var$Hn = "Konqueror", $e444d6404c095fa5$var$Wn = "(\\d+(\\.\\d+)?)", $e444d6404c095fa5$var$Gn = new RegExp("Version/" + $e444d6404c095fa5$var$Wn), $e444d6404c095fa5$var$Vn = new RegExp($e444d6404c095fa5$var$Fn, "i"), $e444d6404c095fa5$var$Jn = new RegExp($e444d6404c095fa5$var$On + " \\w+", "i"), $e444d6404c095fa5$var$Kn = new RegExp($e444d6404c095fa5$var$Mn + " \\w+", "i"), $e444d6404c095fa5$var$Yn = new RegExp($e444d6404c095fa5$var$_n + "|PlayBook|BB10", "i"), $e444d6404c095fa5$var$Xn = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
};
var $e444d6404c095fa5$var$Qn = (t, i)=>i && $e444d6404c095fa5$var$y(i, $e444d6404c095fa5$var$fn) || function(t) {
        return $e444d6404c095fa5$var$y(t, $e444d6404c095fa5$var$gn) && !$e444d6404c095fa5$var$y(t, $e444d6404c095fa5$var$wn) && !$e444d6404c095fa5$var$y(t, $e444d6404c095fa5$var$hn);
    }(t), $e444d6404c095fa5$var$Zn = function(t, i) {
    return i = i || "", $e444d6404c095fa5$var$y(t, " OPR/") && $e444d6404c095fa5$var$y(t, "Mini") ? $e444d6404c095fa5$var$Pn : $e444d6404c095fa5$var$y(t, " OPR/") ? $e444d6404c095fa5$var$En : $e444d6404c095fa5$var$Yn.test(t) ? $e444d6404c095fa5$var$_n : $e444d6404c095fa5$var$y(t, "IE" + $e444d6404c095fa5$var$ln) || $e444d6404c095fa5$var$y(t, "WPDesktop") ? $e444d6404c095fa5$var$xn : $e444d6404c095fa5$var$y(t, $e444d6404c095fa5$var$yn) ? $e444d6404c095fa5$var$bn : $e444d6404c095fa5$var$y(t, $e444d6404c095fa5$var$In) || $e444d6404c095fa5$var$y(t, "Edg/") ? $e444d6404c095fa5$var$Rn : $e444d6404c095fa5$var$y(t, "FBIOS") ? "Facebook " + $e444d6404c095fa5$var$ln : $e444d6404c095fa5$var$y(t, "UCWEB") || $e444d6404c095fa5$var$y(t, "UCBrowser") ? "UC Browser" : $e444d6404c095fa5$var$y(t, "CriOS") ? $e444d6404c095fa5$var$kn : $e444d6404c095fa5$var$y(t, "CrMo") || $e444d6404c095fa5$var$y(t, $e444d6404c095fa5$var$wn) ? $e444d6404c095fa5$var$wn : $e444d6404c095fa5$var$y(t, $e444d6404c095fa5$var$hn) && $e444d6404c095fa5$var$y(t, $e444d6404c095fa5$var$gn) ? $e444d6404c095fa5$var$An : $e444d6404c095fa5$var$y(t, "FxiOS") ? $e444d6404c095fa5$var$Cn : $e444d6404c095fa5$var$y(t.toLowerCase(), $e444d6404c095fa5$var$Hn.toLowerCase()) ? $e444d6404c095fa5$var$Hn : $e444d6404c095fa5$var$Qn(t, i) ? $e444d6404c095fa5$var$y(t, $e444d6404c095fa5$var$ln) ? $e444d6404c095fa5$var$Dn : $e444d6404c095fa5$var$gn : $e444d6404c095fa5$var$y(t, $e444d6404c095fa5$var$Tn) ? $e444d6404c095fa5$var$Tn : $e444d6404c095fa5$var$y(t, "MSIE") || $e444d6404c095fa5$var$y(t, "Trident/") ? $e444d6404c095fa5$var$$n : $e444d6404c095fa5$var$y(t, "Gecko") ? $e444d6404c095fa5$var$Tn : "";
}, $e444d6404c095fa5$var$to = {
    [$e444d6404c095fa5$var$xn]: [
        new RegExp("rv:" + $e444d6404c095fa5$var$Wn)
    ],
    [$e444d6404c095fa5$var$Rn]: [
        new RegExp($e444d6404c095fa5$var$In + "?\\/" + $e444d6404c095fa5$var$Wn)
    ],
    [$e444d6404c095fa5$var$wn]: [
        new RegExp("(" + $e444d6404c095fa5$var$wn + "|CrMo)\\/" + $e444d6404c095fa5$var$Wn)
    ],
    [$e444d6404c095fa5$var$kn]: [
        new RegExp("CriOS\\/" + $e444d6404c095fa5$var$Wn)
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/" + $e444d6404c095fa5$var$Wn)
    ],
    [$e444d6404c095fa5$var$gn]: [
        $e444d6404c095fa5$var$Gn
    ],
    [$e444d6404c095fa5$var$Dn]: [
        $e444d6404c095fa5$var$Gn
    ],
    [$e444d6404c095fa5$var$En]: [
        new RegExp("(Opera|OPR)\\/" + $e444d6404c095fa5$var$Wn)
    ],
    [$e444d6404c095fa5$var$Tn]: [
        new RegExp($e444d6404c095fa5$var$Tn + "\\/" + $e444d6404c095fa5$var$Wn)
    ],
    [$e444d6404c095fa5$var$Cn]: [
        new RegExp("FxiOS\\/" + $e444d6404c095fa5$var$Wn)
    ],
    [$e444d6404c095fa5$var$Hn]: [
        new RegExp("Konqueror[:/]?" + $e444d6404c095fa5$var$Wn, "i")
    ],
    [$e444d6404c095fa5$var$_n]: [
        new RegExp($e444d6404c095fa5$var$_n + " " + $e444d6404c095fa5$var$Wn),
        $e444d6404c095fa5$var$Gn
    ],
    [$e444d6404c095fa5$var$An]: [
        new RegExp("android\\s" + $e444d6404c095fa5$var$Wn, "i")
    ],
    [$e444d6404c095fa5$var$bn]: [
        new RegExp($e444d6404c095fa5$var$yn + "\\/" + $e444d6404c095fa5$var$Wn)
    ],
    [$e444d6404c095fa5$var$$n]: [
        new RegExp("(rv:|MSIE )" + $e444d6404c095fa5$var$Wn)
    ],
    Mozilla: [
        new RegExp("rv:" + $e444d6404c095fa5$var$Wn)
    ]
}, $e444d6404c095fa5$var$io = function(t, i) {
    var e = $e444d6404c095fa5$var$Zn(t, i), r = $e444d6404c095fa5$var$to[e];
    if ($e444d6404c095fa5$var$C(r)) return null;
    for(var s = 0; s < r.length; s++){
        var n = r[s], o = t.match(n);
        if (o) return parseFloat(o[o.length - 2]);
    }
    return null;
}, $e444d6404c095fa5$var$eo = [
    [
        new RegExp($e444d6404c095fa5$var$Fn + "; " + $e444d6404c095fa5$var$Fn + " (.*?)[);]", "i"),
        (t)=>[
                $e444d6404c095fa5$var$Fn,
                t && t[1] || ""
            ]
    ],
    [
        new RegExp($e444d6404c095fa5$var$Mn, "i"),
        [
            $e444d6404c095fa5$var$Mn,
            ""
        ]
    ],
    [
        new RegExp($e444d6404c095fa5$var$On, "i"),
        [
            $e444d6404c095fa5$var$On,
            ""
        ]
    ],
    [
        $e444d6404c095fa5$var$Yn,
        [
            $e444d6404c095fa5$var$_n,
            ""
        ]
    ],
    [
        new RegExp($e444d6404c095fa5$var$jn, "i"),
        (t, i)=>{
            if (/Phone/.test(i) || /WPDesktop/.test(i)) return [
                $e444d6404c095fa5$var$Ln,
                ""
            ];
            if (new RegExp($e444d6404c095fa5$var$ln).test(i) && !/IEMobile\b/.test(i)) return [
                $e444d6404c095fa5$var$jn + " " + $e444d6404c095fa5$var$ln,
                ""
            ];
            var e = /Windows NT ([0-9.]+)/i.exec(i);
            if (e && e[1]) {
                var r = e[1], s = $e444d6404c095fa5$var$Xn[r] || "";
                return /arm/i.test(i) && (s = "RT"), [
                    $e444d6404c095fa5$var$jn,
                    s
                ];
            }
            return [
                $e444d6404c095fa5$var$jn,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (t)=>{
            if (t && t[3]) {
                var i = [
                    t[3],
                    t[4],
                    t[5] || "0"
                ];
                return [
                    $e444d6404c095fa5$var$un,
                    i.join(".")
                ];
            }
            return [
                $e444d6404c095fa5$var$un,
                ""
            ];
        }
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (t)=>{
            var i = "";
            return t && t.length >= 3 && (i = $e444d6404c095fa5$var$C(t[2]) ? t[3] : t[2]), [
                "watchOS",
                i
            ];
        }
    ],
    [
        new RegExp("(" + $e444d6404c095fa5$var$hn + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $e444d6404c095fa5$var$hn + ")", "i"),
        (t)=>{
            if (t && t[2]) {
                var i = [
                    t[2],
                    t[3],
                    t[4] || "0"
                ];
                return [
                    $e444d6404c095fa5$var$hn,
                    i.join(".")
                ];
            }
            return [
                $e444d6404c095fa5$var$hn,
                ""
            ];
        }
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (t)=>{
            var i = [
                "Mac OS X",
                ""
            ];
            if (t && t[1]) {
                var e = [
                    t[1],
                    t[2],
                    t[3] || "0"
                ];
                i[1] = e.join(".");
            }
            return i;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            $e444d6404c095fa5$var$Sn,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $e444d6404c095fa5$var$ro = function(t) {
    return $e444d6404c095fa5$var$Kn.test(t) ? $e444d6404c095fa5$var$Mn : $e444d6404c095fa5$var$Jn.test(t) ? $e444d6404c095fa5$var$On : $e444d6404c095fa5$var$Vn.test(t) ? $e444d6404c095fa5$var$Fn : new RegExp($e444d6404c095fa5$var$Un, "i").test(t) ? $e444d6404c095fa5$var$Un : new RegExp("(" + $e444d6404c095fa5$var$Ln + "|WPDesktop)", "i").test(t) ? $e444d6404c095fa5$var$Ln : /iPad/.test(t) ? $e444d6404c095fa5$var$cn : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(t) ? $e444d6404c095fa5$var$pn : $e444d6404c095fa5$var$Yn.test(t) ? $e444d6404c095fa5$var$_n : /(kobo)\s(ereader|touch)/i.test(t) ? "Kobo" : new RegExp($e444d6404c095fa5$var$Nn, "i").test(t) ? $e444d6404c095fa5$var$Nn : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(t) || /(kf[a-z]+)( bui|\)).+silk\//i.test(t) ? "Kindle Fire" : /(Android|ZTE)/i.test(t) ? !new RegExp($e444d6404c095fa5$var$ln).test(t) || /(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(t) ? /pixel[\daxl ]{1,6}/i.test(t) && !/pixel c/i.test(t) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(t) || /lmy47v/i.test(t) && !/QTAQZ3/i.test(t) ? $e444d6404c095fa5$var$hn : $e444d6404c095fa5$var$vn : $e444d6404c095fa5$var$hn : new RegExp("(pda|" + $e444d6404c095fa5$var$ln + ")", "i").test(t) ? $e444d6404c095fa5$var$qn : new RegExp($e444d6404c095fa5$var$dn, "i").test(t) && !new RegExp($e444d6404c095fa5$var$dn + " pc", "i").test(t) ? $e444d6404c095fa5$var$Bn : "";
}, $e444d6404c095fa5$var$so = "https?://(.*)", $e444d6404c095fa5$var$no = [
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "irclid",
    "_kx"
], $e444d6404c095fa5$var$oo = $e444d6404c095fa5$var$Ot([
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid"
], $e444d6404c095fa5$var$no), $e444d6404c095fa5$var$ao = "<masked>", $e444d6404c095fa5$var$lo = [
    "li_fat_id"
];
function $e444d6404c095fa5$var$uo(t, i, e) {
    if (!$e444d6404c095fa5$var$o) return {};
    var r, s = i ? $e444d6404c095fa5$var$Ot([], $e444d6404c095fa5$var$no, e || []) : [], n = $e444d6404c095fa5$var$ho($e444d6404c095fa5$var$_e($e444d6404c095fa5$var$o.URL, s, $e444d6404c095fa5$var$ao), t), a = (r = {}, $e444d6404c095fa5$var$Ct($e444d6404c095fa5$var$lo, function(t) {
        var i = $e444d6404c095fa5$var$De.J(t);
        r[t] = i || null;
    }), r);
    return $e444d6404c095fa5$var$Mt(a, n);
}
function $e444d6404c095fa5$var$ho(t, i) {
    var e = $e444d6404c095fa5$var$oo.concat(i || []), r = {};
    return $e444d6404c095fa5$var$Ct(e, function(i) {
        var e = $e444d6404c095fa5$var$ge(t, i);
        r[i] = e || null;
    }), r;
}
function $e444d6404c095fa5$var$vo(t) {
    var i = function(t) {
        return t ? 0 === t.search($e444d6404c095fa5$var$so + "google.([^/?]*)") ? "google" : 0 === t.search($e444d6404c095fa5$var$so + "bing.com") ? "bing" : 0 === t.search($e444d6404c095fa5$var$so + "yahoo.com") ? "yahoo" : 0 === t.search($e444d6404c095fa5$var$so + "duckduckgo.com") ? "duckduckgo" : null : null;
    }(t), e = "yahoo" != i ? "q" : "p", r = {};
    if (!$e444d6404c095fa5$var$F(i)) {
        r.$search_engine = i;
        var s = $e444d6404c095fa5$var$o ? $e444d6404c095fa5$var$ge($e444d6404c095fa5$var$o.referrer, e) : "";
        s.length && (r.ph_keyword = s);
    }
    return r;
}
function $e444d6404c095fa5$var$co() {
    return navigator.language || navigator.userLanguage;
}
function $e444d6404c095fa5$var$fo() {
    return (null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.referrer) || "$direct";
}
function $e444d6404c095fa5$var$po(t, i) {
    var e = t ? $e444d6404c095fa5$var$Ot([], $e444d6404c095fa5$var$no, i || []) : [], r = null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.href.substring(0, 1e3);
    return {
        r: $e444d6404c095fa5$var$fo().substring(0, 1e3),
        u: r ? $e444d6404c095fa5$var$_e(r, e, $e444d6404c095fa5$var$ao) : void 0
    };
}
function $e444d6404c095fa5$var$go(t) {
    var i, { r: e, u: r } = t, s = {
        $referrer: e,
        $referring_domain: null == e ? void 0 : "$direct" == e ? "$direct" : null == (i = $e444d6404c095fa5$var$fe(e)) ? void 0 : i.host
    };
    if (r) {
        s.$current_url = r;
        var n = $e444d6404c095fa5$var$fe(r);
        s.$host = null == n ? void 0 : n.host, s.$pathname = null == n ? void 0 : n.pathname;
        var o = $e444d6404c095fa5$var$ho(r);
        $e444d6404c095fa5$var$Mt(s, o);
    }
    if (e) {
        var a = $e444d6404c095fa5$var$vo(e);
        $e444d6404c095fa5$var$Mt(s, a);
    }
    return s;
}
function $e444d6404c095fa5$var$_o() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (t) {
        return;
    }
}
function $e444d6404c095fa5$var$mo() {
    try {
        return (new Date).getTimezoneOffset();
    } catch (t) {
        return;
    }
}
function $e444d6404c095fa5$var$yo(i, e) {
    if (!$e444d6404c095fa5$var$d) return {};
    var r, s, n, o = i ? $e444d6404c095fa5$var$Ot([], $e444d6404c095fa5$var$no, e || []) : [], [l, u] = function(t) {
        for(var i = 0; i < $e444d6404c095fa5$var$eo.length; i++){
            var [e, r] = $e444d6404c095fa5$var$eo[i], s = e.exec(t), n = s && ($e444d6404c095fa5$var$I(r) ? r(s, t) : r);
            if (n) return n;
        }
        return [
            "",
            ""
        ];
    }($e444d6404c095fa5$var$d);
    return $e444d6404c095fa5$var$Mt($e444d6404c095fa5$var$jt({
        $os: l,
        $os_version: u,
        $browser: $e444d6404c095fa5$var$Zn($e444d6404c095fa5$var$d, navigator.vendor),
        $device: $e444d6404c095fa5$var$ro($e444d6404c095fa5$var$d),
        $device_type: (s = $e444d6404c095fa5$var$d, n = $e444d6404c095fa5$var$ro(s), n === $e444d6404c095fa5$var$cn || n === $e444d6404c095fa5$var$vn || "Kobo" === n || "Kindle Fire" === n || n === $e444d6404c095fa5$var$Bn ? $e444d6404c095fa5$var$dn : n === $e444d6404c095fa5$var$Mn || n === $e444d6404c095fa5$var$Fn || n === $e444d6404c095fa5$var$On || n === $e444d6404c095fa5$var$Un ? "Console" : n === $e444d6404c095fa5$var$pn ? "Wearable" : n ? $e444d6404c095fa5$var$ln : "Desktop"),
        $timezone: $e444d6404c095fa5$var$_o(),
        $timezone_offset: $e444d6404c095fa5$var$mo()
    }), {
        $current_url: $e444d6404c095fa5$var$_e(null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.href, o, $e444d6404c095fa5$var$ao),
        $host: null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.host,
        $pathname: null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.pathname,
        $raw_user_agent: $e444d6404c095fa5$var$d.length > 1e3 ? $e444d6404c095fa5$var$d.substring(0, 997) + "..." : $e444d6404c095fa5$var$d,
        $browser_version: $e444d6404c095fa5$var$io($e444d6404c095fa5$var$d, navigator.vendor),
        $browser_language: $e444d6404c095fa5$var$co(),
        $browser_language_prefix: (r = $e444d6404c095fa5$var$co(), "string" == typeof r ? r.split("-")[0] : void 0),
        $screen_height: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.screen.height,
        $screen_width: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.screen.width,
        $viewport_height: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.innerHeight,
        $viewport_width: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.innerWidth,
        $lib: "web",
        $lib_version: $e444d6404c095fa5$var$c.LIB_VERSION,
        $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
        $time: Date.now() / 1e3
    });
}
var $e444d6404c095fa5$var$bo = $e444d6404c095fa5$var$Et("[FeatureFlags]"), $e444d6404c095fa5$var$wo = "$active_feature_flags", $e444d6404c095fa5$var$So = "$override_feature_flags", $e444d6404c095fa5$var$ko = "$feature_flag_payloads", $e444d6404c095fa5$var$$o = "$override_feature_flag_payloads", $e444d6404c095fa5$var$xo = "$feature_flag_request_id", $e444d6404c095fa5$var$Eo = (t)=>{
    var i = {};
    for (var [e, r] of $e444d6404c095fa5$var$Ft(t || {}))r && (i[e] = r);
    return i;
}, $e444d6404c095fa5$var$Po = (t)=>{
    var i = t.flags;
    return i ? (t.featureFlags = Object.fromEntries(Object.keys(i).map((t)=>{
        var e;
        return [
            t,
            null !== (e = i[t].variant) && void 0 !== e ? e : i[t].enabled
        ];
    })), t.featureFlagPayloads = Object.fromEntries(Object.keys(i).filter((t)=>i[t].enabled).filter((t)=>{
        var e;
        return null == (e = i[t].metadata) ? void 0 : e.payload;
    }).map((t)=>{
        var e;
        return [
            t,
            null == (e = i[t].metadata) ? void 0 : e.payload
        ];
    }))) : $e444d6404c095fa5$var$bo.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), t;
}, $e444d6404c095fa5$var$Io = function(t) {
    return t.FeatureFlags = "feature_flags", t.Recordings = "recordings", t;
}({});
class $e444d6404c095fa5$var$Ro {
    constructor(t){
        this.be = !1, this.we = !1, this.Se = !1, this.ke = !1, this.$e = !1, this.xe = !1, this.Ee = !1, this._instance = t, this.featureFlagEventHandlers = [];
    }
    flags() {
        if (this._instance.config.__preview_remote_config) this.xe = !0;
        else {
            var t = !this.Pe && (this._instance.config.advanced_disable_feature_flags || this._instance.config.advanced_disable_feature_flags_on_first_load);
            this.Ie({
                disableFlags: t
            });
        }
    }
    get hasLoadedFlags() {
        return this.we;
    }
    getFlags() {
        return Object.keys(this.getFlagVariants());
    }
    getFlagsWithDetails() {
        var t = this._instance.get_property($e444d6404c095fa5$var$pi), i = this._instance.get_property($e444d6404c095fa5$var$So), e = this._instance.get_property($e444d6404c095fa5$var$$o);
        if (!e && !i) return t || {};
        var r = $e444d6404c095fa5$var$Mt({}, t || {}), s = [
            ...new Set([
                ...Object.keys(e || {}),
                ...Object.keys(i || {})
            ])
        ];
        for (var n of s){
            var o, a, l = r[n], u = null == i ? void 0 : i[n], h = $e444d6404c095fa5$var$C(u) ? null !== (o = null == l ? void 0 : l.enabled) && void 0 !== o && o : !!u, d = $e444d6404c095fa5$var$C(u) ? l.variant : "string" == typeof u ? u : void 0, v = null == e ? void 0 : e[n], c = $e444d6404c095fa5$var$g({}, l, {
                enabled: h,
                variant: h ? null != d ? d : null == l ? void 0 : l.variant : void 0
            });
            if (h !== (null == l ? void 0 : l.enabled) && (c.original_enabled = null == l ? void 0 : l.enabled), d !== (null == l ? void 0 : l.variant) && (c.original_variant = null == l ? void 0 : l.variant), v) c.metadata = $e444d6404c095fa5$var$g({}, null == l ? void 0 : l.metadata, {
                payload: v,
                original_payload: null == l || null == (a = l.metadata) ? void 0 : a.payload
            });
            r[n] = c;
        }
        return this.be || ($e444d6404c095fa5$var$bo.warn(" Overriding feature flag details!", {
            flagDetails: t,
            overriddenPayloads: e,
            finalDetails: r
        }), this.be = !0), r;
    }
    getFlagVariants() {
        var t = this._instance.get_property($e444d6404c095fa5$var$ci), i = this._instance.get_property($e444d6404c095fa5$var$So);
        if (!i) return t || {};
        for(var e = $e444d6404c095fa5$var$Mt({}, t), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.be || ($e444d6404c095fa5$var$bo.warn(" Overriding feature flags!", {
            enabledFlags: t,
            overriddenFlags: i,
            finalFlags: e
        }), this.be = !0), e;
    }
    getFlagPayloads() {
        var t = this._instance.get_property($e444d6404c095fa5$var$ko), i = this._instance.get_property($e444d6404c095fa5$var$$o);
        if (!i) return t || {};
        for(var e = $e444d6404c095fa5$var$Mt({}, t || {}), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.be || ($e444d6404c095fa5$var$bo.warn(" Overriding feature flag payloads!", {
            flagPayloads: t,
            overriddenPayloads: i,
            finalPayloads: e
        }), this.be = !0), e;
    }
    reloadFeatureFlags() {
        this.ke || this._instance.config.advanced_disable_feature_flags || this.Pe || (this.Pe = setTimeout(()=>{
            this.Ie();
        }, 5));
    }
    Re() {
        clearTimeout(this.Pe), this.Pe = void 0;
    }
    ensureFlagsLoaded() {
        this.we || this.Se || this.Pe || this.reloadFeatureFlags();
    }
    setAnonymousDistinctId(t) {
        this.$anon_distinct_id = t;
    }
    setReloadingPaused(t) {
        this.ke = t;
    }
    Ie(t) {
        var i;
        if (this.Re(), !this._instance.L()) {
            if (this.Se) this.$e = !0;
            else {
                var e = {
                    token: this._instance.config.token,
                    distinct_id: this._instance.get_distinct_id(),
                    groups: this._instance.getGroups(),
                    $anon_distinct_id: this.$anon_distinct_id,
                    person_properties: $e444d6404c095fa5$var$g({}, (null == (i = this._instance.persistence) ? void 0 : i.get_initial_props()) || {}, this._instance.get_property($e444d6404c095fa5$var$gi) || {}),
                    group_properties: this._instance.get_property($e444d6404c095fa5$var$_i)
                };
                (null != t && t.disableFlags || this._instance.config.advanced_disable_feature_flags) && (e.disable_flags = !0);
                var r = this._instance.config.__preview_remote_config, s = r ? "/flags/?v=2" : "/flags/?v=2&config=true", n = this._instance.config.advanced_only_evaluate_survey_feature_flags ? "&only_evaluate_survey_feature_flags=true" : "", o = this._instance.requestRouter.endpointFor("api", s + n);
                r && (e.timezone = $e444d6404c095fa5$var$_o()), this.Se = !0, this._instance.Te({
                    method: "POST",
                    url: o,
                    data: e,
                    compression: this._instance.config.disable_compression ? void 0 : $e444d6404c095fa5$export$6a00d17b5aff0af.Base64,
                    timeout: this._instance.config.feature_flag_request_timeout_ms,
                    callback: (t)=>{
                        var i, r, s = !0;
                        (200 === t.statusCode && (this.$e || (this.$anon_distinct_id = void 0), s = !1), this.Se = !1, this.xe) || (this.xe = !0, this._instance.Ce(null !== (r = t.json) && void 0 !== r ? r : {}));
                        if (!e.disable_flags || this.$e) {
                            if (this.Ee = !s, t.json && null != (i = t.json.quotaLimited) && i.includes($e444d6404c095fa5$var$Io.FeatureFlags)) $e444d6404c095fa5$var$bo.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.");
                            else {
                                var n;
                                if (!e.disable_flags) this.receivedFeatureFlags(null !== (n = t.json) && void 0 !== n ? n : {}, s);
                                this.$e && (this.$e = !1, this.Ie());
                            }
                        }
                    }
                });
            }
        }
    }
    getFeatureFlag(t, i) {
        if (void 0 === i && (i = {}), this.we || this.getFlags() && this.getFlags().length > 0) {
            var e = this.getFlagVariants()[t], r = "" + e, s = this._instance.get_property($e444d6404c095fa5$var$xo) || void 0, n = this._instance.get_property($e444d6404c095fa5$var$bi) || {};
            if ((i.send_event || !("send_event" in i)) && (!(t in n) || !n[t].includes(r))) {
                var o, a, l, u, h, d, v, c, f;
                $e444d6404c095fa5$var$P(n[t]) ? n[t].push(r) : n[t] = [
                    r
                ], null == (o = this._instance.persistence) || o.register({
                    [$e444d6404c095fa5$var$bi]: n
                });
                var p = this.getFeatureFlagDetails(t), g = {
                    $feature_flag: t,
                    $feature_flag_response: e,
                    $feature_flag_payload: this.getFeatureFlagPayload(t) || null,
                    $feature_flag_request_id: s,
                    $feature_flag_bootstrapped_response: (null == (a = this._instance.config.bootstrap) || null == (a = a.featureFlags) ? void 0 : a[t]) || null,
                    $feature_flag_bootstrapped_payload: (null == (l = this._instance.config.bootstrap) || null == (l = l.featureFlagPayloads) ? void 0 : l[t]) || null,
                    $used_bootstrap_value: !this.Ee
                };
                $e444d6404c095fa5$var$C(null == p || null == (u = p.metadata) ? void 0 : u.version) || (g.$feature_flag_version = p.metadata.version);
                var _, m = null !== (h = null == p || null == (d = p.reason) ? void 0 : d.description) && void 0 !== h ? h : null == p || null == (v = p.reason) ? void 0 : v.code;
                if (m && (g.$feature_flag_reason = m), null != p && null != (c = p.metadata) && c.id && (g.$feature_flag_id = p.metadata.id), $e444d6404c095fa5$var$C(null == p ? void 0 : p.original_variant) && $e444d6404c095fa5$var$C(null == p ? void 0 : p.original_enabled) || (g.$feature_flag_original_response = $e444d6404c095fa5$var$C(p.original_variant) ? p.original_enabled : p.original_variant), null != p && null != (f = p.metadata) && f.original_payload) g.$feature_flag_original_payload = null == p || null == (_ = p.metadata) ? void 0 : _.original_payload;
                this._instance.capture("$feature_flag_called", g);
            }
            return e;
        }
        $e444d6404c095fa5$var$bo.warn('getFeatureFlag for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    getFeatureFlagDetails(t) {
        return this.getFlagsWithDetails()[t];
    }
    getFeatureFlagPayload(t) {
        return this.getFlagPayloads()[t];
    }
    getRemoteConfigPayload(t, i) {
        var e = this._instance.config.token;
        this._instance.Te({
            method: "POST",
            url: this._instance.requestRouter.endpointFor("api", "/flags/?v=2&config=true"),
            data: {
                distinct_id: this._instance.get_distinct_id(),
                token: e
            },
            compression: this._instance.config.disable_compression ? void 0 : $e444d6404c095fa5$export$6a00d17b5aff0af.Base64,
            timeout: this._instance.config.feature_flag_request_timeout_ms,
            callback: (e)=>{
                var r, s = null == (r = e.json) ? void 0 : r.featureFlagPayloads;
                i((null == s ? void 0 : s[t]) || void 0);
            }
        });
    }
    isFeatureEnabled(t, i) {
        if (void 0 === i && (i = {}), this.we || this.getFlags() && this.getFlags().length > 0) {
            var e = this.getFeatureFlag(t, i);
            return $e444d6404c095fa5$var$C(e) ? void 0 : !!e;
        }
        $e444d6404c095fa5$var$bo.warn('isFeatureEnabled for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    addFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers.push(t);
    }
    removeFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((i)=>i !== t);
    }
    receivedFeatureFlags(t, i) {
        if (this._instance.persistence) {
            this.we = !0;
            var e = this.getFlagVariants(), r = this.getFlagPayloads(), s = this.getFlagsWithDetails();
            !function(t, i, e, r, s) {
                void 0 === e && (e = {}), void 0 === r && (r = {}), void 0 === s && (s = {});
                var n = $e444d6404c095fa5$var$Po(t), o = n.flags, a = n.featureFlags, l = n.featureFlagPayloads;
                if (a) {
                    var u = t.requestId;
                    if ($e444d6404c095fa5$var$P(a)) {
                        $e444d6404c095fa5$var$bo.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
                        var h = {};
                        if (a) for(var d = 0; d < a.length; d++)h[a[d]] = !0;
                        i && i.register({
                            [$e444d6404c095fa5$var$wo]: a,
                            [$e444d6404c095fa5$var$ci]: h
                        });
                    } else {
                        var v = a, c = l, f = o;
                        t.errorsWhileComputingFlags && (v = $e444d6404c095fa5$var$g({}, e, v), c = $e444d6404c095fa5$var$g({}, r, c), f = $e444d6404c095fa5$var$g({}, s, f)), i && i.register($e444d6404c095fa5$var$g({
                            [$e444d6404c095fa5$var$wo]: Object.keys($e444d6404c095fa5$var$Eo(v)),
                            [$e444d6404c095fa5$var$ci]: v || {},
                            [$e444d6404c095fa5$var$ko]: c || {},
                            [$e444d6404c095fa5$var$pi]: f || {}
                        }, u ? {
                            [$e444d6404c095fa5$var$xo]: u
                        } : {}));
                    }
                }
            }(t, this._instance.persistence, e, r, s), this.Me(i);
        }
    }
    override(t, i) {
        void 0 === i && (i = !1), $e444d6404c095fa5$var$bo.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({
            flags: t,
            suppressWarning: i
        });
    }
    overrideFeatureFlags(t) {
        if (!this._instance.__loaded || !this._instance.persistence) return $e444d6404c095fa5$var$bo.uninitializedWarning("posthog.featureFlags.overrideFeatureFlags");
        if (!1 === t) return this._instance.persistence.unregister($e444d6404c095fa5$var$So), this._instance.persistence.unregister($e444d6404c095fa5$var$$o), void this.Me();
        if (t && "object" == typeof t && ("flags" in t || "payloads" in t)) {
            var i, e = t;
            if (this.be = Boolean(null !== (i = e.suppressWarning) && void 0 !== i && i), "flags" in e) {
                if (!1 === e.flags) this._instance.persistence.unregister($e444d6404c095fa5$var$So);
                else if (e.flags) {
                    if ($e444d6404c095fa5$var$P(e.flags)) {
                        for(var r = {}, s = 0; s < e.flags.length; s++)r[e.flags[s]] = !0;
                        this._instance.persistence.register({
                            [$e444d6404c095fa5$var$So]: r
                        });
                    } else this._instance.persistence.register({
                        [$e444d6404c095fa5$var$So]: e.flags
                    });
                }
            }
            return "payloads" in e && (!1 === e.payloads ? this._instance.persistence.unregister($e444d6404c095fa5$var$$o) : e.payloads && this._instance.persistence.register({
                [$e444d6404c095fa5$var$$o]: e.payloads
            })), void this.Me();
        }
        this.Me();
    }
    onFeatureFlags(t) {
        if (this.addFeatureFlagsHandler(t), this.we) {
            var { flags: i, flagVariants: e } = this.Oe();
            t(i, e);
        }
        return ()=>this.removeFeatureFlagsHandler(t);
    }
    updateEarlyAccessFeatureEnrollment(t, i, e) {
        var r, s = (this._instance.get_property($e444d6404c095fa5$var$fi) || []).find((i)=>i.flagKey === t), n = {
            ["$feature_enrollment/" + t]: i
        }, o = {
            $feature_flag: t,
            $feature_enrollment: i,
            $set: n
        };
        s && (o.$early_access_feature_name = s.name), e && (o.$feature_enrollment_stage = e), this._instance.capture("$feature_enrollment_update", o), this.setPersonPropertiesForFlags(n, !1);
        var a = $e444d6404c095fa5$var$g({}, this.getFlagVariants(), {
            [t]: i
        });
        null == (r = this._instance.persistence) || r.register({
            [$e444d6404c095fa5$var$wo]: Object.keys($e444d6404c095fa5$var$Eo(a)),
            [$e444d6404c095fa5$var$ci]: a
        }), this.Me();
    }
    getEarlyAccessFeatures(t, i, e) {
        void 0 === i && (i = !1);
        var r = this._instance.get_property($e444d6404c095fa5$var$fi), s = e ? "&" + e.map((t)=>"stage=" + t).join("&") : "";
        if (r && !i) return t(r);
        this._instance.Te({
            url: this._instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=" + this._instance.config.token + s),
            method: "GET",
            callback: (i)=>{
                var e, r;
                if (i.json) {
                    var s = i.json.earlyAccessFeatures;
                    return null == (e = this._instance.persistence) || e.unregister($e444d6404c095fa5$var$fi), null == (r = this._instance.persistence) || r.register({
                        [$e444d6404c095fa5$var$fi]: s
                    }), t(s);
                }
            }
        });
    }
    Oe() {
        var t = this.getFlags(), i = this.getFlagVariants();
        return {
            flags: t.filter((t)=>i[t]),
            flagVariants: Object.keys(i).filter((t)=>i[t]).reduce((t, e)=>(t[e] = i[e], t), {})
        };
    }
    Me(t) {
        var { flags: i, flagVariants: e } = this.Oe();
        this.featureFlagEventHandlers.forEach((r)=>r(i, e, {
                errorsLoading: t
            }));
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this._instance.get_property($e444d6404c095fa5$var$gi) || {};
        this._instance.register({
            [$e444d6404c095fa5$var$gi]: $e444d6404c095fa5$var$g({}, e, t)
        }), i && this._instance.reloadFeatureFlags();
    }
    resetPersonPropertiesForFlags() {
        this._instance.unregister($e444d6404c095fa5$var$gi);
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this._instance.get_property($e444d6404c095fa5$var$_i) || {};
        0 !== Object.keys(e).length && Object.keys(e).forEach((i)=>{
            e[i] = $e444d6404c095fa5$var$g({}, e[i], t[i]), delete t[i];
        }), this._instance.register({
            [$e444d6404c095fa5$var$_i]: $e444d6404c095fa5$var$g({}, e, t)
        }), i && this._instance.reloadFeatureFlags();
    }
    resetGroupPropertiesForFlags(t) {
        if (t) {
            var i = this._instance.get_property($e444d6404c095fa5$var$_i) || {};
            this._instance.register({
                [$e444d6404c095fa5$var$_i]: $e444d6404c095fa5$var$g({}, i, {
                    [t]: {}
                })
            });
        } else this._instance.unregister($e444d6404c095fa5$var$_i);
    }
    reset() {
        this.we = !1, this.Se = !1, this.ke = !1, this.$e = !1, this.xe = !1, this.Ee = !1, this.$anon_distinct_id = void 0, this.Re(), this.be = !1;
    }
}
var $e444d6404c095fa5$var$To = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
];
class $e444d6404c095fa5$var$Co {
    constructor(t, i){
        this.A = t, this.props = {}, this.Fe = !1, this.Ae = ((t)=>{
            var i = "";
            return t.token && (i = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), t.persistence_name ? "ph_" + t.persistence_name : "ph_" + i + "_posthog";
        })(t), this.it = this.De(t), this.load(), t.debug && $e444d6404c095fa5$var$xt.info("Persistence loaded", t.persistence, $e444d6404c095fa5$var$g({}, this.props)), this.update_config(t, t, i), this.save();
    }
    isDisabled() {
        return !!this.je;
    }
    De(t) {
        -1 === $e444d6404c095fa5$var$To.indexOf(t.persistence.toLowerCase()) && ($e444d6404c095fa5$var$xt.critical("Unknown persistence type " + t.persistence + "; falling back to localStorage+cookie"), t.persistence = "localStorage+cookie");
        var i = t.persistence.toLowerCase();
        return "localstorage" === i && $e444d6404c095fa5$var$Le.G() ? $e444d6404c095fa5$var$Le : "localstorage+cookie" === i && $e444d6404c095fa5$var$Ue.G() ? $e444d6404c095fa5$var$Ue : "sessionstorage" === i && $e444d6404c095fa5$var$He.G() ? $e444d6404c095fa5$var$He : "memory" === i ? $e444d6404c095fa5$var$qe : "cookie" === i ? $e444d6404c095fa5$var$De : $e444d6404c095fa5$var$Ue.G() ? $e444d6404c095fa5$var$Ue : $e444d6404c095fa5$var$De;
    }
    properties() {
        var t = {};
        return $e444d6404c095fa5$var$Ct(this.props, function(i, e) {
            if (e === $e444d6404c095fa5$var$ci && $e444d6404c095fa5$var$R(i)) for(var r = Object.keys(i), n = 0; n < r.length; n++)t["$feature/" + r[n]] = i[r[n]];
            else a = e, l = !1, ($e444d6404c095fa5$var$F(o = $e444d6404c095fa5$var$Ti) ? l : $e444d6404c095fa5$var$s && o.indexOf === $e444d6404c095fa5$var$s ? -1 != o.indexOf(a) : ($e444d6404c095fa5$var$Ct(o, function(t) {
                if (l || (l = t === a)) return $e444d6404c095fa5$var$Rt;
            }), l)) || (t[e] = i);
            var o, a, l;
        }), t;
    }
    load() {
        if (!this.je) {
            var t = this.it.K(this.Ae);
            t && (this.props = $e444d6404c095fa5$var$Mt({}, t));
        }
    }
    save() {
        this.je || this.it.Y(this.Ae, this.props, this.Le, this.Ne, this.Ue, this.A.debug);
    }
    remove() {
        this.it.X(this.Ae, !1), this.it.X(this.Ae, !0);
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(t, i, e) {
        if ($e444d6404c095fa5$var$R(t)) {
            $e444d6404c095fa5$var$C(i) && (i = "None"), this.Le = $e444d6404c095fa5$var$C(e) ? this.ze : e;
            var r = !1;
            if ($e444d6404c095fa5$var$Ct(t, (t, e)=>{
                this.props.hasOwnProperty(e) && this.props[e] !== i || (this.props[e] = t, r = !0);
            }), r) return this.save(), !0;
        }
        return !1;
    }
    register(t, i) {
        if ($e444d6404c095fa5$var$R(t)) {
            this.Le = $e444d6404c095fa5$var$C(i) ? this.ze : i;
            var e = !1;
            if ($e444d6404c095fa5$var$Ct(t, (i, r)=>{
                t.hasOwnProperty(r) && this.props[r] !== i && (this.props[r] = i, e = !0);
            }), e) return this.save(), !0;
        }
        return !1;
    }
    unregister(t) {
        t in this.props && (delete this.props[t], this.save());
    }
    update_campaign_params() {
        if (!this.Fe) {
            var t = $e444d6404c095fa5$var$uo(this.A.custom_campaign_params, this.A.mask_personal_data_properties, this.A.custom_personal_data_properties);
            $e444d6404c095fa5$var$T($e444d6404c095fa5$var$jt(t)) || this.register(t), this.Fe = !0;
        }
    }
    update_search_keyword() {
        var t;
        this.register((t = null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.referrer) ? $e444d6404c095fa5$var$vo(t) : {});
    }
    update_referrer_info() {
        var t;
        this.register_once({
            $referrer: $e444d6404c095fa5$var$fo(),
            $referring_domain: null != $e444d6404c095fa5$var$o && $e444d6404c095fa5$var$o.referrer && (null == (t = $e444d6404c095fa5$var$fe($e444d6404c095fa5$var$o.referrer)) ? void 0 : t.host) || "$direct"
        }, void 0);
    }
    set_initial_person_info() {
        this.props[$e444d6404c095fa5$var$$i] || this.props[$e444d6404c095fa5$var$xi] || this.register_once({
            [$e444d6404c095fa5$var$Ei]: $e444d6404c095fa5$var$po(this.A.mask_personal_data_properties, this.A.custom_personal_data_properties)
        }, void 0);
    }
    get_initial_props() {
        var t = {};
        $e444d6404c095fa5$var$Ct([
            $e444d6404c095fa5$var$xi,
            $e444d6404c095fa5$var$$i
        ], (i)=>{
            var e = this.props[i];
            e && $e444d6404c095fa5$var$Ct(e, function(i, e) {
                t["$initial_" + $e444d6404c095fa5$var$w(e)] = i;
            });
        });
        var i, e, r = this.props[$e444d6404c095fa5$var$Ei];
        if (r) {
            var s = (i = $e444d6404c095fa5$var$go(r), e = {}, $e444d6404c095fa5$var$Ct(i, function(t, i) {
                e["$initial_" + $e444d6404c095fa5$var$w(i)] = t;
            }), e);
            $e444d6404c095fa5$var$Mt(t, s);
        }
        return t;
    }
    safe_merge(t) {
        return $e444d6404c095fa5$var$Ct(this.props, function(i, e) {
            e in t || (t[e] = i);
        }), t;
    }
    update_config(t, i, e) {
        if (this.ze = this.Le = t.cookie_expiration, this.set_disabled(t.disable_persistence || !!e), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie), t.persistence !== i.persistence) {
            var r = this.De(t), s = this.props;
            this.clear(), this.it = r, this.props = s, this.save();
        }
    }
    set_disabled(t) {
        this.je = t, this.je ? this.remove() : this.save();
    }
    set_cross_subdomain(t) {
        t !== this.Ne && (this.Ne = t, this.remove(), this.save());
    }
    set_secure(t) {
        t !== this.Ue && (this.Ue = t, this.remove(), this.save());
    }
    set_event_timer(t, i) {
        var e = this.props[$e444d6404c095fa5$var$Wt] || {};
        e[t] = i, this.props[$e444d6404c095fa5$var$Wt] = e, this.save();
    }
    remove_event_timer(t) {
        var i = (this.props[$e444d6404c095fa5$var$Wt] || {})[t];
        return $e444d6404c095fa5$var$C(i) || (delete this.props[$e444d6404c095fa5$var$Wt][t], this.save()), i;
    }
    get_property(t) {
        return this.props[t];
    }
    set_property(t, i) {
        this.props[t] = i, this.save();
    }
}
var $e444d6404c095fa5$export$87f1e68f1b904cbb = function(t) {
    return t.Button = "button", t.Tab = "tab", t.Selector = "selector", t;
}({}), $e444d6404c095fa5$export$8c0ce98316e43193 = function(t) {
    return t.TopLeft = "top_left", t.TopRight = "top_right", t.TopCenter = "top_center", t.MiddleLeft = "middle_left", t.MiddleRight = "middle_right", t.MiddleCenter = "middle_center", t.Left = "left", t.Center = "center", t.Right = "right", t.NextToTrigger = "next_to_trigger", t;
}({}), $e444d6404c095fa5$export$22779822dd24228f = function(t) {
    return t.Popover = "popover", t.API = "api", t.Widget = "widget", t.ExternalSurvey = "external_survey", t;
}({}), $e444d6404c095fa5$export$9c2ac61661d417f8 = function(t) {
    return t.Open = "open", t.MultipleChoice = "multiple_choice", t.SingleChoice = "single_choice", t.Rating = "rating", t.Link = "link", t;
}({}), $e444d6404c095fa5$export$bbed2da3bd3bb001 = function(t) {
    return t.NextQuestion = "next_question", t.End = "end", t.ResponseBased = "response_based", t.SpecificQuestion = "specific_question", t;
}({}), $e444d6404c095fa5$export$407ee791fe918359 = function(t) {
    return t.Once = "once", t.Recurring = "recurring", t.Always = "always", t;
}({}), $e444d6404c095fa5$export$9d7ec1793ca1658e = function(t) {
    return t.SHOWN = "survey shown", t.DISMISSED = "survey dismissed", t.SENT = "survey sent", t;
}({}), $e444d6404c095fa5$export$fe4c9af525341543 = function(t) {
    return t.SURVEY_ID = "$survey_id", t.SURVEY_NAME = "$survey_name", t.SURVEY_RESPONSE = "$survey_response", t.SURVEY_ITERATION = "$survey_iteration", t.SURVEY_ITERATION_START_DATE = "$survey_iteration_start_date", t.SURVEY_PARTIALLY_COMPLETED = "$survey_partially_completed", t.SURVEY_SUBMISSION_ID = "$survey_submission_id", t.SURVEY_QUESTIONS = "$survey_questions", t.SURVEY_COMPLETED = "$survey_completed", t;
}({}), $e444d6404c095fa5$export$a8a66d9d1b857494 = function(t) {
    return t.Popover = "popover", t.Inline = "inline", t;
}({});
class $e444d6404c095fa5$var$zo {
    constructor(){
        this.qe = {}, this.qe = {};
    }
    on(t, i) {
        return this.qe[t] || (this.qe[t] = []), this.qe[t].push(i), ()=>{
            this.qe[t] = this.qe[t].filter((t)=>t !== i);
        };
    }
    emit(t, i) {
        for (var e of this.qe[t] || [])e(i);
        for (var r of this.qe["*"] || [])r(t, i);
    }
}
class $e444d6404c095fa5$var$qo {
    constructor(t){
        this.Be = new $e444d6404c095fa5$var$zo, this.He = (t, i)=>this.We(t, i) && this.Ge(t, i) && this.Ve(t, i), this.We = (t, i)=>null == i || !i.event || (null == t ? void 0 : t.event) === (null == i ? void 0 : i.event), this._instance = t, this.Je = new Set, this.Ke = new Set;
    }
    init() {
        var t;
        if (!$e444d6404c095fa5$var$C(null == (t = this._instance) ? void 0 : t.Ye)) {
            var i;
            null == (i = this._instance) || i.Ye((t, i)=>{
                this.on(t, i);
            });
        }
    }
    register(t) {
        var i, e;
        if (!$e444d6404c095fa5$var$C(null == (i = this._instance) ? void 0 : i.Ye) && (t.forEach((t)=>{
            var i, e;
            null == (i = this.Ke) || i.add(t), null == (e = t.steps) || e.forEach((t)=>{
                var i;
                null == (i = this.Je) || i.add((null == t ? void 0 : t.event) || "");
            });
        }), null != (e = this._instance) && e.autocapture)) {
            var r, s = new Set;
            t.forEach((t)=>{
                var i;
                null == (i = t.steps) || i.forEach((t)=>{
                    null != t && t.selector && s.add(null == t ? void 0 : t.selector);
                });
            }), null == (r = this._instance) || r.autocapture.setElementSelectors(s);
        }
    }
    on(t, i) {
        var e;
        null != i && 0 != t.length && (this.Je.has(t) || this.Je.has(null == i ? void 0 : i.event)) && this.Ke && (null == (e = this.Ke) ? void 0 : e.size) > 0 && this.Ke.forEach((t)=>{
            this.Xe(i, t) && this.Be.emit("actionCaptured", t.name);
        });
    }
    Qe(t) {
        this.onAction("actionCaptured", (i)=>t(i));
    }
    Xe(t, i) {
        if (null == (null == i ? void 0 : i.steps)) return !1;
        for (var e of i.steps)if (this.He(t, e)) return !0;
        return !1;
    }
    onAction(t, i) {
        return this.Be.on(t, i);
    }
    Ge(t, i) {
        if (null != i && i.url) {
            var e, r = null == t || null == (e = t.properties) ? void 0 : e.$current_url;
            if (!r || "string" != typeof r) return !1;
            if (!$e444d6404c095fa5$var$qo.Ze(r, null == i ? void 0 : i.url, (null == i ? void 0 : i.url_matching) || "contains")) return !1;
        }
        return !0;
    }
    static Ze(i, e, r) {
        switch(r){
            case "regex":
                return !!$e444d6404c095fa5$var$t && $e444d6404c095fa5$var$en(i, e);
            case "exact":
                return e === i;
            case "contains":
                var s = $e444d6404c095fa5$var$qo.tr(e).replace(/_/g, ".").replace(/%/g, ".*");
                return $e444d6404c095fa5$var$en(i, s);
            default:
                return !1;
        }
    }
    static tr(t) {
        return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
    }
    Ve(t, i) {
        if ((null != i && i.href || null != i && i.tag_name || null != i && i.text) && !this.ir(t).some((t)=>!(null != i && i.href && !$e444d6404c095fa5$var$qo.Ze(t.href || "", null == i ? void 0 : i.href, (null == i ? void 0 : i.href_matching) || "exact")) && (null == i || !i.tag_name || t.tag_name === (null == i ? void 0 : i.tag_name)) && !(null != i && i.text && !$e444d6404c095fa5$var$qo.Ze(t.text || "", null == i ? void 0 : i.text, (null == i ? void 0 : i.text_matching) || "exact") && !$e444d6404c095fa5$var$qo.Ze(t.$el_text || "", null == i ? void 0 : i.text, (null == i ? void 0 : i.text_matching) || "exact")))) return !1;
        if (null != i && i.selector) {
            var e, r = null == t || null == (e = t.properties) ? void 0 : e.$element_selectors;
            if (!r) return !1;
            if (!r.includes(null == i ? void 0 : i.selector)) return !1;
        }
        return !0;
    }
    ir(t) {
        return null == (null == t ? void 0 : t.properties.$elements) ? [] : null == t ? void 0 : t.properties.$elements;
    }
}
var $e444d6404c095fa5$var$Bo = $e444d6404c095fa5$var$Et("[Surveys]");
var $e444d6404c095fa5$var$Ho = "seenSurvey_", $e444d6404c095fa5$var$Wo = (t, i)=>{
    var e = "$survey_" + i + "/" + t.id;
    return t.current_iteration && t.current_iteration > 0 && (e = "$survey_" + i + "/" + t.id + "/" + t.current_iteration), e;
}, $e444d6404c095fa5$var$Go = (t)=>{
    var i = "" + $e444d6404c095fa5$var$Ho + t.id;
    return t.current_iteration && t.current_iteration > 0 && (i = "" + $e444d6404c095fa5$var$Ho + t.id + "_" + t.current_iteration), i;
}, $e444d6404c095fa5$var$Vo = [
    $e444d6404c095fa5$export$22779822dd24228f.Popover,
    $e444d6404c095fa5$export$22779822dd24228f.Widget,
    $e444d6404c095fa5$export$22779822dd24228f.API
], $e444d6404c095fa5$var$Jo = {
    ignoreConditions: !1,
    ignoreDelay: !1,
    displayType: $e444d6404c095fa5$export$a8a66d9d1b857494.Popover
};
class $e444d6404c095fa5$var$Ko {
    constructor(t){
        this._instance = t, this.er = new Map, this.rr = new Map;
    }
    register(t) {
        var i;
        $e444d6404c095fa5$var$C(null == (i = this._instance) ? void 0 : i.Ye) || (this.sr(t), this.nr(t));
    }
    nr(t) {
        var i = t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.actions) && (null == (e = t.conditions) || null == (e = e.actions) || null == (e = e.values) ? void 0 : e.length) > 0;
        });
        if (0 !== i.length) {
            if (null == this.ar) {
                this.ar = new $e444d6404c095fa5$var$qo(this._instance), this.ar.init();
                this.ar.Qe((t)=>{
                    this.onAction(t);
                });
            }
            i.forEach((t)=>{
                var i, e, r, s, n;
                t.conditions && null != (i = t.conditions) && i.actions && null != (e = t.conditions) && null != (e = e.actions) && e.values && (null == (r = t.conditions) || null == (r = r.actions) || null == (r = r.values) ? void 0 : r.length) > 0 && (null == (s = this.ar) || s.register(t.conditions.actions.values), null == (n = t.conditions) || null == (n = n.actions) || null == (n = n.values) || n.forEach((i)=>{
                    if (i && i.name) {
                        var e = this.rr.get(i.name);
                        e && e.push(t.id), this.rr.set(i.name, e || [
                            t.id
                        ]);
                    }
                }));
            });
        }
    }
    sr(t) {
        var i;
        if (0 !== t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.events) && (null == (e = t.conditions) || null == (e = e.events) || null == (e = e.values) ? void 0 : e.length) > 0;
        }).length) null == (i = this._instance) || i.Ye((t, i)=>{
            this.onEvent(t, i);
        }), t.forEach((t)=>{
            var i;
            null == (i = t.conditions) || null == (i = i.events) || null == (i = i.values) || i.forEach((i)=>{
                if (i && i.name) {
                    var e = this.er.get(i.name);
                    e && e.push(t.id), this.er.set(i.name, e || [
                        t.id
                    ]);
                }
            });
        });
    }
    onEvent(t, i) {
        var e, r, s = (null == (e = this._instance) || null == (e = e.persistence) ? void 0 : e.props[$e444d6404c095fa5$var$yi]) || [];
        if ($e444d6404c095fa5$export$9d7ec1793ca1658e.SHOWN === t && i && s.length > 0) {
            var n;
            $e444d6404c095fa5$var$Bo.info("survey event matched, removing survey from activated surveys", {
                event: t,
                eventPayload: i,
                existingActivatedSurveys: s
            });
            var o = null == i || null == (n = i.properties) ? void 0 : n.$survey_id;
            if (o) {
                var a = s.indexOf(o);
                a >= 0 && (s.splice(a, 1), this.lr(s));
            }
        } else if (this.er.has(t)) {
            $e444d6404c095fa5$var$Bo.info("survey event name matched", {
                event: t,
                eventPayload: i,
                surveys: this.er.get(t)
            });
            var l = [];
            null == (r = this._instance) || r.getSurveys((i)=>{
                l = i.filter((i)=>{
                    var e;
                    return null == (e = this.er.get(t)) ? void 0 : e.includes(i.id);
                });
            });
            var u = l.filter((e)=>{
                var r, s = null == (r = e.conditions) || null == (r = r.events) || null == (r = r.values) ? void 0 : r.find((i)=>i.name === t);
                return !!s && (!s.propertyFilters || Object.entries(s.propertyFilters).every((t)=>{
                    var e, [r, s] = t, n = null == i || null == (e = i.properties) ? void 0 : e[r];
                    if ($e444d6404c095fa5$var$C(n) || $e444d6404c095fa5$var$F(n)) return !1;
                    var o = [
                        String(n)
                    ], a = $e444d6404c095fa5$var$sn[s.operator];
                    return a ? a(s.values, o) : ($e444d6404c095fa5$var$Bo.warn("Unknown property comparison operator: " + s.operator), !1);
                }));
            });
            this.lr(s.concat(u.map((t)=>t.id) || []));
        }
    }
    onAction(t) {
        var i, e = (null == (i = this._instance) || null == (i = i.persistence) ? void 0 : i.props[$e444d6404c095fa5$var$yi]) || [];
        this.rr.has(t) && this.lr(e.concat(this.rr.get(t) || []));
    }
    lr(t) {
        var i;
        $e444d6404c095fa5$var$Bo.info("updating activated surveys", {
            activatedSurveys: t
        }), null == (i = this._instance) || null == (i = i.persistence) || i.register({
            [$e444d6404c095fa5$var$yi]: [
                ...new Set(t)
            ]
        });
    }
    getSurveys() {
        var t, i = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.props[$e444d6404c095fa5$var$yi];
        return i || [];
    }
    getEventToSurveys() {
        return this.er;
    }
    ur() {
        return this.ar;
    }
}
class $e444d6404c095fa5$var$Yo {
    constructor(t){
        this.hr = void 0, this._surveyManager = null, this.dr = !1, this.vr = !1, this.cr = [], this._instance = t, this._surveyEventReceiver = null;
    }
    onRemoteConfig(t) {
        if (!this._instance.config.disable_surveys) {
            var i = t.surveys;
            if ($e444d6404c095fa5$var$A(i)) return $e444d6404c095fa5$var$Bo.warn("Flags not loaded yet. Not loading surveys.");
            var e = $e444d6404c095fa5$var$P(i);
            this.hr = e ? i.length > 0 : i, $e444d6404c095fa5$var$Bo.info("flags response received, isSurveysEnabled: " + this.hr), this.loadIfEnabled();
        }
    }
    reset() {
        localStorage.removeItem("lastSeenSurveyDate");
        for(var t = [], i = 0; i < localStorage.length; i++){
            var e = localStorage.key(i);
            (null != e && e.startsWith($e444d6404c095fa5$var$Ho) || null != e && e.startsWith("inProgressSurvey_")) && t.push(e);
        }
        t.forEach((t)=>localStorage.removeItem(t));
    }
    loadIfEnabled() {
        if (!this._surveyManager) {
            if (this.vr) $e444d6404c095fa5$var$Bo.info("Already initializing surveys, skipping...");
            else if (this._instance.config.disable_surveys) $e444d6404c095fa5$var$Bo.info("Disabled. Not loading surveys.");
            else if (this._instance.config.cookieless_mode && this._instance.consent.isOptedOut()) $e444d6404c095fa5$var$Bo.info("Not loading surveys in cookieless mode without consent.");
            else {
                var t = null == $e444d6404c095fa5$var$v ? void 0 : $e444d6404c095fa5$var$v.__PosthogExtensions__;
                if (t) {
                    if (!$e444d6404c095fa5$var$C(this.hr) || this._instance.config.advanced_enable_surveys) {
                        var i = this.hr || this._instance.config.advanced_enable_surveys;
                        this.vr = !0;
                        try {
                            var e = t.generateSurveys;
                            if (e) return void this.pr(e, i);
                            var r = t.loadExternalDependency;
                            if (!r) return void this.gr("PostHog loadExternalDependency extension not found.");
                            r(this._instance, "surveys", (e)=>{
                                e || !t.generateSurveys ? this.gr("Could not load surveys script", e) : this.pr(t.generateSurveys, i);
                            });
                        } catch (t) {
                            throw this.gr("Error initializing surveys", t), t;
                        } finally{
                            this.vr = !1;
                        }
                    }
                } else $e444d6404c095fa5$var$Bo.error("PostHog Extensions not found.");
            }
        }
    }
    pr(t, i) {
        this._surveyManager = t(this._instance, i), this._surveyEventReceiver = new $e444d6404c095fa5$var$Ko(this._instance), $e444d6404c095fa5$var$Bo.info("Surveys loaded successfully"), this._r({
            isLoaded: !0
        });
    }
    gr(t, i) {
        $e444d6404c095fa5$var$Bo.error(t, i), this._r({
            isLoaded: !1,
            error: t
        });
    }
    onSurveysLoaded(t) {
        return this.cr.push(t), this._surveyManager && this._r({
            isLoaded: !0
        }), ()=>{
            this.cr = this.cr.filter((i)=>i !== t);
        };
    }
    getSurveys(t, i) {
        if (void 0 === i && (i = !1), this._instance.config.disable_surveys) return $e444d6404c095fa5$var$Bo.info("Disabled. Not loading surveys."), t([]);
        var e = this._instance.get_property($e444d6404c095fa5$var$mi);
        if (e && !i) return t(e, {
            isLoaded: !0
        });
        if (this.dr) return t([], {
            isLoaded: !1,
            error: "Surveys are already being loaded"
        });
        try {
            this.dr = !0, this._instance.Te({
                url: this._instance.requestRouter.endpointFor("api", "/api/surveys/?token=" + this._instance.config.token),
                method: "GET",
                timeout: this._instance.config.surveys_request_timeout_ms,
                callback: (i)=>{
                    var e;
                    this.dr = !1;
                    var r = i.statusCode;
                    if (200 !== r || !i.json) {
                        var s = "Surveys API could not be loaded, status: " + r;
                        return $e444d6404c095fa5$var$Bo.error(s), t([], {
                            isLoaded: !1,
                            error: s
                        });
                    }
                    var n, o = i.json.surveys || [], a = o.filter((t)=>(function(t) {
                            return !(!t.start_date || t.end_date);
                        })(t) && (function(t) {
                            var i;
                            return !(null == (i = t.conditions) || null == (i = i.events) || null == (i = i.values) || !i.length);
                        }(t) || function(t) {
                            var i;
                            return !(null == (i = t.conditions) || null == (i = i.actions) || null == (i = i.values) || !i.length);
                        }(t)));
                    a.length > 0 && (null == (n = this._surveyEventReceiver) || n.register(a));
                    return null == (e = this._instance.persistence) || e.register({
                        [$e444d6404c095fa5$var$mi]: o
                    }), t(o, {
                        isLoaded: !0
                    });
                }
            });
        } catch (t) {
            throw this.dr = !1, t;
        }
    }
    _r(t) {
        for (var i of this.cr)try {
            if (!t.isLoaded) return i([], t);
            this.getSurveys(i);
        } catch (t) {
            $e444d6404c095fa5$var$Bo.error("Error in survey callback", t);
        }
    }
    getActiveMatchingSurveys(t, i) {
        if (void 0 === i && (i = !1), !$e444d6404c095fa5$var$A(this._surveyManager)) return this._surveyManager.getActiveMatchingSurveys(t, i);
        $e444d6404c095fa5$var$Bo.warn("init was not called");
    }
    mr(t) {
        var i = null;
        return this.getSurveys((e)=>{
            var r;
            i = null !== (r = e.find((i)=>i.id === t)) && void 0 !== r ? r : null;
        }), i;
    }
    yr(t) {
        if ($e444d6404c095fa5$var$A(this._surveyManager)) return {
            eligible: !1,
            reason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = "string" == typeof t ? this.mr(t) : t;
        return i ? this._surveyManager.checkSurveyEligibility(i) : {
            eligible: !1,
            reason: "Survey not found"
        };
    }
    canRenderSurvey(t) {
        if ($e444d6404c095fa5$var$A(this._surveyManager)) return $e444d6404c095fa5$var$Bo.warn("init was not called"), {
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = this.yr(t);
        return {
            visible: i.eligible,
            disabledReason: i.reason
        };
    }
    canRenderSurveyAsync(t, i) {
        return $e444d6404c095fa5$var$A(this._surveyManager) ? ($e444d6404c095fa5$var$Bo.warn("init was not called"), Promise.resolve({
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        })) : new Promise((e)=>{
            this.getSurveys((i)=>{
                var r, s = null !== (r = i.find((i)=>i.id === t)) && void 0 !== r ? r : null;
                if (s) {
                    var n = this.yr(s);
                    e({
                        visible: n.eligible,
                        disabledReason: n.reason
                    });
                } else e({
                    visible: !1,
                    disabledReason: "Survey not found"
                });
            }, i);
        });
    }
    renderSurvey(t, i) {
        var e;
        if ($e444d6404c095fa5$var$A(this._surveyManager)) $e444d6404c095fa5$var$Bo.warn("init was not called");
        else {
            var r = "string" == typeof t ? this.mr(t) : t;
            if (null != r && r.id) {
                if ($e444d6404c095fa5$var$Vo.includes(r.type)) {
                    var s = null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.querySelector(i);
                    if (s) return null != (e = r.appearance) && e.surveyPopupDelaySeconds ? ($e444d6404c095fa5$var$Bo.info("Rendering survey " + r.id + " with delay of " + r.appearance.surveyPopupDelaySeconds + " seconds"), void setTimeout(()=>{
                        var t, i;
                        $e444d6404c095fa5$var$Bo.info("Rendering survey " + r.id + " with delay of " + (null == (t = r.appearance) ? void 0 : t.surveyPopupDelaySeconds) + " seconds"), null == (i = this._surveyManager) || i.renderSurvey(r, s), $e444d6404c095fa5$var$Bo.info("Survey " + r.id + " rendered");
                    }, 1e3 * r.appearance.surveyPopupDelaySeconds)) : void this._surveyManager.renderSurvey(r, s);
                    $e444d6404c095fa5$var$Bo.warn("Survey element not found");
                } else $e444d6404c095fa5$var$Bo.warn("Surveys of type " + r.type + " cannot be rendered in the app");
            } else $e444d6404c095fa5$var$Bo.warn("Survey not found");
        }
    }
    displaySurvey(t, i) {
        var e;
        if ($e444d6404c095fa5$var$A(this._surveyManager)) $e444d6404c095fa5$var$Bo.warn("init was not called");
        else {
            var r = this.mr(t);
            if (r) {
                var s = r;
                if (null != (e = r.appearance) && e.surveyPopupDelaySeconds && i.ignoreDelay && (s = $e444d6404c095fa5$var$g({}, r, {
                    appearance: $e444d6404c095fa5$var$g({}, r.appearance, {
                        surveyPopupDelaySeconds: 0
                    })
                })), !1 === i.ignoreConditions) {
                    var n = this.canRenderSurvey(r);
                    if (!n.visible) return void $e444d6404c095fa5$var$Bo.warn("Survey is not eligible to be displayed: ", n.disabledReason);
                }
                i.displayType !== $e444d6404c095fa5$export$a8a66d9d1b857494.Inline ? this._surveyManager.handlePopoverSurvey(s) : this.renderSurvey(s, i.selector);
            } else $e444d6404c095fa5$var$Bo.warn("Survey not found");
        }
    }
}
var $e444d6404c095fa5$var$Xo = $e444d6404c095fa5$var$Et("[RateLimiter]");
class $e444d6404c095fa5$var$Qo {
    constructor(t){
        var i, e;
        this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (t)=>{
            var i = t.text;
            if (i && i.length) try {
                (JSON.parse(i).quota_limited || []).forEach((t)=>{
                    $e444d6404c095fa5$var$Xo.info((t || "events") + " is quota limited."), this.serverLimits[t] = (new Date).getTime() + 6e4;
                });
            } catch (t) {
                return void $e444d6404c095fa5$var$Xo.warn('could not rate limit - continuing. Error: "' + (null == t ? void 0 : t.message) + '"', {
                    text: i
                });
            }
        }, this.instance = t, this.captureEventsPerSecond = (null == (i = t.config.rate_limiting) ? void 0 : i.events_per_second) || 10, this.captureEventsBurstLimit = Math.max((null == (e = t.config.rate_limiting) ? void 0 : e.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond), this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    clientRateLimitContext(t) {
        var i, e, r;
        void 0 === t && (t = !1);
        var s = (new Date).getTime(), n = null !== (i = null == (e = this.instance.persistence) ? void 0 : e.get_property($e444d6404c095fa5$var$ki)) && void 0 !== i ? i : {
            tokens: this.captureEventsBurstLimit,
            last: s
        };
        n.tokens += (s - n.last) / 1e3 * this.captureEventsPerSecond, n.last = s, n.tokens > this.captureEventsBurstLimit && (n.tokens = this.captureEventsBurstLimit);
        var o = n.tokens < 1;
        return o || t || (n.tokens = Math.max(0, n.tokens - 1)), !o || this.lastEventRateLimited || t || this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to " + this.captureEventsPerSecond + " events per second and " + this.captureEventsBurstLimit + " events burst limit."
        }, {
            skip_client_rate_limiting: !0
        }), this.lastEventRateLimited = o, null == (r = this.instance.persistence) || r.set_property($e444d6404c095fa5$var$ki, n), {
            isRateLimited: o,
            remainingTokens: n.tokens
        };
    }
    isServerRateLimited(t) {
        var i = this.serverLimits[t || "events"] || !1;
        return !1 !== i && (new Date).getTime() < i;
    }
}
var $e444d6404c095fa5$var$Zo = $e444d6404c095fa5$var$Et("[RemoteConfig]");
class $e444d6404c095fa5$var$ta {
    constructor(t){
        this._instance = t;
    }
    get remoteConfig() {
        var t;
        return null == (t = $e444d6404c095fa5$var$v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.config;
    }
    br(t) {
        var i, e;
        null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.loadExternalDependency ? null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "remote-config", ()=>t(this.remoteConfig)) : ($e444d6404c095fa5$var$Zo.error("PostHog Extensions not found. Cannot load remote config."), t());
    }
    wr(t) {
        this._instance.Te({
            method: "GET",
            url: this._instance.requestRouter.endpointFor("assets", "/array/" + this._instance.config.token + "/config"),
            callback: (i)=>{
                t(i.json);
            }
        });
    }
    load() {
        try {
            if (this.remoteConfig) return $e444d6404c095fa5$var$Zo.info("Using preloaded remote config", this.remoteConfig), void this.Ce(this.remoteConfig);
            if (this._instance.L()) return void $e444d6404c095fa5$var$Zo.warn("Remote config is disabled. Falling back to local config.");
            this.br((t)=>{
                if (!t) return $e444d6404c095fa5$var$Zo.info("No config found after loading remote JS config. Falling back to JSON."), void this.wr((t)=>{
                    this.Ce(t);
                });
                this.Ce(t);
            });
        } catch (t) {
            $e444d6404c095fa5$var$Zo.error("Error loading remote config", t);
        }
    }
    Ce(t) {
        t ? this._instance.config.__preview_remote_config ? (this._instance.Ce(t), !1 !== t.hasFeatureFlags && this._instance.featureFlags.ensureFlagsLoaded()) : $e444d6404c095fa5$var$Zo.info("__preview_remote_config is disabled. Logging config instead", t) : $e444d6404c095fa5$var$Zo.error("Failed to fetch remote config from PostHog.");
    }
}
var $e444d6404c095fa5$var$ia = 3e3;
class $e444d6404c095fa5$var$ea {
    constructor(t, i){
        this.Sr = !0, this.kr = [], this.$r = $e444d6404c095fa5$var$G((null == i ? void 0 : i.flush_interval_ms) || $e444d6404c095fa5$var$ia, 250, 5e3, $e444d6404c095fa5$var$xt.createLogger("flush interval"), $e444d6404c095fa5$var$ia), this.Er = t;
    }
    enqueue(t) {
        this.kr.push(t), this.Pr || this.Ir();
    }
    unload() {
        this.Rr();
        var t = this.kr.length > 0 ? this.Tr() : {}, i = Object.values(t);
        [
            ...i.filter((t)=>0 === t.url.indexOf("/e")),
            ...i.filter((t)=>0 !== t.url.indexOf("/e"))
        ].map((t)=>{
            this.Er($e444d6404c095fa5$var$g({}, t, {
                transport: "sendBeacon"
            }));
        });
    }
    enable() {
        this.Sr = !1, this.Ir();
    }
    Ir() {
        var t = this;
        this.Sr || (this.Pr = setTimeout(()=>{
            if (this.Rr(), this.kr.length > 0) {
                var i = this.Tr(), e = function() {
                    var e = i[r], s = (new Date).getTime();
                    e.data && $e444d6404c095fa5$var$P(e.data) && $e444d6404c095fa5$var$Ct(e.data, (t)=>{
                        t.offset = Math.abs(t.timestamp - s), delete t.timestamp;
                    }), t.Er(e);
                };
                for(var r in i)e();
            }
        }, this.$r));
    }
    Rr() {
        clearTimeout(this.Pr), this.Pr = void 0;
    }
    Tr() {
        var t = {};
        return $e444d6404c095fa5$var$Ct(this.kr, (i)=>{
            var e, r = i, s = (r ? r.batchKey : null) || r.url;
            $e444d6404c095fa5$var$C(t[s]) && (t[s] = $e444d6404c095fa5$var$g({}, r, {
                data: []
            })), null == (e = t[s].data) || e.push(r.data);
        }), this.kr = [], t;
    }
}
var $e444d6404c095fa5$var$ra = [
    "retriesPerformedSoFar"
];
class $e444d6404c095fa5$var$sa {
    constructor(i){
        this.Cr = !1, this.Mr = 3e3, this.kr = [], this._instance = i, this.kr = [], this.Or = !0, !$e444d6404c095fa5$var$C($e444d6404c095fa5$var$t) && "onLine" in $e444d6404c095fa5$var$t.navigator && (this.Or = $e444d6404c095fa5$var$t.navigator.onLine, $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "online", ()=>{
            this.Or = !0, this.ne();
        }), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "offline", ()=>{
            this.Or = !1;
        }));
    }
    get length() {
        return this.kr.length;
    }
    retriableRequest(t) {
        var { retriesPerformedSoFar: i } = t, e = $e444d6404c095fa5$var$_(t, $e444d6404c095fa5$var$ra);
        $e444d6404c095fa5$var$D(i) && i > 0 && (e.url = $e444d6404c095fa5$var$Xs(e.url, {
            retry_count: i
        })), this._instance.Te($e444d6404c095fa5$var$g({}, e, {
            callback: (t)=>{
                200 !== t.statusCode && (t.statusCode < 400 || t.statusCode >= 500) && (null != i ? i : 0) < 10 ? this.Fr($e444d6404c095fa5$var$g({
                    retriesPerformedSoFar: i
                }, e)) : null == e.callback || e.callback(t);
            }
        }));
    }
    Fr(t) {
        var i = t.retriesPerformedSoFar || 0;
        t.retriesPerformedSoFar = i + 1;
        var e = function(t) {
            var i = 3e3 * Math.pow(2, t), e = i / 2, r = Math.min(18e5, i), s = (Math.random() - .5) * (r - e);
            return Math.ceil(r + s);
        }(i), r = Date.now() + e;
        this.kr.push({
            retryAt: r,
            requestOptions: t
        });
        var s = "Enqueued failed request for retry in " + e;
        navigator.onLine || (s += " (Browser is offline)"), $e444d6404c095fa5$var$xt.warn(s), this.Cr || (this.Cr = !0, this.Ar());
    }
    Ar() {
        this.Dr && clearTimeout(this.Dr), this.Dr = setTimeout(()=>{
            this.Or && this.kr.length > 0 && this.ne(), this.Ar();
        }, this.Mr);
    }
    ne() {
        var t = Date.now(), i = [], e = this.kr.filter((e)=>e.retryAt < t || (i.push(e), !1));
        if (this.kr = i, e.length > 0) for (var { requestOptions: r } of e)this.retriableRequest(r);
    }
    unload() {
        for (var { requestOptions: t } of (this.Dr && (clearTimeout(this.Dr), this.Dr = void 0), this.kr))try {
            this._instance.Te($e444d6404c095fa5$var$g({}, t, {
                transport: "sendBeacon"
            }));
        } catch (t) {
            $e444d6404c095fa5$var$xt.error(t);
        }
        this.kr = [];
    }
}
class $e444d6404c095fa5$var$na {
    constructor(t){
        this.jr = ()=>{
            var t, i, e, r;
            this.Lr || (this.Lr = {});
            var s = this.scrollElement(), n = this.scrollY(), o = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, a = n + ((null == s ? void 0 : s.clientHeight) || 0), l = (null == s ? void 0 : s.scrollHeight) || 0;
            this.Lr.lastScrollY = Math.ceil(n), this.Lr.maxScrollY = Math.max(n, null !== (t = this.Lr.maxScrollY) && void 0 !== t ? t : 0), this.Lr.maxScrollHeight = Math.max(o, null !== (i = this.Lr.maxScrollHeight) && void 0 !== i ? i : 0), this.Lr.lastContentY = a, this.Lr.maxContentY = Math.max(a, null !== (e = this.Lr.maxContentY) && void 0 !== e ? e : 0), this.Lr.maxContentHeight = Math.max(l, null !== (r = this.Lr.maxContentHeight) && void 0 !== r ? r : 0);
        }, this._instance = t;
    }
    getContext() {
        return this.Lr;
    }
    resetContext() {
        var t = this.Lr;
        return setTimeout(this.jr, 0), t;
    }
    startMeasuringScrollPosition() {
        $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "scroll", this.jr, {
            capture: !0
        }), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "scrollend", this.jr, {
            capture: !0
        }), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "resize", this.jr);
    }
    scrollElement() {
        if (!this._instance.config.scroll_root_selector) return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.document.documentElement;
        var i = $e444d6404c095fa5$var$P(this._instance.config.scroll_root_selector) ? this._instance.config.scroll_root_selector : [
            this._instance.config.scroll_root_selector
        ];
        for (var e of i){
            var r = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.document.querySelector(e);
            if (r) return r;
        }
    }
    scrollY() {
        if (this._instance.config.scroll_root_selector) {
            var i = this.scrollElement();
            return i && i.scrollTop || 0;
        }
        return $e444d6404c095fa5$var$t && ($e444d6404c095fa5$var$t.scrollY || $e444d6404c095fa5$var$t.pageYOffset || $e444d6404c095fa5$var$t.document.documentElement.scrollTop) || 0;
    }
    scrollX() {
        if (this._instance.config.scroll_root_selector) {
            var i = this.scrollElement();
            return i && i.scrollLeft || 0;
        }
        return $e444d6404c095fa5$var$t && ($e444d6404c095fa5$var$t.scrollX || $e444d6404c095fa5$var$t.pageXOffset || $e444d6404c095fa5$var$t.document.documentElement.scrollLeft) || 0;
    }
}
var $e444d6404c095fa5$var$oa = (t)=>$e444d6404c095fa5$var$po(null == t ? void 0 : t.config.mask_personal_data_properties, null == t ? void 0 : t.config.custom_personal_data_properties);
class $e444d6404c095fa5$var$aa {
    constructor(t, i, e, r){
        this.Nr = (t)=>{
            var i = this.Ur();
            if (!i || i.sessionId !== t) {
                var e = {
                    sessionId: t,
                    props: this.zr(this._instance)
                };
                this.qr.register({
                    [$e444d6404c095fa5$var$Si]: e
                });
            }
        }, this._instance = t, this.Br = i, this.qr = e, this.zr = r || $e444d6404c095fa5$var$oa, this.Br.onSessionId(this.Nr);
    }
    Ur() {
        return this.qr.props[$e444d6404c095fa5$var$Si];
    }
    getSetOnceProps() {
        var t, i = null == (t = this.Ur()) ? void 0 : t.props;
        return i ? "r" in i ? $e444d6404c095fa5$var$go(i) : {
            $referring_domain: i.referringDomain,
            $pathname: i.initialPathName,
            utm_source: i.utm_source,
            utm_campaign: i.utm_campaign,
            utm_medium: i.utm_medium,
            utm_content: i.utm_content,
            utm_term: i.utm_term
        } : {};
    }
    getSessionProps() {
        var t = {};
        return $e444d6404c095fa5$var$Ct($e444d6404c095fa5$var$jt(this.getSetOnceProps()), (i, e)=>{
            "$current_url" === e && (e = "url"), t["$session_entry_" + $e444d6404c095fa5$var$w(e)] = i;
        }), t;
    }
}
var $e444d6404c095fa5$var$la = $e444d6404c095fa5$var$Et("[SessionId]");
class $e444d6404c095fa5$var$ua {
    constructor(t, i, e){
        var r;
        if (this.Hr = [], this.Wr = (t, i)=>Math.abs(t - i) > this.sessionTimeoutMs, !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
        if ("always" === t.config.cookieless_mode) throw new Error('SessionIdManager cannot be used with cookieless_mode="always"');
        this.A = t.config, this.qr = t.persistence, this.pi = void 0, this.Ft = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this.Gr = i || $e444d6404c095fa5$var$Ce, this.Vr = e || $e444d6404c095fa5$var$Ce;
        var s = this.A.persistence_name || this.A.token, n = this.A.session_idle_timeout_seconds || 1800;
        if (this._sessionTimeoutMs = 1e3 * $e444d6404c095fa5$var$G(n, 60, 36e3, $e444d6404c095fa5$var$la.createLogger("session_idle_timeout_seconds"), 1800), t.register({
            $configured_session_timeout_ms: this._sessionTimeoutMs
        }), this.Jr(), this.Kr = "ph_" + s + "_window_id", this.Yr = "ph_" + s + "_primary_window_exists", this.Xr()) {
            var o = $e444d6404c095fa5$var$He.K(this.Kr), a = $e444d6404c095fa5$var$He.K(this.Yr);
            o && !a ? this.pi = o : $e444d6404c095fa5$var$He.X(this.Kr), $e444d6404c095fa5$var$He.Y(this.Yr, !0);
        }
        if (null != (r = this.A.bootstrap) && r.sessionID) try {
            var l = ((t)=>{
                var i = t.replace(/-/g, "");
                if (32 !== i.length) throw new Error("Not a valid UUID");
                if ("7" !== i[12]) throw new Error("Not a UUIDv7");
                return parseInt(i.substring(0, 12), 16);
            })(this.A.bootstrap.sessionID);
            this.Qr(this.A.bootstrap.sessionID, (new Date).getTime(), l);
        } catch (t) {
            $e444d6404c095fa5$var$la.error("Invalid sessionID in bootstrap", t);
        }
        this.Zr();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(t) {
        return $e444d6404c095fa5$var$C(this.Hr) && (this.Hr = []), this.Hr.push(t), this.Ft && t(this.Ft, this.pi), ()=>{
            this.Hr = this.Hr.filter((i)=>i !== t);
        };
    }
    Xr() {
        return "memory" !== this.A.persistence && !this.qr.je && $e444d6404c095fa5$var$He.G();
    }
    ts(t) {
        t !== this.pi && (this.pi = t, this.Xr() && $e444d6404c095fa5$var$He.Y(this.Kr, t));
    }
    es() {
        return this.pi ? this.pi : this.Xr() ? $e444d6404c095fa5$var$He.K(this.Kr) : null;
    }
    Qr(t, i, e) {
        t === this.Ft && i === this._sessionActivityTimestamp && e === this._sessionStartTimestamp || (this._sessionStartTimestamp = e, this._sessionActivityTimestamp = i, this.Ft = t, this.qr.register({
            [$e444d6404c095fa5$var$ui]: [
                i,
                t,
                e
            ]
        }));
    }
    rs() {
        if (this.Ft && this._sessionActivityTimestamp && this._sessionStartTimestamp) return [
            this._sessionActivityTimestamp,
            this.Ft,
            this._sessionStartTimestamp
        ];
        var t = this.qr.props[$e444d6404c095fa5$var$ui];
        return $e444d6404c095fa5$var$P(t) && 2 === t.length && t.push(t[0]), t || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this.Qr(null, null, null);
    }
    Zr() {
        $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "beforeunload", ()=>{
            this.Xr() && $e444d6404c095fa5$var$He.X(this.Yr);
        }, {
            capture: !1
        });
    }
    checkAndGetSessionAndWindowId(t, i) {
        if (void 0 === t && (t = !1), void 0 === i && (i = null), "always" === this.A.cookieless_mode) throw new Error('checkAndGetSessionAndWindowId should not be called with cookieless_mode="always"');
        var e = i || (new Date).getTime(), [r, s, n] = this.rs(), o = this.es(), a = $e444d6404c095fa5$var$D(n) && n > 0 && Math.abs(e - n) > 864e5, l = !1, u = !s, h = !t && this.Wr(e, r);
        u || h || a ? (s = this.Gr(), o = this.Vr(), $e444d6404c095fa5$var$la.info("new session ID generated", {
            sessionId: s,
            windowId: o,
            changeReason: {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            }
        }), n = e, l = !0) : o || (o = this.Vr(), l = !0);
        var d = 0 === r || !t || a ? e : r, v = 0 === n ? (new Date).getTime() : n;
        return this.ts(o), this.Qr(s, d, v), t || this.Jr(), l && this.Hr.forEach((t)=>t(s, o, l ? {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            } : void 0)), {
            sessionId: s,
            windowId: o,
            sessionStartTimestamp: v,
            changeReason: l ? {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            } : void 0,
            lastActivityTimestamp: r
        };
    }
    Jr() {
        clearTimeout(this.ss), this.ss = setTimeout(()=>{
            var [t] = this.rs();
            this.Wr((new Date).getTime(), t) && this.resetSessionId();
        }, 1.1 * this.sessionTimeoutMs);
    }
}
var $e444d6404c095fa5$var$ha = [
    "$set_once",
    "$set"
], $e444d6404c095fa5$var$da = $e444d6404c095fa5$var$Et("[SiteApps]");
class $e444d6404c095fa5$var$va {
    constructor(t){
        this._instance = t, this.ns = [], this.apps = {};
    }
    get isEnabled() {
        return !!this._instance.config.opt_in_site_apps;
    }
    os(t, i) {
        if (i) {
            var e = this.globalsForEvent(i);
            this.ns.push(e), this.ns.length > 1e3 && (this.ns = this.ns.slice(10));
        }
    }
    get siteAppLoaders() {
        var t;
        return null == (t = $e444d6404c095fa5$var$v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.siteApps;
    }
    init() {
        if (this.isEnabled) {
            var t = this._instance.Ye(this.os.bind(this));
            this.ls = ()=>{
                t(), this.ns = [], this.ls = void 0;
            };
        }
    }
    globalsForEvent(t) {
        var i, e, r, s, n, o, a;
        if (!t) throw new Error("Event payload is required");
        var l = {}, u = this._instance.get_property("$groups") || [], h = this._instance.get_property("$stored_group_properties") || {};
        for (var [d, v] of Object.entries(h))l[d] = {
            id: u[d],
            type: d,
            properties: v
        };
        var { $set_once: c, $set: f } = t;
        return {
            event: $e444d6404c095fa5$var$g({}, $e444d6404c095fa5$var$_(t, $e444d6404c095fa5$var$ha), {
                properties: $e444d6404c095fa5$var$g({}, t.properties, f ? {
                    $set: $e444d6404c095fa5$var$g({}, null !== (i = null == (e = t.properties) ? void 0 : e.$set) && void 0 !== i ? i : {}, f)
                } : {}, c ? {
                    $set_once: $e444d6404c095fa5$var$g({}, null !== (r = null == (s = t.properties) ? void 0 : s.$set_once) && void 0 !== r ? r : {}, c)
                } : {}),
                elements_chain: null !== (n = null == (o = t.properties) ? void 0 : o.$elements_chain) && void 0 !== n ? n : "",
                distinct_id: null == (a = t.properties) ? void 0 : a.distinct_id
            }),
            person: {
                properties: this._instance.get_property("$stored_person_properties")
            },
            groups: l
        };
    }
    setupSiteApp(t) {
        var i = this.apps[t.id], e = ()=>{
            var e;
            (!i.errored && this.ns.length && ($e444d6404c095fa5$var$da.info("Processing " + this.ns.length + " events for site app with id " + t.id), this.ns.forEach((t)=>null == i.processEvent ? void 0 : i.processEvent(t)), i.processedBuffer = !0), Object.values(this.apps).every((t)=>t.processedBuffer || t.errored)) && (null == (e = this.ls) || e.call(this));
        }, r = !1, s = (s)=>{
            i.errored = !s, i.loaded = !0, $e444d6404c095fa5$var$da.info("Site app with id " + t.id + " " + (s ? "loaded" : "errored")), r && e();
        };
        try {
            var { processEvent: n } = t.init({
                posthog: this._instance,
                callback: (t)=>{
                    s(t);
                }
            });
            n && (i.processEvent = n), r = !0;
        } catch (i) {
            $e444d6404c095fa5$var$da.error("Error while initializing PostHog app with config id " + t.id, i), s(!1);
        }
        if (r && i.loaded) try {
            e();
        } catch (e) {
            $e444d6404c095fa5$var$da.error("Error while processing buffered events PostHog app with config id " + t.id, e), i.errored = !0;
        }
    }
    us() {
        var t = this.siteAppLoaders || [];
        for (var i of t)this.apps[i.id] = {
            id: i.id,
            loaded: !1,
            errored: !1,
            processedBuffer: !1
        };
        for (var e of t)this.setupSiteApp(e);
    }
    hs(t) {
        if (0 !== Object.keys(this.apps).length) {
            var i = this.globalsForEvent(t);
            for (var e of Object.values(this.apps))try {
                null == e.processEvent || e.processEvent(i);
            } catch (i) {
                $e444d6404c095fa5$var$da.error("Error while processing event " + t.event + " for site app " + e.id, i);
            }
        }
    }
    onRemoteConfig(t) {
        var i, e, r, s = this;
        if (null != (i = this.siteAppLoaders) && i.length) return this.isEnabled ? (this.us(), void this._instance.on("eventCaptured", (t)=>this.hs(t))) : void $e444d6404c095fa5$var$da.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        if (null == (e = this.ls) || e.call(this), null != (r = t.siteApps) && r.length) {
            if (this.isEnabled) {
                var n = function(t) {
                    var i;
                    $e444d6404c095fa5$var$v["__$$ph_site_app_" + t] = s._instance, null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == i.loadSiteApp || i.loadSiteApp(s._instance, a, (i)=>{
                        if (i) return $e444d6404c095fa5$var$da.error("Error while initializing PostHog app with config id " + t, i);
                    });
                };
                for (var { id: o, url: a } of t.siteApps)n(o);
            } else $e444d6404c095fa5$var$da.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        }
    }
}
var $e444d6404c095fa5$var$ca = [
    "amazonbot",
    "amazonproductbot",
    "app.hypefactors.com",
    "applebot",
    "archive.org_bot",
    "awariobot",
    "backlinksextendedbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "dataforseobot",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "leikibot",
    "linkedinbot",
    "meta-externalagent",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "sebot-wa",
    "sitebulb",
    "slackbot",
    "slurp",
    "trendictionbot",
    "turnitin",
    "twitterbot",
    "vercel-screenshot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "zoombot",
    "bot.htm",
    "bot.php",
    "(bot;",
    "bot/",
    "crawler",
    "ahrefsbot",
    "ahrefssiteaudit",
    "semrushbot",
    "siteauditbot",
    "splitsignalbot",
    "gptbot",
    "oai-searchbot",
    "chatgpt-user",
    "perplexitybot",
    "better uptime bot",
    "sentryuptimebot",
    "uptimerobot",
    "headlesschrome",
    "cypress",
    "google-hoteladsverifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleother",
    "google-cloudvertexbot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "google-inspectiontool",
    "bytespider"
], $e444d6404c095fa5$var$fa = function(t, i) {
    if (!t) return !1;
    var e = t.toLowerCase();
    return $e444d6404c095fa5$var$ca.concat(i || []).some((t)=>{
        var i = t.toLowerCase();
        return -1 !== e.indexOf(i);
    });
}, $e444d6404c095fa5$var$pa = function(t, i) {
    if (!t) return !1;
    var e = t.userAgent;
    if (e && $e444d6404c095fa5$var$fa(e, i)) return !0;
    try {
        var r = null == t ? void 0 : t.userAgentData;
        if (null != r && r.brands && r.brands.some((t)=>$e444d6404c095fa5$var$fa(null == t ? void 0 : t.brand, i))) return !0;
    } catch (t) {}
    return !!t.webdriver;
}, $e444d6404c095fa5$var$ga = function(t) {
    return t.US = "us", t.EU = "eu", t.CUSTOM = "custom", t;
}({}), $e444d6404c095fa5$var$_a = "i.posthog.com";
class $e444d6404c095fa5$var$ma {
    constructor(t){
        this.ds = {}, this.instance = t;
    }
    get apiHost() {
        var t = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === t ? "https://us.i.posthog.com" : t;
    }
    get uiHost() {
        var t, i = null == (t = this.instance.config.ui_host) ? void 0 : t.replace(/\/$/, "");
        return i || (i = this.apiHost.replace("." + $e444d6404c095fa5$var$_a, ".posthog.com")), "https://app.posthog.com" === i ? "https://us.posthog.com" : i;
    }
    get region() {
        return this.ds[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.ds[this.apiHost] = $e444d6404c095fa5$var$ga.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.ds[this.apiHost] = $e444d6404c095fa5$var$ga.EU : this.ds[this.apiHost] = $e444d6404c095fa5$var$ga.CUSTOM), this.ds[this.apiHost];
    }
    endpointFor(t, i) {
        if (void 0 === i && (i = ""), i && (i = "/" === i[0] ? i : "/" + i), "ui" === t) return this.uiHost + i;
        if (this.region === $e444d6404c095fa5$var$ga.CUSTOM) return this.apiHost + i;
        var e = $e444d6404c095fa5$var$_a + i;
        switch(t){
            case "assets":
                return "https://" + this.region + "-assets." + e;
            case "api":
                return "https://" + this.region + "." + e;
        }
    }
}
var $e444d6404c095fa5$var$ya = {
    icontains: (i, e)=>!!$e444d6404c095fa5$var$t && e.href.toLowerCase().indexOf(i.toLowerCase()) > -1,
    not_icontains: (i, e)=>!!$e444d6404c095fa5$var$t && -1 === e.href.toLowerCase().indexOf(i.toLowerCase()),
    regex: (i, e)=>!!$e444d6404c095fa5$var$t && $e444d6404c095fa5$var$en(e.href, i),
    not_regex: (i, e)=>!!$e444d6404c095fa5$var$t && !$e444d6404c095fa5$var$en(e.href, i),
    exact: (t, i)=>i.href === t,
    is_not: (t, i)=>i.href !== t
};
class $e444d6404c095fa5$var$ba {
    constructor(t){
        var i = this;
        this.getWebExperimentsAndEvaluateDisplayLogic = function(t) {
            void 0 === t && (t = !1), i.getWebExperiments((t)=>{
                $e444d6404c095fa5$var$ba.vs("retrieved web experiments from the server"), i.cs = new Map, t.forEach((t)=>{
                    if (t.feature_flag_key) {
                        var e;
                        if (i.cs) $e444d6404c095fa5$var$ba.vs("setting flag key ", t.feature_flag_key, " to web experiment ", t), null == (e = i.cs) || e.set(t.feature_flag_key, t);
                        var r = i._instance.getFeatureFlag(t.feature_flag_key);
                        $e444d6404c095fa5$var$M(r) && t.variants[r] && i.fs(t.name, r, t.variants[r].transforms);
                    } else if (t.variants) for(var s in t.variants){
                        var n = t.variants[s];
                        $e444d6404c095fa5$var$ba.ps(n) && i.fs(t.name, s, n.transforms);
                    }
                });
            }, t);
        }, this._instance = t, this._instance.onFeatureFlags((t)=>{
            this.onFeatureFlags(t);
        });
    }
    onFeatureFlags(t) {
        if (this._is_bot()) $e444d6404c095fa5$var$ba.vs("Refusing to render web experiment since the viewer is a likely bot");
        else if (!this._instance.config.disable_web_experiments) {
            if ($e444d6404c095fa5$var$A(this.cs)) return this.cs = new Map, this.loadIfEnabled(), void this.previewWebExperiment();
            $e444d6404c095fa5$var$ba.vs("applying feature flags", t), t.forEach((t)=>{
                var i;
                if (this.cs && null != (i = this.cs) && i.has(t)) {
                    var e, r = this._instance.getFeatureFlag(t), s = null == (e = this.cs) ? void 0 : e.get(t);
                    r && null != s && s.variants[r] && this.fs(s.name, r, s.variants[r].transforms);
                }
            });
        }
    }
    previewWebExperiment() {
        var t = $e444d6404c095fa5$var$ba.getWindowLocation();
        if (null != t && t.search) {
            var i = $e444d6404c095fa5$var$ge(null == t ? void 0 : t.search, "__experiment_id"), e = $e444d6404c095fa5$var$ge(null == t ? void 0 : t.search, "__experiment_variant");
            i && e && ($e444d6404c095fa5$var$ba.vs("previewing web experiments " + i + " && " + e), this.getWebExperiments((t)=>{
                this.gs(parseInt(i), e, t);
            }, !1, !0));
        }
    }
    loadIfEnabled() {
        this._instance.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
    }
    getWebExperiments(t, i, e) {
        if (this._instance.config.disable_web_experiments && !e) return t([]);
        var r = this._instance.get_property("$web_experiments");
        if (r && !i) return t(r);
        this._instance.Te({
            url: this._instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=" + this._instance.config.token),
            method: "GET",
            callback: (i)=>{
                if (200 !== i.statusCode || !i.json) return t([]);
                var e = i.json.experiments || [];
                return t(e);
            }
        });
    }
    gs(t, i, e) {
        var r = e.filter((i)=>i.id === t);
        r && r.length > 0 && ($e444d6404c095fa5$var$ba.vs("Previewing web experiment [" + r[0].name + "] with variant [" + i + "]"), this.fs(r[0].name, i, r[0].variants[i].transforms));
    }
    static ps(t) {
        return !$e444d6404c095fa5$var$A(t.conditions) && $e444d6404c095fa5$var$ba._s(t) && $e444d6404c095fa5$var$ba.ys(t);
    }
    static _s(t) {
        var i;
        if ($e444d6404c095fa5$var$A(t.conditions) || $e444d6404c095fa5$var$A(null == (i = t.conditions) ? void 0 : i.url)) return !0;
        var e, r, s, n = $e444d6404c095fa5$var$ba.getWindowLocation();
        return !!n && (null == (e = t.conditions) || !e.url || $e444d6404c095fa5$var$ya[null !== (r = null == (s = t.conditions) ? void 0 : s.urlMatchType) && void 0 !== r ? r : "icontains"](t.conditions.url, n));
    }
    static getWindowLocation() {
        return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.location;
    }
    static ys(t) {
        var i;
        if ($e444d6404c095fa5$var$A(t.conditions) || $e444d6404c095fa5$var$A(null == (i = t.conditions) ? void 0 : i.utm)) return !0;
        var e = $e444d6404c095fa5$var$uo();
        if (e.utm_source) {
            var r, s, n, o, a, l, u, h, d = null == (r = t.conditions) || null == (r = r.utm) || !r.utm_campaign || (null == (s = t.conditions) || null == (s = s.utm) ? void 0 : s.utm_campaign) == e.utm_campaign, v = null == (n = t.conditions) || null == (n = n.utm) || !n.utm_source || (null == (o = t.conditions) || null == (o = o.utm) ? void 0 : o.utm_source) == e.utm_source, c = null == (a = t.conditions) || null == (a = a.utm) || !a.utm_medium || (null == (l = t.conditions) || null == (l = l.utm) ? void 0 : l.utm_medium) == e.utm_medium, f = null == (u = t.conditions) || null == (u = u.utm) || !u.utm_term || (null == (h = t.conditions) || null == (h = h.utm) ? void 0 : h.utm_term) == e.utm_term;
            return d && c && f && v;
        }
        return !1;
    }
    static vs(t) {
        for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
        $e444d6404c095fa5$var$xt.info("[WebExperiments] " + t, e);
    }
    fs(t, i, e) {
        this._is_bot() ? $e444d6404c095fa5$var$ba.vs("Refusing to render web experiment since the viewer is a likely bot") : "control" !== i ? e.forEach((e)=>{
            if (e.selector) {
                var r;
                $e444d6404c095fa5$var$ba.vs("applying transform of variant " + i + " for experiment " + t + " ", e);
                var s = null == (r = document) ? void 0 : r.querySelectorAll(e.selector);
                null == s || s.forEach((t)=>{
                    var i = t;
                    e.html && (i.innerHTML = e.html), e.css && i.setAttribute("style", e.css);
                });
            }
        }) : $e444d6404c095fa5$var$ba.vs("Control variants leave the page unmodified.");
    }
    _is_bot() {
        return $e444d6404c095fa5$var$n && this._instance ? $e444d6404c095fa5$var$pa($e444d6404c095fa5$var$n, this._instance.config.custom_blocked_useragents) : void 0;
    }
}
var $e444d6404c095fa5$var$wa = $e444d6404c095fa5$var$Et("[PostHog ExternalIntegrations]"), $e444d6404c095fa5$var$Sa = {
    intercom: "intercom-integration",
    crispChat: "crisp-chat-integration"
};
class $e444d6404c095fa5$var$ka {
    constructor(t){
        this._instance = t;
    }
    nt(t, i) {
        var e;
        null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, t, (t)=>{
            if (t) return $e444d6404c095fa5$var$wa.error("failed to load script", t);
            i();
        });
    }
    startIfEnabledOrStop() {
        var t = this, i = function(i) {
            var e, s, n;
            (!r || null != (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) && null != (e = e.integrations) && e[i] || t.nt($e444d6404c095fa5$var$Sa[i], ()=>{
                var e;
                null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (e = e.integrations) || null == (e = e[i]) || e.start(t._instance);
            }), !r && null != (s = $e444d6404c095fa5$var$v.__PosthogExtensions__) && null != (s = s.integrations) && s[i]) && (null == (n = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (n = n.integrations) || null == (n = n[i]) || n.stop());
        };
        for (var [e, r] of Object.entries(null !== (s = this._instance.config.integrations) && void 0 !== s ? s : {})){
            var s;
            i(e);
        }
    }
}
var $e444d6404c095fa5$var$$a = "[SessionRecording]", $e444d6404c095fa5$var$xa = $e444d6404c095fa5$var$Et($e444d6404c095fa5$var$$a);
class $e444d6404c095fa5$var$Ea {
    get started() {
        var t;
        return !(null == (t = this.bs) || !t.isStarted);
    }
    get status() {
        var t;
        return (null == (t = this.bs) ? void 0 : t.status) || "lazy_loading";
    }
    constructor(t){
        if (this._forceAllowLocalhostNetworkCapture = !1, this.ni = void 0, this._instance = t, !this._instance.sessionManager) throw $e444d6404c095fa5$var$xa.error("started without valid sessionManager"), new Error($e444d6404c095fa5$var$$a + " started without valid sessionManager. This is a bug.");
        if ("always" === this._instance.config.cookieless_mode) throw new Error($e444d6404c095fa5$var$$a + ' cannot be used with cookieless_mode="always"');
    }
    get qt() {
        var i, e = !(null == (i = this._instance.get_property($e444d6404c095fa5$var$ti)) || !i.enabled), r = !this._instance.config.disable_session_recording, s = this._instance.config.disable_session_recording || this._instance.consent.isOptedOut();
        return $e444d6404c095fa5$var$t && e && r && !s;
    }
    startIfEnabledOrStop(t) {
        var i;
        if (!this.qt || null == (i = this.bs) || !i.isStarted) {
            var e = !$e444d6404c095fa5$var$C(Object.assign) && !$e444d6404c095fa5$var$C(Array.from);
            this.qt && e ? (this.ws(t), $e444d6404c095fa5$var$xa.info("starting")) : this.stopRecording();
        }
    }
    ws(t) {
        var i, e, r;
        this.qt && (null != $e444d6404c095fa5$var$v && null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && null != (i = i.rrweb) && i.record && null != (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) && e.initSessionRecording ? this.Pi(t) : null == (r = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == r.loadExternalDependency || r.loadExternalDependency(this._instance, this.Ii, (i)=>{
            if (i) return $e444d6404c095fa5$var$xa.error("could not load recorder", i);
            this.Pi(t);
        }));
    }
    stopRecording() {
        var t;
        null == (t = this.bs) || t.stop();
    }
    ki() {
        var t;
        null == (t = this._instance.persistence) || t.unregister($e444d6404c095fa5$var$hi);
    }
    Ei(t) {
        if (this._instance.persistence) {
            var i, e, r = this._instance.persistence, s = ()=>{
                var i = t.sessionRecording, e = null == i ? void 0 : i.sampleRate, s = $e444d6404c095fa5$var$A(e) ? null : parseFloat(e);
                $e444d6404c095fa5$var$A(s) && this.ki();
                var n = null == i ? void 0 : i.minimumDurationMilliseconds;
                r.register({
                    [$e444d6404c095fa5$var$ti]: $e444d6404c095fa5$var$g({
                        enabled: !!i
                    }, i, {
                        networkPayloadCapture: $e444d6404c095fa5$var$g({
                            capturePerformance: t.capturePerformance
                        }, null == i ? void 0 : i.networkPayloadCapture),
                        canvasRecording: {
                            enabled: null == i ? void 0 : i.recordCanvas,
                            fps: null == i ? void 0 : i.canvasFps,
                            quality: null == i ? void 0 : i.canvasQuality
                        },
                        sampleRate: s,
                        minimumDurationMilliseconds: $e444d6404c095fa5$var$C(n) ? null : n,
                        endpoint: null == i ? void 0 : i.endpoint,
                        triggerMatchType: null == i ? void 0 : i.triggerMatchType,
                        masking: null == i ? void 0 : i.masking,
                        urlTriggers: null == i ? void 0 : i.urlTriggers
                    })
                });
            };
            s(), null == (i = this.ni) || i.call(this), this.ni = null == (e = this._instance.sessionManager) ? void 0 : e.onSessionId(s);
        }
    }
    onRemoteConfig(t) {
        "sessionRecording" in t ? (this.Ei(t), this.startIfEnabledOrStop()) : $e444d6404c095fa5$var$xa.info("skipping remote config with no sessionRecording", t);
    }
    log(t, i) {
        var e;
        void 0 === i && (i = "log"), null != (e = this.bs) && e.log ? this.bs.log(t, i) : $e444d6404c095fa5$var$xa.warn("log called before recorder was ready");
    }
    get Ii() {
        var t, i, e = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.get_property($e444d6404c095fa5$var$ti);
        return (null == e || null == (i = e.scriptConfig) ? void 0 : i.script) || "lazy-recorder";
    }
    Pi(t) {
        var i, e;
        if (null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || !i.initSessionRecording) throw Error("Called on script loaded before session recording is available");
        this.bs || (this.bs = null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) ? void 0 : e.initSessionRecording(this._instance), this.bs._forceAllowLocalhostNetworkCapture = this._forceAllowLocalhostNetworkCapture);
        this.bs.start(t);
    }
    onRRwebEmit(t) {
        var i;
        null == (i = this.bs) || null == i.onRRwebEmit || i.onRRwebEmit(t);
    }
    overrideLinkedFlag() {
        var t;
        null == (t = this.bs) || t.overrideLinkedFlag();
    }
    overrideSampling() {
        var t;
        null == (t = this.bs) || t.overrideSampling();
    }
    overrideTrigger(t) {
        var i;
        null == (i = this.bs) || i.overrideTrigger(t);
    }
    get sdkDebugProperties() {
        var t;
        return (null == (t = this.bs) ? void 0 : t.sdkDebugProperties) || {
            $recording_status: this.status
        };
    }
    tryAddCustomEvent(t, i) {
        var e;
        return !(null == (e = this.bs) || !e.tryAddCustomEvent(t, i));
    }
}
var $e444d6404c095fa5$var$Pa = {}, $e444d6404c095fa5$var$Ia = ()=>{}, $e444d6404c095fa5$var$Ra = "posthog", $e444d6404c095fa5$var$Ta = !$e444d6404c095fa5$var$Ks && -1 === (null == $e444d6404c095fa5$var$d ? void 0 : $e444d6404c095fa5$var$d.indexOf("MSIE")) && -1 === (null == $e444d6404c095fa5$var$d ? void 0 : $e444d6404c095fa5$var$d.indexOf("Mozilla")), $e444d6404c095fa5$var$Ca = (i)=>{
    var e;
    return {
        api_host: "https://us.i.posthog.com",
        ui_host: null,
        token: "",
        autocapture: !0,
        rageclick: !0,
        cross_subdomain_cookie: $e444d6404c095fa5$var$Ut(null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.location),
        persistence: "localStorage+cookie",
        persistence_name: "",
        loaded: $e444d6404c095fa5$var$Ia,
        save_campaign_params: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageview: "2025-05-24" !== i || "history_change",
        capture_pageleave: "if_capture_pageview",
        defaults: null != i ? i : "unset",
        debug: $e444d6404c095fa5$var$a && $e444d6404c095fa5$var$M(null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.search) && -1 !== $e444d6404c095fa5$var$a.search.indexOf("__posthog_debug=true") || !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        disable_surveys_automatic_display: !1,
        disable_external_dependency_loading: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $e444d6404c095fa5$var$t || null == (e = $e444d6404c095fa5$var$t.location) ? void 0 : e.protocol),
        ip: !1,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        consent_persistence_name: null,
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        request_batching: !0,
        properties_string_max_length: 65535,
        session_recording: {},
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        mask_personal_data_properties: !1,
        custom_personal_data_properties: [],
        advanced_disable_flags: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_only_evaluate_survey_feature_flags: !1,
        advanced_enable_surveys: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        surveys_request_timeout_ms: 1e4,
        on_request_error: (t)=>{
            var i = "Bad HTTP status: " + t.statusCode + " " + t.text;
            $e444d6404c095fa5$var$xt.error(i);
        },
        get_device_id: (t)=>t,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: "identified_only",
        before_send: void 0,
        request_queue_config: {
            flush_interval_ms: $e444d6404c095fa5$var$ia
        },
        error_tracking: {},
        _onCapture: $e444d6404c095fa5$var$Ia,
        __preview_eager_load_replay: !0
    };
}, $e444d6404c095fa5$var$Ma = (t)=>{
    var i = {};
    $e444d6404c095fa5$var$C(t.process_person) || (i.person_profiles = t.process_person), $e444d6404c095fa5$var$C(t.xhr_headers) || (i.request_headers = t.xhr_headers), $e444d6404c095fa5$var$C(t.cookie_name) || (i.persistence_name = t.cookie_name), $e444d6404c095fa5$var$C(t.disable_cookie) || (i.disable_persistence = t.disable_cookie), $e444d6404c095fa5$var$C(t.store_google) || (i.save_campaign_params = t.store_google), $e444d6404c095fa5$var$C(t.verbose) || (i.debug = t.verbose);
    var e = $e444d6404c095fa5$var$Mt({}, i, t);
    return $e444d6404c095fa5$var$P(t.property_blacklist) && ($e444d6404c095fa5$var$C(t.property_denylist) ? e.property_denylist = t.property_blacklist : $e444d6404c095fa5$var$P(t.property_denylist) ? e.property_denylist = [
        ...t.property_blacklist,
        ...t.property_denylist
    ] : $e444d6404c095fa5$var$xt.error("Invalid value for property_denylist config: " + t.property_denylist)), e;
};
class $e444d6404c095fa5$var$Oa {
    constructor(){
        this.__forceAllowLocalhost = !1;
    }
    get Ss() {
        return this.__forceAllowLocalhost;
    }
    set Ss(t) {
        $e444d6404c095fa5$var$xt.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
    }
}
class $e444d6404c095fa5$export$a9d6b9cbf49b8241 {
    get decideEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    get flagsEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    constructor(){
        this.webPerformance = new $e444d6404c095fa5$var$Oa, this.ks = !1, this.version = $e444d6404c095fa5$var$c.LIB_VERSION, this.$s = new $e444d6404c095fa5$var$zo, this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = $e444d6404c095fa5$var$Ca(), this.SentryIntegration = $e444d6404c095fa5$var$Os, this.sentryIntegration = (t)=>(function(t, i) {
                var e = $e444d6404c095fa5$var$Ms(t, i);
                return {
                    name: $e444d6404c095fa5$var$Cs,
                    processEvent: (t)=>e(t)
                };
            })(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.xs = !1, this.Es = null, this.Ps = null, this.Is = null, this.featureFlags = new $e444d6404c095fa5$var$Ro(this), this.toolbar = new $e444d6404c095fa5$var$Ls(this), this.scrollManager = new $e444d6404c095fa5$var$na(this), this.pageViewManager = new $e444d6404c095fa5$var$Vs(this), this.surveys = new $e444d6404c095fa5$var$Yo(this), this.experiments = new $e444d6404c095fa5$var$ba(this), this.exceptions = new $e444d6404c095fa5$var$an(this), this.rateLimiter = new $e444d6404c095fa5$var$Qo(this), this.requestRouter = new $e444d6404c095fa5$var$ma(this), this.consent = new $e444d6404c095fa5$var$Ge(this), this.externalIntegrations = new $e444d6404c095fa5$var$ka(this), this.people = {
            set: (t, i, e)=>{
                var r = $e444d6404c095fa5$var$M(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(r), null == e || e({});
            },
            set_once: (t, i, e)=>{
                var r = $e444d6404c095fa5$var$M(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(void 0, r), null == e || e({});
            }
        }, this.on("eventCaptured", (t)=>$e444d6404c095fa5$var$xt.info('send "' + (null == t ? void 0 : t.event) + '"', t));
    }
    init(t, i, e) {
        if (e && e !== $e444d6404c095fa5$var$Ra) {
            var r, s = null !== (r = $e444d6404c095fa5$var$Pa[e]) && void 0 !== r ? r : new $e444d6404c095fa5$export$a9d6b9cbf49b8241;
            return s._init(t, i, e), $e444d6404c095fa5$var$Pa[e] = s, $e444d6404c095fa5$var$Pa[$e444d6404c095fa5$var$Ra][e] = s, s;
        }
        return this._init(t, i, e);
    }
    _init(i, e, r) {
        var s, n;
        if (void 0 === e && (e = {}), $e444d6404c095fa5$var$C(i) || $e444d6404c095fa5$var$O(i)) return $e444d6404c095fa5$var$xt.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        if (this.__loaded) return $e444d6404c095fa5$var$xt.warn("You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = {}, this.Rs = e, this.Ts = [], e.person_profiles && (this.Ps = e.person_profiles), this.set_config($e444d6404c095fa5$var$Mt({}, $e444d6404c095fa5$var$Ca(e.defaults), $e444d6404c095fa5$var$Ma(e), {
            name: r,
            token: i
        })), this.config.on_xhr_error && $e444d6404c095fa5$var$xt.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = e.disable_compression ? void 0 : $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS;
        var o = this.Cs();
        this.persistence = new $e444d6404c095fa5$var$Co(this.config, o), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $e444d6404c095fa5$var$Co($e444d6404c095fa5$var$g({}, this.config, {
            persistence: "sessionStorage"
        }), o);
        var a = $e444d6404c095fa5$var$g({}, this.persistence.props), l = $e444d6404c095fa5$var$g({}, this.sessionPersistence.props);
        this.register({
            $initialization_time: (new Date).toISOString()
        }), this.Ms = new $e444d6404c095fa5$var$ea((t)=>this.Os(t), this.config.request_queue_config), this.Fs = new $e444d6404c095fa5$var$sa(this), this.__request_queue = [];
        var u = "always" === this.config.cookieless_mode || "on_reject" === this.config.cookieless_mode && this.consent.isExplicitlyOptedOut();
        if (u || (this.sessionManager = new $e444d6404c095fa5$var$ua(this), this.sessionPropsManager = new $e444d6404c095fa5$var$aa(this, this.sessionManager, this.persistence)), new $e444d6404c095fa5$var$Us(this).startIfEnabledOrStop(), this.siteApps = new $e444d6404c095fa5$var$va(this), null == (s = this.siteApps) || s.init(), u || (this.config.__preview_eager_load_replay ? this.sessionRecording = new $e444d6404c095fa5$var$Is(this) : this.sessionRecording = new $e444d6404c095fa5$var$Ea(this), this.sessionRecording.startIfEnabledOrStop()), this.config.disable_scroll_properties || this.scrollManager.startMeasuringScrollPosition(), this.autocapture = new $e444d6404c095fa5$var$$e(this), this.autocapture.startIfEnabled(), this.surveys.loadIfEnabled(), this.heatmaps = new $e444d6404c095fa5$var$Gs(this), this.heatmaps.startIfEnabled(), this.webVitalsAutocapture = new $e444d6404c095fa5$var$Bs(this), this.exceptionObserver = new $e444d6404c095fa5$var$Qe(this), this.exceptionObserver.startIfEnabled(), this.deadClicksAutocapture = new $e444d6404c095fa5$var$Ye(this, $e444d6404c095fa5$var$Ke), this.deadClicksAutocapture.startIfEnabled(), this.historyAutocapture = new $e444d6404c095fa5$var$tr(this), this.historyAutocapture.startIfEnabled(), $e444d6404c095fa5$var$c.DEBUG = $e444d6404c095fa5$var$c.DEBUG || this.config.debug, $e444d6404c095fa5$var$c.DEBUG && $e444d6404c095fa5$var$xt.info("Starting in debug mode", {
            this: this,
            config: e,
            thisC: $e444d6404c095fa5$var$g({}, this.config),
            p: a,
            s: l
        }), void 0 !== (null == (n = e.bootstrap) ? void 0 : n.distinctID)) {
            var h, d, v = this.config.get_device_id($e444d6404c095fa5$var$Ce()), f = null != (h = e.bootstrap) && h.isIdentifiedID ? v : e.bootstrap.distinctID;
            this.persistence.set_property($e444d6404c095fa5$var$wi, null != (d = e.bootstrap) && d.isIdentifiedID ? "identified" : "anonymous"), this.register({
                distinct_id: e.bootstrap.distinctID,
                $device_id: f
            });
        }
        if (this.As()) {
            var p, _, m = Object.keys((null == (p = e.bootstrap) ? void 0 : p.featureFlags) || {}).filter((t)=>{
                var i;
                return !(null == (i = e.bootstrap) || null == (i = i.featureFlags) || !i[t]);
            }).reduce((t, i)=>{
                var r;
                return t[i] = (null == (r = e.bootstrap) || null == (r = r.featureFlags) ? void 0 : r[i]) || !1, t;
            }, {}), y = Object.keys((null == (_ = e.bootstrap) ? void 0 : _.featureFlagPayloads) || {}).filter((t)=>m[t]).reduce((t, i)=>{
                var r, s;
                null != (r = e.bootstrap) && null != (r = r.featureFlagPayloads) && r[i] && (t[i] = null == (s = e.bootstrap) || null == (s = s.featureFlagPayloads) ? void 0 : s[i]);
                return t;
            }, {});
            this.featureFlags.receivedFeatureFlags({
                featureFlags: m,
                featureFlagPayloads: y
            });
        }
        if (u) this.register_once({
            distinct_id: $e444d6404c095fa5$var$Ri,
            $device_id: null
        }, "");
        else if (!this.get_distinct_id()) {
            var b = this.config.get_device_id($e444d6404c095fa5$var$Ce());
            this.register_once({
                distinct_id: b,
                $device_id: b
            }, ""), this.persistence.set_property($e444d6404c095fa5$var$wi, "anonymous");
        }
        return $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), {
            passive: !1
        }), this.toolbar.maybeLoadToolbar(), e.segment ? $e444d6404c095fa5$var$Ts(this, ()=>this.Ds()) : this.Ds(), $e444d6404c095fa5$var$I(this.config._onCapture) && this.config._onCapture !== $e444d6404c095fa5$var$Ia && ($e444d6404c095fa5$var$xt.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (t)=>this.config._onCapture(t.event, t))), this.config.ip && $e444d6404c095fa5$var$xt.warn('The `ip` config option has NO EFFECT AT ALL and has been deprecated. Use a custom transformation or "Discard IP data" project setting instead. See https://posthog.com/tutorials/web-redact-properties#hiding-customer-ip-address for more information.'), this;
    }
    Ce(t) {
        var i, e, r, s, n, a, l, u;
        if (!$e444d6404c095fa5$var$o || !$e444d6404c095fa5$var$o.body) return $e444d6404c095fa5$var$xt.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
            this.Ce(t);
        }, 500);
        this.compression = void 0, t.supportedCompression && !this.config.disable_compression && (this.compression = $e444d6404c095fa5$var$y(t.supportedCompression, $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS) ? $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS : $e444d6404c095fa5$var$y(t.supportedCompression, $e444d6404c095fa5$export$6a00d17b5aff0af.Base64) ? $e444d6404c095fa5$export$6a00d17b5aff0af.Base64 : void 0), null != (i = t.analytics) && i.endpoint && (this.analyticsDefaultEndpoint = t.analytics.endpoint), this.set_config({
            person_profiles: this.Ps ? this.Ps : "identified_only"
        }), null == (e = this.siteApps) || e.onRemoteConfig(t), null == (r = this.sessionRecording) || r.onRemoteConfig(t), null == (s = this.autocapture) || s.onRemoteConfig(t), null == (n = this.heatmaps) || n.onRemoteConfig(t), this.surveys.onRemoteConfig(t), null == (a = this.webVitalsAutocapture) || a.onRemoteConfig(t), null == (l = this.exceptionObserver) || l.onRemoteConfig(t), this.exceptions.onRemoteConfig(t), null == (u = this.deadClicksAutocapture) || u.onRemoteConfig(t);
    }
    Ds() {
        try {
            this.config.loaded(this);
        } catch (t) {
            $e444d6404c095fa5$var$xt.critical("`loaded` function failed", t);
        }
        this.js(), this.config.capture_pageview && setTimeout(()=>{
            (this.consent.isOptedIn() || "always" === this.config.cookieless_mode) && this.Ls();
        }, 1), new $e444d6404c095fa5$var$ta(this).load(), this.featureFlags.flags();
    }
    js() {
        var t;
        this.is_capturing() && this.config.request_batching && (null == (t = this.Ms) || t.enable());
    }
    _dom_loaded() {
        this.is_capturing() && $e444d6404c095fa5$var$Tt(this.__request_queue, (t)=>this.Os(t)), this.__request_queue = [], this.js();
    }
    _handle_unload() {
        var t, i;
        this.config.request_batching ? (this.Ns() && this.capture("$pageleave"), null == (t = this.Ms) || t.unload(), null == (i = this.Fs) || i.unload()) : this.Ns() && this.capture("$pageleave", null, {
            transport: "sendBeacon"
        });
    }
    Te(t) {
        this.__loaded && ($e444d6404c095fa5$var$Ta ? this.__request_queue.push(t) : this.rateLimiter.isServerRateLimited(t.batchKey) || (t.transport = t.transport || this.config.api_transport, t.url = $e444d6404c095fa5$var$Xs(t.url, {
            ip: this.config.ip ? 1 : 0
        }), t.headers = $e444d6404c095fa5$var$g({}, this.config.request_headers), t.compression = "best-available" === t.compression ? this.compression : t.compression, t.disableXHRCredentials = this.config.__preview_disable_xhr_credentials, this.config.__preview_disable_beacon && (t.disableTransport = [
            "sendBeacon"
        ]), t.fetchOptions = t.fetchOptions || this.config.fetch_options, ((t)=>{
            var i, e, r, s = $e444d6404c095fa5$var$g({}, t);
            s.timeout = s.timeout || 6e4, s.url = $e444d6404c095fa5$var$Xs(s.url, {
                _: (new Date).getTime().toString(),
                ver: $e444d6404c095fa5$var$c.LIB_VERSION,
                compression: s.compression
            });
            var n = null !== (i = s.transport) && void 0 !== i ? i : "fetch", o = $e444d6404c095fa5$var$tn.filter((t)=>!s.disableTransport || !t.transport || !s.disableTransport.includes(t.transport)), a = null !== (e = null == (r = $e444d6404c095fa5$var$zt(o, (t)=>t.transport === n)) ? void 0 : r.method) && void 0 !== e ? e : o[0].method;
            if (!a) throw new Error("No available transport method");
            a(s);
        })($e444d6404c095fa5$var$g({}, t, {
            callback: (i)=>{
                var e, r;
                (this.rateLimiter.checkForLimiting(i), i.statusCode >= 400) && (null == (e = (r = this.config).on_request_error) || e.call(r, i));
                null == t.callback || t.callback(i);
            }
        }))));
    }
    Os(t) {
        this.Fs ? this.Fs.retriableRequest(t) : this.Te(t);
    }
    _execute_array(t) {
        var i, e = [], r = [], s = [];
        $e444d6404c095fa5$var$Tt(t, (t)=>{
            t && (i = t[0], $e444d6404c095fa5$var$P(i) ? s.push(t) : $e444d6404c095fa5$var$I(t) ? t.call(this) : $e444d6404c095fa5$var$P(t) && "alias" === i ? e.push(t) : $e444d6404c095fa5$var$P(t) && -1 !== i.indexOf("capture") && $e444d6404c095fa5$var$I(this[i]) ? s.push(t) : r.push(t));
        });
        var n = function(t, i) {
            $e444d6404c095fa5$var$Tt(t, function(t) {
                if ($e444d6404c095fa5$var$P(t[0])) {
                    var e = i;
                    $e444d6404c095fa5$var$Ct(t, function(t) {
                        e = e[t[0]].apply(e, t.slice(1));
                    });
                } else this[t[0]].apply(this, t.slice(1));
            }, i);
        };
        n(e, this), n(r, this), n(s, this);
    }
    As() {
        var t, i;
        return (null == (t = this.config.bootstrap) ? void 0 : t.featureFlags) && Object.keys(null == (i = this.config.bootstrap) ? void 0 : i.featureFlags).length > 0 || !1;
    }
    push(t) {
        this._execute_array([
            t
        ]);
    }
    capture(t, i, e) {
        var r;
        if (this.__loaded && this.persistence && this.sessionPersistence && this.Ms) {
            if (this.is_capturing()) {
                if (!$e444d6404c095fa5$var$C(t) && $e444d6404c095fa5$var$M(t)) {
                    if (this.config.opt_out_useragent_filter || !this._is_bot()) {
                        var s = null != e && e.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
                        if (null == s || !s.isRateLimited) {
                            null != i && i.$current_url && !$e444d6404c095fa5$var$M(null == i ? void 0 : i.$current_url) && ($e444d6404c095fa5$var$xt.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), null == i || delete i.$current_url), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
                            var n = new Date, o = (null == e ? void 0 : e.timestamp) || n, a = $e444d6404c095fa5$var$Ce(), l = {
                                uuid: a,
                                event: t,
                                properties: this.calculateEventProperties(t, i || {}, o, a)
                            };
                            s && (l.properties.$lib_rate_limit_remaining_tokens = s.remainingTokens), (null == e ? void 0 : e.$set) && (l.$set = null == e ? void 0 : e.$set);
                            var u, h = this.Us(null == e ? void 0 : e.$set_once);
                            if (h && (l.$set_once = h), (l = $e444d6404c095fa5$var$Lt(l, null != e && e._noTruncate ? null : this.config.properties_string_max_length)).timestamp = o, $e444d6404c095fa5$var$C(null == e ? void 0 : e.timestamp) || (l.properties.$event_time_override_provided = !0, l.properties.$event_time_override_system_time = n), t === $e444d6404c095fa5$export$9d7ec1793ca1658e.DISMISSED || t === $e444d6404c095fa5$export$9d7ec1793ca1658e.SENT) {
                                var d = null == i ? void 0 : i[$e444d6404c095fa5$export$fe4c9af525341543.SURVEY_ID], v = null == i ? void 0 : i[$e444d6404c095fa5$export$fe4c9af525341543.SURVEY_ITERATION];
                                u = {
                                    id: d,
                                    current_iteration: v
                                }, localStorage.getItem($e444d6404c095fa5$var$Go(u)) || localStorage.setItem($e444d6404c095fa5$var$Go(u), "true"), l.$set = $e444d6404c095fa5$var$g({}, l.$set, {
                                    [$e444d6404c095fa5$var$Wo({
                                        id: d,
                                        current_iteration: v
                                    }, t === $e444d6404c095fa5$export$9d7ec1793ca1658e.SENT ? "responded" : "dismissed")]: !0
                                });
                            }
                            var c = $e444d6404c095fa5$var$g({}, l.properties.$set, l.$set);
                            if ($e444d6404c095fa5$var$T(c) || this.setPersonPropertiesForFlags(c), !$e444d6404c095fa5$var$A(this.config.before_send)) {
                                var f = this.zs(l);
                                if (!f) return;
                                l = f;
                            }
                            this.$s.emit("eventCaptured", l);
                            var p = {
                                method: "POST",
                                url: null !== (r = null == e ? void 0 : e._url) && void 0 !== r ? r : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint),
                                data: l,
                                compression: "best-available",
                                batchKey: null == e ? void 0 : e._batchKey
                            };
                            return !this.config.request_batching || e && (null == e || !e._batchKey) || null != e && e.send_instantly ? this.Os(p) : this.Ms.enqueue(p), l;
                        }
                        $e444d6404c095fa5$var$xt.critical("This capture call is ignored due to client rate limiting.");
                    }
                } else $e444d6404c095fa5$var$xt.error("No event name provided to posthog.capture");
            }
        } else $e444d6404c095fa5$var$xt.uninitializedWarning("posthog.capture");
    }
    Ye(t) {
        return this.on("eventCaptured", (i)=>t(i.event, i));
    }
    calculateEventProperties(t, i, e, r, s) {
        if (e = e || new Date, !this.persistence || !this.sessionPersistence) return i;
        var n = s ? void 0 : this.persistence.remove_event_timer(t), a = $e444d6404c095fa5$var$g({}, i);
        if (a.token = this.config.token, a.$config_defaults = this.config.defaults, ("always" == this.config.cookieless_mode || "on_reject" == this.config.cookieless_mode && this.consent.isExplicitlyOptedOut()) && (a.$cookieless_mode = !0), "$snapshot" === t) {
            var l = $e444d6404c095fa5$var$g({}, this.persistence.properties(), this.sessionPersistence.properties());
            return a.distinct_id = l.distinct_id, (!$e444d6404c095fa5$var$M(a.distinct_id) && !$e444d6404c095fa5$var$D(a.distinct_id) || $e444d6404c095fa5$var$O(a.distinct_id)) && $e444d6404c095fa5$var$xt.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), a;
        }
        var u, h = $e444d6404c095fa5$var$yo(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties);
        if (this.sessionManager) {
            var { sessionId: v, windowId: c } = this.sessionManager.checkAndGetSessionAndWindowId(s, e.getTime());
            a.$session_id = v, a.$window_id = c;
        }
        this.sessionPropsManager && $e444d6404c095fa5$var$Mt(a, this.sessionPropsManager.getSessionProps());
        try {
            var f;
            this.sessionRecording && $e444d6404c095fa5$var$Mt(a, this.sessionRecording.sdkDebugProperties), a.$sdk_debug_retry_queue_size = null == (f = this.Fs) ? void 0 : f.length;
        } catch (t) {
            a.$sdk_debug_error_capturing_properties = String(t);
        }
        if (this.requestRouter.region === $e444d6404c095fa5$var$ga.CUSTOM && (a.$lib_custom_api_host = this.config.api_host), u = "$pageview" !== t || s ? "$pageleave" !== t || s ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(e) : this.pageViewManager.doPageView(e, r), a = $e444d6404c095fa5$var$Mt(a, u), "$pageview" === t && $e444d6404c095fa5$var$o && (a.title = $e444d6404c095fa5$var$o.title), !$e444d6404c095fa5$var$C(n)) {
            var p = e.getTime() - n;
            a.$duration = parseFloat((p / 1e3).toFixed(3));
        }
        $e444d6404c095fa5$var$d && this.config.opt_out_useragent_filter && (a.$browser_type = this._is_bot() ? "bot" : "browser"), (a = $e444d6404c095fa5$var$Mt({}, h, this.persistence.properties(), this.sessionPersistence.properties(), a)).$is_identified = this._isIdentified(), $e444d6404c095fa5$var$P(this.config.property_denylist) ? $e444d6404c095fa5$var$Ct(this.config.property_denylist, function(t) {
            delete a[t];
        }) : $e444d6404c095fa5$var$xt.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        var _ = this.config.sanitize_properties;
        _ && ($e444d6404c095fa5$var$xt.error("sanitize_properties is deprecated. Use before_send instead"), a = _(a, t));
        var m = this.qs();
        return a.$process_person_profile = m, m && !s && this.Bs("_calculate_event_properties"), a;
    }
    Us(t) {
        var i;
        if (!this.persistence || !this.qs()) return t;
        if (this.ks) return t;
        var e = this.persistence.get_initial_props(), r = null == (i = this.sessionPropsManager) ? void 0 : i.getSetOnceProps(), s = $e444d6404c095fa5$var$Mt({}, e, r || {}, t || {}), n = this.config.sanitize_properties;
        return n && ($e444d6404c095fa5$var$xt.error("sanitize_properties is deprecated. Use before_send instead"), s = n(s, "$set_once")), this.ks = !0, $e444d6404c095fa5$var$T(s) ? void 0 : s;
    }
    register(t, i) {
        var e;
        null == (e = this.persistence) || e.register(t, i);
    }
    register_once(t, i, e) {
        var r;
        null == (r = this.persistence) || r.register_once(t, i, e);
    }
    register_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.register(t);
    }
    unregister(t) {
        var i;
        null == (i = this.persistence) || i.unregister(t);
    }
    unregister_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.unregister(t);
    }
    Hs(t, i) {
        this.register({
            [t]: i
        });
    }
    getFeatureFlag(t, i) {
        return this.featureFlags.getFeatureFlag(t, i);
    }
    getFeatureFlagPayload(t) {
        var i = this.featureFlags.getFeatureFlagPayload(t);
        try {
            return JSON.parse(i);
        } catch (t) {
            return i;
        }
    }
    isFeatureEnabled(t, i) {
        return this.featureFlags.isFeatureEnabled(t, i);
    }
    reloadFeatureFlags() {
        this.featureFlags.reloadFeatureFlags();
    }
    updateEarlyAccessFeatureEnrollment(t, i, e) {
        this.featureFlags.updateEarlyAccessFeatureEnrollment(t, i, e);
    }
    getEarlyAccessFeatures(t, i, e) {
        return void 0 === i && (i = !1), this.featureFlags.getEarlyAccessFeatures(t, i, e);
    }
    on(t, i) {
        return this.$s.on(t, i);
    }
    onFeatureFlags(t) {
        return this.featureFlags.onFeatureFlags(t);
    }
    onSurveysLoaded(t) {
        return this.surveys.onSurveysLoaded(t);
    }
    onSessionId(t) {
        var i, e;
        return null !== (i = null == (e = this.sessionManager) ? void 0 : e.onSessionId(t)) && void 0 !== i ? i : ()=>{};
    }
    getSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getSurveys(t, i);
    }
    getActiveMatchingSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getActiveMatchingSurveys(t, i);
    }
    renderSurvey(t, i) {
        this.surveys.renderSurvey(t, i);
    }
    displaySurvey(t, i) {
        void 0 === i && (i = $e444d6404c095fa5$var$Jo), this.surveys.displaySurvey(t, i);
    }
    canRenderSurvey(t) {
        return this.surveys.canRenderSurvey(t);
    }
    canRenderSurveyAsync(t, i) {
        return void 0 === i && (i = !1), this.surveys.canRenderSurveyAsync(t, i);
    }
    identify(t, i, e) {
        if (!this.__loaded || !this.persistence) return $e444d6404c095fa5$var$xt.uninitializedWarning("posthog.identify");
        if ($e444d6404c095fa5$var$D(t) && (t = t.toString(), $e444d6404c095fa5$var$xt.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), t) {
            if ([
                "distinct_id",
                "distinctid"
            ].includes(t.toLowerCase())) $e444d6404c095fa5$var$xt.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.');
            else if (t !== $e444d6404c095fa5$var$Ri) {
                if (this.Bs("posthog.identify")) {
                    var r = this.get_distinct_id();
                    if (this.register({
                        $user_id: t
                    }), !this.get_property("$device_id")) {
                        var s = r;
                        this.register_once({
                            $had_persisted_distinct_id: !0,
                            $device_id: s
                        }, "");
                    }
                    t !== r && t !== this.get_property($e444d6404c095fa5$var$Ht) && (this.unregister($e444d6404c095fa5$var$Ht), this.register({
                        distinct_id: t
                    }));
                    var n = "anonymous" === (this.persistence.get_property($e444d6404c095fa5$var$wi) || "anonymous");
                    t !== r && n ? (this.persistence.set_property($e444d6404c095fa5$var$wi, "identified"), this.setPersonPropertiesForFlags($e444d6404c095fa5$var$g({}, e || {}, i || {}), !1), this.capture("$identify", {
                        distinct_id: t,
                        $anon_distinct_id: r
                    }, {
                        $set: i || {},
                        $set_once: e || {}
                    }), this.Is = $e444d6404c095fa5$var$rn(t, i, e), this.featureFlags.setAnonymousDistinctId(r)) : (i || e) && this.setPersonProperties(i, e), t !== r && (this.reloadFeatureFlags(), this.unregister($e444d6404c095fa5$var$bi));
                }
            } else $e444d6404c095fa5$var$xt.critical('The string "' + $e444d6404c095fa5$var$Ri + '" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.');
        } else $e444d6404c095fa5$var$xt.error("Unique user id has not been set in posthog.identify");
    }
    setPersonProperties(t, i) {
        if ((t || i) && this.Bs("posthog.setPersonProperties")) {
            var e = $e444d6404c095fa5$var$rn(this.get_distinct_id(), t, i);
            this.Is !== e ? (this.setPersonPropertiesForFlags($e444d6404c095fa5$var$g({}, i || {}, t || {})), this.capture("$set", {
                $set: t || {},
                $set_once: i || {}
            }), this.Is = e) : $e444d6404c095fa5$var$xt.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
        }
    }
    group(t, i, e) {
        if (t && i) {
            if (this.Bs("posthog.group")) {
                var r = this.getGroups();
                r[t] !== i && this.resetGroupPropertiesForFlags(t), this.register({
                    $groups: $e444d6404c095fa5$var$g({}, r, {
                        [t]: i
                    })
                }), e && (this.capture("$groupidentify", {
                    $group_type: t,
                    $group_key: i,
                    $group_set: e
                }), this.setGroupPropertiesForFlags({
                    [t]: e
                })), r[t] === i || e || this.reloadFeatureFlags();
            }
        } else $e444d6404c095fa5$var$xt.error("posthog.group requires a group type and group key");
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this.featureFlags.setPersonPropertiesForFlags(t, i);
    }
    resetPersonPropertiesForFlags() {
        this.featureFlags.resetPersonPropertiesForFlags();
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this.Bs("posthog.setGroupPropertiesForFlags") && this.featureFlags.setGroupPropertiesForFlags(t, i);
    }
    resetGroupPropertiesForFlags(t) {
        this.featureFlags.resetGroupPropertiesForFlags(t);
    }
    reset(t) {
        var i, e, r, s;
        if ($e444d6404c095fa5$var$xt.info("reset"), !this.__loaded) return $e444d6404c095fa5$var$xt.uninitializedWarning("posthog.reset");
        var n = this.get_property("$device_id");
        if (this.consent.reset(), null == (i = this.persistence) || i.clear(), null == (e = this.sessionPersistence) || e.clear(), this.surveys.reset(), this.featureFlags.reset(), null == (r = this.persistence) || r.set_property($e444d6404c095fa5$var$wi, "anonymous"), null == (s = this.sessionManager) || s.resetSessionId(), this.Is = null, "always" === this.config.cookieless_mode) this.register_once({
            distinct_id: $e444d6404c095fa5$var$Ri,
            $device_id: null
        }, "");
        else {
            var o = this.config.get_device_id($e444d6404c095fa5$var$Ce());
            this.register_once({
                distinct_id: o,
                $device_id: t ? o : n
            }, "");
        }
        this.register({
            $last_posthog_reset: (new Date).toISOString()
        }, 1);
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var t, i;
        return null !== (t = null == (i = this.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== t ? t : "";
    }
    get_session_replay_url(t) {
        if (!this.sessionManager) return "";
        var { sessionId: i, sessionStartTimestamp: e } = this.sessionManager.checkAndGetSessionAndWindowId(!0), r = this.requestRouter.endpointFor("ui", "/project/" + this.config.token + "/replay/" + i);
        if (null != t && t.withTimestamp && e) {
            var s, n = null !== (s = t.timestampLookBack) && void 0 !== s ? s : 10;
            if (!e) return r;
            r += "?t=" + Math.max(Math.floor(((new Date).getTime() - e) / 1e3) - n, 0);
        }
        return r;
    }
    alias(t, i) {
        return t === this.get_property($e444d6404c095fa5$var$Bt) ? ($e444d6404c095fa5$var$xt.critical("Attempting to create alias for existing People user - aborting."), -2) : this.Bs("posthog.alias") ? ($e444d6404c095fa5$var$C(i) && (i = this.get_distinct_id()), t !== i ? (this.Hs($e444d6404c095fa5$var$Ht, t), this.capture("$create_alias", {
            alias: t,
            distinct_id: i
        })) : ($e444d6404c095fa5$var$xt.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
    }
    set_config(t) {
        var i = $e444d6404c095fa5$var$g({}, this.config);
        if ($e444d6404c095fa5$var$R(t)) {
            var e, r, s, n, o;
            $e444d6404c095fa5$var$Mt(this.config, $e444d6404c095fa5$var$Ma(t));
            var a = this.Cs();
            null == (e = this.persistence) || e.update_config(this.config, i, a), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $e444d6404c095fa5$var$Co($e444d6404c095fa5$var$g({}, this.config, {
                persistence: "sessionStorage"
            }), a), $e444d6404c095fa5$var$Le.G() && "true" === $e444d6404c095fa5$var$Le.J("ph_debug") && (this.config.debug = !0), this.config.debug && ($e444d6404c095fa5$var$c.DEBUG = !0, $e444d6404c095fa5$var$xt.info("set_config", {
                config: t,
                oldConfig: i,
                newConfig: $e444d6404c095fa5$var$g({}, this.config)
            })), null == (r = this.sessionRecording) || r.startIfEnabledOrStop(), null == (s = this.autocapture) || s.startIfEnabled(), null == (n = this.heatmaps) || n.startIfEnabled(), this.surveys.loadIfEnabled(), this.Ws(), null == (o = this.externalIntegrations) || o.startIfEnabledOrStop();
        }
    }
    startSessionRecording(t) {
        var i = !0 === t, e = {
            sampling: i || !(null == t || !t.sampling),
            linked_flag: i || !(null == t || !t.linked_flag),
            url_trigger: i || !(null == t || !t.url_trigger),
            event_trigger: i || !(null == t || !t.event_trigger)
        };
        if (Object.values(e).some(Boolean)) {
            var r, s, n, o, a;
            if (null == (r = this.sessionManager) || r.checkAndGetSessionAndWindowId(), e.sampling) null == (s = this.sessionRecording) || s.overrideSampling();
            if (e.linked_flag) null == (n = this.sessionRecording) || n.overrideLinkedFlag();
            if (e.url_trigger) null == (o = this.sessionRecording) || o.overrideTrigger("url");
            if (e.event_trigger) null == (a = this.sessionRecording) || a.overrideTrigger("event");
        }
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var t;
        return !(null == (t = this.sessionRecording) || !t.started);
    }
    captureException(t, i) {
        var e = new Error("PostHog syntheticException"), r = this.exceptions.buildProperties(t, {
            handled: !0,
            syntheticException: e
        });
        return this.exceptions.sendExceptionEvent($e444d6404c095fa5$var$g({}, r, i));
    }
    loadToolbar(t) {
        return this.toolbar.loadToolbar(t);
    }
    get_property(t) {
        var i;
        return null == (i = this.persistence) ? void 0 : i.props[t];
    }
    getSessionProperty(t) {
        var i;
        return null == (i = this.sessionPersistence) ? void 0 : i.props[t];
    }
    toString() {
        var t, i = null !== (t = this.config.name) && void 0 !== t ? t : $e444d6404c095fa5$var$Ra;
        return i !== $e444d6404c095fa5$var$Ra && (i = $e444d6404c095fa5$var$Ra + "." + i), i;
    }
    _isIdentified() {
        var t, i;
        return "identified" === (null == (t = this.persistence) ? void 0 : t.get_property($e444d6404c095fa5$var$wi)) || "identified" === (null == (i = this.sessionPersistence) ? void 0 : i.get_property($e444d6404c095fa5$var$wi));
    }
    qs() {
        var t, i;
        return !("never" === this.config.person_profiles || "identified_only" === this.config.person_profiles && !this._isIdentified() && $e444d6404c095fa5$var$T(this.getGroups()) && (null == (t = this.persistence) || null == (t = t.props) || !t[$e444d6404c095fa5$var$Ht]) && (null == (i = this.persistence) || null == (i = i.props) || !i[$e444d6404c095fa5$var$Pi]));
    }
    Ns() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && (!0 === this.config.capture_pageview || "history_change" === this.config.capture_pageview);
    }
    createPersonProfile() {
        this.qs() || this.Bs("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    Bs(t) {
        return "never" === this.config.person_profiles ? ($e444d6404c095fa5$var$xt.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.Hs($e444d6404c095fa5$var$Pi, !0), !0);
    }
    Cs() {
        if ("always" === this.config.cookieless_mode) return !0;
        var t = this.consent.isOptedOut(), i = this.config.opt_out_persistence_by_default || "on_reject" === this.config.cookieless_mode;
        return this.config.disable_persistence || t && !!i;
    }
    Ws() {
        var t, i, e, r, s = this.Cs();
        (null == (t = this.persistence) ? void 0 : t.je) !== s && (null == (e = this.persistence) || e.set_disabled(s));
        (null == (i = this.sessionPersistence) ? void 0 : i.je) !== s && (null == (r = this.sessionPersistence) || r.set_disabled(s));
        return s;
    }
    opt_in_capturing(t) {
        if ("always" !== this.config.cookieless_mode) {
            var i;
            if ("on_reject" === this.config.cookieless_mode && this.consent.isExplicitlyOptedOut() && (this.reset(!0), this.sessionManager = new $e444d6404c095fa5$var$ua(this), this.persistence && (this.sessionPropsManager = new $e444d6404c095fa5$var$aa(this, this.sessionManager, this.persistence)), this.sessionRecording = new $e444d6404c095fa5$var$Is(this), this.sessionRecording.startIfEnabledOrStop()), this.consent.optInOut(!0), this.Ws(), "on_reject" == this.config.cookieless_mode && this.surveys.loadIfEnabled(), $e444d6404c095fa5$var$C(null == t ? void 0 : t.captureEventName) || null != t && t.captureEventName) this.capture(null !== (i = null == t ? void 0 : t.captureEventName) && void 0 !== i ? i : "$opt_in", null == t ? void 0 : t.captureProperties, {
                send_instantly: !0
            });
            this.config.capture_pageview && this.Ls();
        } else $e444d6404c095fa5$var$xt.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
    }
    opt_out_capturing() {
        var t;
        "always" !== this.config.cookieless_mode ? ("on_reject" === this.config.cookieless_mode && this.consent.isOptedIn() && this.reset(!0), this.consent.optInOut(!1), this.Ws(), "on_reject" === this.config.cookieless_mode && (this.register({
            distinct_id: $e444d6404c095fa5$var$Ri,
            $device_id: null
        }), this.sessionManager = void 0, this.sessionPropsManager = void 0, null == (t = this.sessionRecording) || t.stopRecording(), this.sessionRecording = void 0, this.Ls())) : $e444d6404c095fa5$var$xt.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    get_explicit_consent_status() {
        var t = this.consent.consent;
        return t === $e444d6404c095fa5$var$We.GRANTED ? "granted" : t === $e444d6404c095fa5$var$We.DENIED ? "denied" : "pending";
    }
    is_capturing() {
        return "always" === this.config.cookieless_mode || ("on_reject" === this.config.cookieless_mode ? this.consent.isExplicitlyOptedOut() || this.consent.isOptedIn() : !this.has_opted_out_capturing());
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this.Ws();
    }
    _is_bot() {
        return $e444d6404c095fa5$var$n ? $e444d6404c095fa5$var$pa($e444d6404c095fa5$var$n, this.config.custom_blocked_useragents) : void 0;
    }
    Ls() {
        $e444d6404c095fa5$var$o && ("visible" === $e444d6404c095fa5$var$o.visibilityState ? this.xs || (this.xs = !0, this.capture("$pageview", {
            title: $e444d6404c095fa5$var$o.title
        }, {
            send_instantly: !0
        }), this.Es && ($e444d6404c095fa5$var$o.removeEventListener("visibilitychange", this.Es), this.Es = null)) : this.Es || (this.Es = this.Ls.bind(this), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "visibilitychange", this.Es)));
    }
    debug(i) {
        !1 === i ? (null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.console.log("You've disabled debug mode."), localStorage && localStorage.removeItem("ph_debug"), this.set_config({
            debug: !1
        })) : (null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), localStorage && localStorage.setItem("ph_debug", "true"), this.set_config({
            debug: !0
        }));
    }
    L() {
        var t, i, e, r, s, n, o, a = this.Rs || {};
        return "advanced_disable_flags" in a ? !!a.advanced_disable_flags : !1 !== this.config.advanced_disable_flags ? !!this.config.advanced_disable_flags : !0 === this.config.advanced_disable_decide ? ($e444d6404c095fa5$var$xt.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : (e = "advanced_disable_decide", r = !1, s = $e444d6404c095fa5$var$xt, n = (i = "advanced_disable_flags") in (t = a) && !$e444d6404c095fa5$var$C(t[i]), o = e in t && !$e444d6404c095fa5$var$C(t[e]), n ? t[i] : o ? (s && s.warn("Config field '" + e + "' is deprecated. Please use '" + i + "' instead. The old field will be removed in a future major version."), t[e]) : r);
    }
    zs(t) {
        if ($e444d6404c095fa5$var$A(this.config.before_send)) return t;
        var i = $e444d6404c095fa5$var$P(this.config.before_send) ? this.config.before_send : [
            this.config.before_send
        ], e = t;
        for (var r of i){
            if (e = r(e), $e444d6404c095fa5$var$A(e)) {
                var s = "Event '" + t.event + "' was rejected in beforeSend function";
                return $e444d6404c095fa5$var$N(t.event) ? $e444d6404c095fa5$var$xt.warn(s + ". This can cause unexpected behavior.") : $e444d6404c095fa5$var$xt.info(s), null;
            }
            e.properties && !$e444d6404c095fa5$var$T(e.properties) || $e444d6404c095fa5$var$xt.warn("Event '" + t.event + "' has no properties after beforeSend function, this is likely an error.");
        }
        return e;
    }
    getPageViewId() {
        var t;
        return null == (t = this.pageViewManager.fe) ? void 0 : t.pageViewId;
    }
    captureTraceFeedback(t, i) {
        this.capture("$ai_feedback", {
            $ai_trace_id: String(t),
            $ai_feedback_text: i
        });
    }
    captureTraceMetric(t, i, e) {
        this.capture("$ai_metric", {
            $ai_trace_id: String(t),
            $ai_metric_name: i,
            $ai_metric_value: String(e)
        });
    }
}
!function(t, i) {
    for(var e = 0; e < i.length; e++)t.prototype[i[e]] = $e444d6404c095fa5$var$Dt(t.prototype[i[e]]);
}($e444d6404c095fa5$export$a9d6b9cbf49b8241, [
    "identify"
]);
var $e444d6404c095fa5$var$Aa, $e444d6404c095fa5$export$2e2bcd8739ae039 = ($e444d6404c095fa5$var$Aa = $e444d6404c095fa5$var$Pa[$e444d6404c095fa5$var$Ra] = new $e444d6404c095fa5$export$a9d6b9cbf49b8241, function() {
    function i() {
        i.done || (i.done = !0, $e444d6404c095fa5$var$Ta = !1, $e444d6404c095fa5$var$Ct($e444d6404c095fa5$var$Pa, function(t) {
            t._dom_loaded();
        }));
    }
    null != $e444d6404c095fa5$var$o && $e444d6404c095fa5$var$o.addEventListener ? "complete" === $e444d6404c095fa5$var$o.readyState ? i() : $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "DOMContentLoaded", i, {
        capture: !1
    }) : $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$xt.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
}(), $e444d6404c095fa5$var$Aa);



const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]];
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;



var $acw62 = parcelRequire("acw62");
const $b98af9bcbcc66238$export$416ce63f8d658857 = ()=>{
    const posthogApiKey = "phc_GPRbFERHA3KhuVPZnTg5cg2eEFrLJzTnNxRzMU0WFaC";
    const posthogUrl = "https://us.posthog.com/";
    const apiBaseUrl = "https://prod.lambertbot.com";
    const authUrl = `${apiBaseUrl}/auth`;
    (0, $acw62.useEffect)(()=>{
        if (posthogApiKey) {
            (0, $e444d6404c095fa5$export$2e2bcd8739ae039).init(posthogApiKey, {
                api_host: posthogUrl,
                autocapture: false
            });
            (0, $e444d6404c095fa5$export$2e2bcd8739ae039).capture("landing page visit", {
                user_id: getOrCreateUserId()
            });
        } else console.error("PostHog API key is not set");
    }, []);
    function addToSlack(e) {
        (0, $e444d6404c095fa5$export$2e2bcd8739ae039).capture("add to slack click", {
            user_id: getOrCreateUserId()
        });
    }
    function getOrCreateUserId() {
        let userId = getCookie("user_id");
        if (!userId) {
            userId = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
            setCookie("user_id", userId);
        }
        return userId;
    }
    function setCookie(name, value, days = 365) {
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 86400000);
        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
    }
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
        return null;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "lambert",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                href: "https://www.producthunt.com/posts/lambert?utm_source=producthunt&utm_medium=lw-website&utm_campaign=lambert",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: "https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=420761&theme=light",
                    alt: "Lambert - Office utility Slack bot making office life a bit more fun | Product Hunt",
                    class: "product-hunt"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "frame",
                src: "/img/frame.svg"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "div",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "group",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "overlap-group-wrapper",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "overlap-group",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "/",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: "/img/logo.svg"
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "meet-lambert-your",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "span",
                                    children: "Meet Lambert, your office botler \uD83C\uDFA9 "
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "lambert-is-an-office",
                                children: [
                                    "Lambert is an office utility bot that will take care of",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "loose ends in the most common office matters."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        class: "mt-60",
                        href: authUrl,
                        onClick: addToSlack,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            className: "link-add-to-slack",
                            src: "/img/add_to_slack.png"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "frame-6",
                        src: "/img/frame-6.svg"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-multiple-features",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Multiple features"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "frame-5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "track-debts-between",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-wrapper-3",
                                            children: "\uD83C\uDFE6\xa0\xa0 Track debts between colleagues"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "span-wrapper",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-wrapper-3",
                                            children: "\uD83E\uDD10\xa0\xa0Swear jar"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-wrapper-3",
                                        children: "\uD83C\uDFB2\xa0\xa0Create poll,\xa0roll, or pick random"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "span-wrapper",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-wrapper-3",
                                            children: "\uD83C\uDF82\xa0\xa0Birthday notifications"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-wrapper-3",
                                        children: "\uD83D\uDCF7\xa0\xa0Search and deliver random images or videos - for fun"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-wrapper-3",
                                        children: "\uD83C\uDF81\xa0\xa0Secret Santa"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-7",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "open-debt-png",
                        src: "/img/open-debt-png.png"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bank-header-text",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bank-header",
                                        children: "Settle debts"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "bank-text",
                                        children: [
                                            "Never lose track of office debts. ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            "Open tabs, track and settle debts all within Slack."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "frame-9",
                                src: "/img/frame-5.svg"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-swear-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-swear-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "swear-header-text",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-wrapper-2",
                                        children: "Swear jar"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "pay-for-your-swears",
                                        children: "Pay for your swears\xa0and improve the office budget."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "overlap-wrapper",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "overlap",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "overlap-group-2",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            className: "overlap-group-swear-jar",
                                            src: "/img/swear-jar.svg"
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-swear-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "stats-no-swears",
                                src: "/img/new-1.png"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "stats-no-swears",
                                src: "/img/stats-no-swears-1.png"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-poll-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "frame-poll-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "poll-examples",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "overlap-group-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "poll",
                                        src: "/img/poll2-1.png"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "roll",
                                        src: "/img/roll3-1.png"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-poll-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "frame-poll-header-text",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "heading-settle",
                                        children: "Create polls,\xa0roll, or pick random"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "poll-text",
                                        children: [
                                            "End indecision about lunch, suggest team building activities?",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            "Resolve disagreement once and for all."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "frame-18",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "overlap-3",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "overlap-group-5",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: "/img/pick-roll.svg"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-santa-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-santa-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "santa-header-text",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-wrapper-2",
                                        children: "Secret Santa"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "pay-for-your-swears",
                                        children: [
                                            "'Tis the season to be jolly, boost the holiday spirit by",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            " organizing Secret \uD83C\uDF85 with your team. ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            "Fa la la la la... \uD83C\uDF81"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "santa-svg",
                                src: "/img/frame-2.svg"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "frame-20",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            className: "secret-santa",
                            src: "/img/answer-1.png"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "div",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-wrapper-9",
                        children: "Add Lambert to your workspace now!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        class: "mt-68",
                        href: authUrl,
                        onClick: addToSlack,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            className: "link-add-to-slack",
                            src: "/img/add_to_slack.png"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-21",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "section",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "frame-22",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-wrapper-9",
                                    children: "FAQ"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "frame-23",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "frame-24",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "frame-14",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-wrapper-10",
                                                            children: "How do I install Lambert on my Slack workspace?"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "p",
                                                            children: [
                                                                "It's really simple, just click\xa0",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    className: "text-wrapper-12",
                                                                    href: authUrl,
                                                                    onClick: addToSlack,
                                                                    children: "Add to slack"
                                                                }),
                                                                " ",
                                                                "and follow the instructions."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "frame-14",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-wrapper-10",
                                                            children: "Where can I get help if this app doesn\u2019t work?"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "p-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-wrapper-11",
                                                                    children: "Reach out to us at "
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    href: "mailto:lambert@lambdaworks.io",
                                                                    className: "text-wrapper-12",
                                                                    children: "lambert@lambdaworks.io"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "text-wrapper-11",
                                                                    children: [
                                                                        " ",
                                                                        "and we'll help you out as soon as we can."
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "frame-25",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "frame-21",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "frame-26",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-wrapper-10",
                                                                children: "Can I send suggestions?"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                className: "p-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-wrapper-11",
                                                                        children: "For sure, we\u2019d love to hear what you have to say. Just hit us up at"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                        href: "mailto:lambert@lambdaworks.io",
                                                                        className: "text-wrapper-12",
                                                                        children: [
                                                                            " ",
                                                                            "lambert@lambdaworks.io"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "frame-28",
                                                    src: "/img/frame-1.svg"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-29",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "made-with-by",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-wrapper-11",
                                        children: "Made with \uD83E\uDDE1\xa0\xa0by "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "https://lambdaworks.io",
                                        className: "text-wrapper-12",
                                        children: "LambdaWorks.io"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "div-align-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "link-support",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "/support",
                                            className: "link-support",
                                            children: "Support"
                                        }),
                                        " ",
                                        "/",
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "/policy",
                                            className: "link-support",
                                            children: "Terms and Conditions & Privacy Policy"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $ebb97d3431da5b6f$export$12449a31c6671d53 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b98af9bcbcc66238$export$416ce63f8d658857), {});
};




parcelRequire("acw62");

const $03b01cd96df6d652$export$145dde601631f6d3 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "frame",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "logo",
                alt: "Logo",
                src: "/img/logo.svg"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-wrapper",
                children: "Terms and Conditions & Privacy policy"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Terms and Conditions"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "p",
                                children: "Last updated: October 20, 2023"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: "Please read these terms and conditions carefully before using Our Service."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Interpretation and Definitions"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "div",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-wrapper-4",
                                        children: "Interpretation"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-wrapper-3",
                                        children: "The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "div",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-wrapper-4",
                                        children: "Definitions"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "div-2",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "span",
                                            children: [
                                                "For the purposes of these Terms and Conditions:",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                    className: "ul",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            children: 'Affiliate means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.'
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            children: 'Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to LambdaWorks, Mi\u0161e Dimitrijevi\u0107a 12, Novi Sad.'
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            children: "Country refers to: Serbia"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            children: "Service refers to the Website."
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            children: 'Terms and Conditions (also referred as "Terms") mean these Terms and Conditions that form the entire agreement between You and the Company regarding the use of the Service.'
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            children: "Third-party Social Media Service means any services or content (including data, information, products or services) provided by a third-party that may be displayed, included or made available by the Service."
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            children: [
                                                                "Website refers to Lambert, accessible from",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-wrapper-5",
                                                                    children: "\xa0"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    href: "http://lambertbot.com/",
                                                                    rel: "noopener noreferrer",
                                                                    target: "_blank",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                        className: "text-wrapper-5",
                                                                        children: [
                                                                            "lambertbot.com",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {})
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "span",
                                                                children: "You means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable."
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Acknowledgement"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-wrapper-3",
                                children: [
                                    "These are the Terms and Conditions governing the use of this Service and the agreement that operates between You and the Company. These Terms and Conditions set out the rights and obligations of all users regarding the use of the Service. Your access to and use of the Service is conditioned on Your acceptance of and compliance with these Terms and Conditions. These Terms and Conditions apply to all visitors, users and others who access or use the Service. By accessing or using the Service You agree to be bound by these Terms and Conditions. If You disagree with any part of these Terms and Conditions then You may not access the Service.",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "Your access to and use of the Service is also conditioned on Your acceptance of and compliance with the Privacy Policy of the Company. Our Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your personal information when You use the Application or the Website and tells You about Your privacy rights and how the law protects You. Please read Our Privacy Policy carefully before using Our Service."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Links to Other Websites"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: "Our Service may contain links to third-party web sites or services that are not owned or controlled by the Company. The Company has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that the Company shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods or services available on or through any such web sites or services. We strongly advise You to read the terms and conditions and privacy policies of any third-party web sites or services that You visit."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Termination"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: "We may terminate or suspend Your access immediately, without prior notice or liability, for any reason whatsoever, including without limitation if You breach these Terms and Conditions. Upon termination, Your right to use the Service will cease immediately."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Limitation of Liability"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: "Notwithstanding any damages that You might incur, the entire liability of the Company and any of its suppliers under any provision of this Terms and Your exclusive remedy for all of the foregoing shall be limited to the amount actually paid by You through the Service or 100 USD if You haven't purchased anything through the Service. To the maximum extent permitted by applicable law, in no event shall the Company or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever (including, but not limited to, damages for loss of profits, loss of data or other information, for business interruption, for personal injury, loss of privacy arising out of or in any way related to the use of or inability to use the Service, third-party software and/or third-party hardware used with the Service, or otherwise in connection with any provision of this Terms), even if the Company or any supplier has been advised of the possibility of such damages and even if the remedy fails of its essential purpose. Some states do not allow the exclusion of implied warranties or limitation of liability for incidental or consequential damages, which means that some of the above limitations may not apply. In these states, each party's liability will be limited to the greatest extent permitted by law."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-2",
                                children: '"AS IS" and "AS AVAILABLE" Disclaimer'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: 'The Service is provided to You "AS IS" and "AS AVAILABLE" and with all faults and defects without warranty of any kind. To the maximum extent permitted under applicable law, the Company, on its own behalf and on behalf of its Affiliates and its and their respective licensors and service providers, expressly disclaims all warranties, whether express, implied, statutory or otherwise, with respect to the Service, including all implied warranties of merchantability, fitness for a particular purpose, title and non-infringement, and warranties that may arise out of course of dealing, course of performance, usage or trade practice. Without limitation to the foregoing, the Company provides no warranty or undertaking, and makes no representation of any kind that the Service will meet Your requirements, achieve any intended results, be compatible or work with any other software, applications, systems or services, operate without interruption, meet any performance or reliability standards or be error free or that any errors or defects can or will be corrected. Without limiting the foregoing, neither the Company nor any of the company\'s provider makes any representation or warranty of any kind, express or implied: (i) as to the operation or availability of the Service, or the information, content, and materials or products included thereon; (ii) that the Service will be uninterrupted or error-free; (iii) as to the accuracy, reliability, or currency of any information or content provided through the Service; or (iv) that the Service, its servers, the content, or e-mails sent from or on behalf of the Company are free of viruses, scripts, trojan horses, worms, malware, timebombs or other harmful components. Some jurisdictions do not allow the exclusion of certain types of warranties or limitations on applicable statutory rights of a consumer, so some or all of the above exclusions and limitations may not apply to You. But in such a case the exclusions and limitations set forth in this section shall be applied to the greatest extent enforceable under applicable law.'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Governing Law"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: "The laws of the Country, excluding its conflicts of law rules, shall govern this Terms and Your use of the Service. Your use of the Application may also be subject to other local, state, national, or international laws."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Disputes Resolution"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: "If You have any concern or dispute about the Service, You agree to first try to resolve the dispute informally by contacting the Company."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-2",
                                children: "For European Union (EU) Users"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: "If You are a European Union consumer, you will benefit from any mandatory provisions of the law of the country in which you are resident in."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "United States Legal Compliance"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: "You represent and warrant that (i) You are not located in a country that is subject to the United States government embargo, or that has been designated by the United States government as a \u201Cterrorist supporting\u201D country, and (ii) You are not listed on any United States government list of prohibited or restricted parties."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "United States Legal Compliance"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: "You represent and warrant that (i) You are not located in a country that is subject to the United States government embargo, or that has been designated by the United States government as a \u201Cterrorist supporting\u201D country, and (ii) You are not listed on any United States government list of prohibited or restricted parties."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Severability and Waiver"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "div",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-wrapper-4",
                                        children: "Severability"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-wrapper-3",
                                        children: "If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law and the remaining provisions will continue in full force and effect."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "div",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-wrapper-4",
                                        children: "Waiver"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-wrapper-3",
                                        children: "Except as provided herein, the failure to exercise a right or to require performance of an obligation under this Terms shall not effect a party's ability to exercise such right or require such performance at any time thereafter nor shall be the waiver of a breach constitute a waiver of any subsequent breach."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Translation Interpretation"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: "These Terms and Conditions may have been translated if We have made them available to You on our Service. You agree that the original English text shall prevail in the case of a dispute."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-2",
                                children: "Changes to These Terms and Conditions"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: "We reserve the right, at Our sole discretion, to modify or replace these Terms at any time. If a revision is material We will make reasonable efforts to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at Our sole discretion. By continuing to access or use Our Service after those revisions become effective, You agree to be bound by the revised terms. If You do not agree to the new terms, in whole or in part, please stop using the website and the Service."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Contact Us"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "div-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "span",
                                        children: [
                                            "If you have any questions about these Terms and Conditions, You can contact us:",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            "By email:"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-wrapper-5",
                                        children: " office@lambdaworks.io"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Privacy Policy"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "div-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "span",
                                        children: [
                                            "Your privacy is important to us. It is LambdaWorks' policy to respect your privacy regarding any information we may collect from you across our website,",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "https://lambertbot.com/",
                                        rel: "noopener noreferrer",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-wrapper-5",
                                            children: "https://lambertbot.com"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-wrapper-5",
                                        children: ","
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "span",
                                        children: [
                                            " ",
                                            "and other sites we own and operate. We only ask for personal information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent. When you subscribe to our service, we may collect necessary personal information, including your name, surname, birthday date, and Slack ID. Your birthday date is exclusively used for our birthday command, enhancing community engagement by announcing upcoming birthdays. Additionally, your Slack ID serves various purposes, including facilitating our Secret Santa command and swear command functionalities. We only retain collected information for as long as necessary to provide you with your requested service. What data we store, we\u2019ll protect within commercially acceptable means to prevent loss and theft, as well as unauthorized access, disclosure, copying, use or modification. We don\u2019t share any personally identifying information publicly or with third-parties, except when required to by law. Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies. You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services. Your continued use of our website will be regarded as acceptance of our practices around privacy and personal information. If you have any questions about how we handle user data and personal information, feel free to contact us. This policy is effective as of 28 January 2020."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Data Retention Policy"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: "LambdaWorks seeks to ensure that it retains only data necessary to effectively conduct its program activities and work in fulfillment of its mission. The need to retain data varies widely with the type of data and the purpose for which it was collected. LambdaWorks strives to ensure that data is only retained for the period necessary to fulfill the purpose for which it was collected and is fully deleted when no longer required. This policy sets forth LambdaWorks\u2019s guidelines on data retention and is to be consistently applied throughout the organization."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Scope"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: "This policy covers all data collected by LambdaWorks and stored on LambdaWorks owned or leased systems and media, regardless of location. It applies to both data collected and held electronically (including photographs, video and audio recordings) and data that is collected and held as hard copy or paper files. The need to retain certain information may be mandated by federal or local law, federal regulations and legitimate business purposes, as well as the EU General Data Protection Regulation (GDPR)."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Reasons for Data Retention"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-wrapper-3",
                                children: [
                                    "LambdaWorks retains only that data that is necessary to effectively conduct its program activities, fulfill its mission and comply with applicable laws and regulations. Reasons for data retention include:",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                        className: "ul",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Providing an ongoing service to the data subject (e.g. sending a newsletter, publication or ongoing program updates to an individual, ongoing training or participation in LambdaWorks\u2019s programs, processing of employee payroll and other benefits)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Compliance with applicable laws and regulations associated with financial and programmatic reporting by LambdaWorks to its funding agencies and other donors"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Compliance with applicable labor, tax and immigration laws"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Other regulatory requirements"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Security incident or other investigation"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Intellectual property preservation"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Litigation"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Data Duplication"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: "LambdaWorks seeks to avoid duplication in data storage whenever possible, though there may be instances in which for programmatic or other business reasons it is necessary for data to be held in more than one place. This policy applies to all data in LambdaWorks\u2019 possession, including duplicate copies of data."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Retention Requirements"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-wrapper-3",
                                children: [
                                    "LambdaWorks has set the following guidelines for retaining all personal data as defined in the Institute\u2019s data privacy policy.",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "Website visitor data will be retained as long as necessary to provide the service requested/initiated through the LambdaWorks\u2019 website.",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "Contributor data will be retained for the year in which the individual has contributed and then for one month after the date of the last contribution.",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "Financial information will not be retained longer than is necessary to process a single transaction.",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "Event participant data will be retained for the period of the event, including any follow up activities, such as the distribution of reports, plus a period of one month.",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "Program participant data (including sign in sheets) will be retained for the duration of the grant agreement that financed the program plus any additional time required under the terms of the grant agreement.",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "Personal data of subgrantees, subcontractors and vendors will be kept for the duration of the contract or agreement.",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "Employee data will be held for the duration of employment and then one month after the last day of employment. Data associated with employee wages, leave and pension shall be held for the period of employment plus one month, with the exception of pension eligibility and retirement beneficiary data which shall be kept for one month.",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "Recruitment data, including interview notes of unsuccessful applicants, will be held for one month after the closing of the position recruitment process.",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "Consultant (both paid and pro bono) data will be held for the duration of the consulting contract plus one month after the end of the consultancy.",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "Board member data will be held for the duration of service on the Board plus for one month after the end of the member\u2019s term.",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "Data associated with tax payments (including payroll, corporate and VAT) will be held for one month.",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "Operational data related to program proposals, reporting and program management will be held for the period required by the LambdaWorks donor, but not more than one month."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Data Destruction"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-wrapper-3",
                                children: "Data destruction ensures that LambdaWorks manages the data it controls and processes it in an efficient and responsible manner. When the retention period for the data as outlined above expires, LambdaWorks will actively destroy the data covered by this policy. If an individual believes that there exists a legitimate business reason why certain data should not be destroyed at the end of a retention period, he or she should identify this data to his/her supervisor and provide information as to why the data should not be destroyed. Any exceptions to this data retention policy must be approved by LambdaWorks\u2019s data protection offer in consultation with legal counsel. In rare circumstances, a litigation hold may be issued by legal counsel prohibiting the destruction of certain documents. A litigation hold remains in effect until released by legal counsel and prohibits the destruction of data subject to the hold."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "User Requests"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "div-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "span",
                                        children: [
                                            "The user may ask to have their data deleted, to access their data, or to transfer their data by contacting the development team: by sending an email to",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-wrapper-5",
                                        children: "lambert@lambdaworks.io."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "div-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "made-with-by",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-wrapper-6",
                                children: "Made with \uD83E\uDDE1\xa0\xa0by "
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "https://lambdaworks.io",
                                className: "text-wrapper-7",
                                children: "LambdaWorks.io"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "div-align-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "link-support",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "/support",
                                    className: "text-wrapper-7",
                                    children: "Support"
                                }),
                                " ",
                                "/",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "/policy",
                                    className: "text-wrapper-7",
                                    children: "Terms and Conditions & Privacy Policy"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};


const $e96830ad88001a6e$export$40ee6f678dc3fb2e = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03b01cd96df6d652$export$145dde601631f6d3), {});
};





parcelRequire("acw62");


const $01de4fb1351cc108$export$78e96a157563a622 = ()=>{
    const apiBaseUrl = "https://prod.lambertbot.com";
    const authUrl = `${apiBaseUrl}/auth`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "lambert",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "frame",
                src: "/img/frame.svg"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "div",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "frame-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "group",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "overlap-group-wrapper",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "overlap-group",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "/",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: "/img/logo.svg"
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "meet-lambert-your",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "span",
                                children: "Support "
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "lambert-is-an-office",
                            children: [
                                "For support, feel free to contact us at: ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                    href: "mailto:lambert@lambdaworks.io",
                                    className: "text-wrapper-mail-top",
                                    children: [
                                        "lambert@lambdaworks.io",
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "frame-6",
                        src: "/img/frame-6.svg"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-multiple-features",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Multiple features"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "frame-5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "track-debts-between",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-wrapper-3",
                                            children: "\uD83C\uDFE6\xa0\xa0 Track debts between colleagues"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "span-wrapper",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-wrapper-3",
                                            children: "\uD83E\uDD10\xa0\xa0Swear jar"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-wrapper-3",
                                        children: "\uD83C\uDFB2\xa0\xa0Create poll,\xa0roll, or pick random"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "span-wrapper",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-wrapper-3",
                                            children: "\uD83C\uDF82\xa0\xa0Birthday notifications"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-wrapper-3",
                                        children: "\uD83D\uDCF7\xa0\xa0Search and deliver random images or videos - for fun"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-wrapper-3",
                                        children: "\uD83C\uDF81\xa0\xa0Secret Santa"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-7",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "open-debt-png",
                        src: "/img/open-debt-png.png"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bank-header-text",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bank-header",
                                        children: "Settle debts"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "bank-text",
                                        children: [
                                            "Never lose track of office debts. ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            "Open tabs, track and settle debts all within Slack."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "frame-9",
                                src: "/img/frame-5.svg"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-swear-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-swear-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "swear-header-text",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-wrapper-2",
                                        children: "Swear jar"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "pay-for-your-swears",
                                        children: "Pay for your swears\xa0and improve the office budget."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "overlap-wrapper",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "overlap",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "overlap-group-2",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            className: "overlap-group-swear-jar",
                                            src: "/img/swear-jar.svg"
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-swear-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "stats-no-swears",
                                src: "/img/new-1.png"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "stats-no-swears",
                                src: "/img/stats-no-swears-1.png"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-poll-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "frame-poll-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "poll-examples",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "overlap-group-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "poll",
                                        src: "/img/poll2-1.png"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "roll",
                                        src: "/img/roll3-1.png"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-poll-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "frame-poll-header-text",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "heading-settle",
                                        children: "Create polls,\xa0roll, or pick random"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "poll-text",
                                        children: [
                                            "End indecision about lunch, suggest team building activities?",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            "Resolve disagreement once and for all."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "frame-18",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "overlap-3",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "overlap-group-5",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: "/img/pick-roll.svg"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-santa-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-santa-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "santa-header-text",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-wrapper-2",
                                        children: "Secret Santa"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "pay-for-your-swears",
                                        children: [
                                            "'Tis the season to be jolly, boost the holiday spirit by",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            " organizing Secret \uD83C\uDF85 with your team. ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            "Fa la la la la... \uD83C\uDF81"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "santa-svg",
                                src: "/img/frame-2.svg"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "frame-20",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            className: "secret-santa",
                            src: "/img/answer-1.png"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "div",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-wrapper-9",
                    children: "Add Lambert to your workspace now!"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-21",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "section",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "frame-22",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-wrapper-9",
                                    children: "FAQ"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "frame-23",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "frame-24",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "frame-14",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-wrapper-10",
                                                            children: "How do I install Lambert on my Slack workspace?"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "p",
                                                            children: [
                                                                "It's really simple, just click\xa0",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    href: authUrl,
                                                                    className: "text-wrapper-12",
                                                                    children: "Add to slack"
                                                                }),
                                                                " ",
                                                                "and follow the instructions."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "frame-14",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-wrapper-10",
                                                            children: "Where can I get help if this app doesn\u2019t work?"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "p-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-wrapper-11",
                                                                    children: "Reach out to us at "
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    href: "mailto:lambert@lambdaworks.io",
                                                                    className: "text-wrapper-12",
                                                                    children: "lambert@lambdaworks.io"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "text-wrapper-11",
                                                                    children: [
                                                                        " ",
                                                                        "and we'll help you out as soon as we can."
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "frame-25",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "frame-21",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "frame-26",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-wrapper-10",
                                                                children: "Can I send suggestions?"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                className: "p-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-wrapper-11",
                                                                        children: "For sure, we\u2019d love to hear what you have to say. Just hit us up at"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                        href: "mailto:lambert@lambdaworks.io",
                                                                        className: "text-wrapper-12",
                                                                        children: [
                                                                            " ",
                                                                            "lambert@lambdaworks.io"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "frame-28",
                                                    src: "/img/frame-1.svg"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-29",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "made-with-by",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-wrapper-11",
                                        children: "Made with \uD83E\uDDE1\xa0\xa0by "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "https://lambdaworks.io",
                                        className: "text-wrapper-12",
                                        children: "LambdaWorks.io"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "div-align-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "link-support",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "/support",
                                            className: "link-support",
                                            children: "Support"
                                        }),
                                        " ",
                                        "/",
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "/policy",
                                            className: "link-support",
                                            children: "Terms and Conditions & Privacy Policy"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");

const $24968250c4b38f62$export$56fd804048b73573 = ()=>{
    const apiBaseUrl = "https://prod.lambertbot.com";
    const authUrl = `${apiBaseUrl}/auth`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "lambert-mobile",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "div",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "frame-17",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "overlap-wrapper",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "overlap",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                        className: "text-wrapper",
                                        children: "Support"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "overlap-group-wrapper",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "overlap-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "ellipse"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector",
                                                    src: "/img-mobile/vector.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-2",
                                                    src: "/img-mobile/vector-1.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-3",
                                                    src: "/img-mobile/vector-2.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-4",
                                                    src: "/img-mobile/vector-3.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "group",
                                                    src: "/img-mobile/group.png"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-5",
                                                    src: "/img-mobile/vector-4.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "group-2",
                                                    src: "/img-mobile/group-1.png"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "group-3",
                                                    src: "/img-mobile/group-2.png"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "group-4",
                                                    src: "/img-mobile/group-3.png"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-6",
                                                    src: "/img-mobile/vector-5.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-7",
                                                    src: "/img-mobile/vector-6.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "group-5",
                                                    src: "/img-mobile/group-4.png"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-8",
                                                    src: "/img-mobile/vector-7.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-9",
                                                    src: "/img-mobile/vector-8.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-10",
                                                    src: "/img-mobile/vector-9.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-11",
                                                    src: "/img-mobile/vector-10.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-12",
                                                    src: "/img-mobile/vector-11.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-13",
                                                    src: "/img-mobile/vector-12.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-14",
                                                    src: "/img-mobile/vector-13.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-15",
                                                    src: "/img-mobile/vector-14.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-16",
                                                    src: "/img-mobile/vector-15.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-17",
                                                    src: "/img-mobile/vector-16.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-18",
                                                    src: "/img-mobile/vector-17.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-19",
                                                    src: "/img-mobile/vector-18.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-20",
                                                    src: "/img-mobile/vector-19.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-21",
                                                    src: "/img-mobile/vector-20.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-22",
                                                    src: "/img-mobile/vector-21.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-23",
                                                    src: "/img-mobile/vector-22.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-24",
                                                    src: "/img-mobile/vector-23.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-25",
                                                    src: "/img-mobile/vector-24.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-26",
                                                    src: "/img-mobile/vector-25.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-27",
                                                    src: "/img-mobile/vector-26.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-28",
                                                    src: "/img-mobile/vector-27.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-29",
                                                    src: "/img-mobile/vector-28.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-30",
                                                    src: "/img-mobile/vector-29.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-31",
                                                    src: "/img-mobile/vector-30.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-32",
                                                    src: "/img-mobile/vector-31.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-33",
                                                    src: "/img-mobile/vector-32.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-34",
                                                    src: "/img-mobile/vector-33.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "vector-35",
                                                    src: "/img-mobile/vector-34.svg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "group-6",
                                                    src: "/img-mobile/group-5.png"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "meet-lambert-your",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "span",
                                children: "For support you can reach us at our email"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "lambert-is-an-office",
                            children: "\u23E9 lambert@lambdaworks.io \u23EA"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-18",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "frame-19",
                        src: "/img-mobile/frame-17.svg"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-20",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Multiple features"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "frame-21",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "track-debts-between",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-wrapper-3",
                                            children: "\uD83C\uDFE6\xa0\xa0 Track debts between colleagues"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "div-2",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-wrapper-3",
                                            children: "\uD83E\uDD10\xa0\xa0Swear jar"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "div-2",
                                        children: "\uD83C\uDFB2\xa0\xa0Create poll,\xa0\xa0roll, or pick random"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "div-2",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-wrapper-3",
                                            children: "\uD83C\uDF82\xa0\xa0Birthday notifications"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "search-and-deliver",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-wrapper-3",
                                            children: "\uD83D\uDCF7\xa0\xa0Search and deliver random images or videos - for fun"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "div-2",
                                        children: "\uD83C\uDF81\xa0\xa0Secret santa"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-22",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "frame-23",
                        src: "/img-mobile/frame-18.svg"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-24",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Settle debts"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "p",
                                children: [
                                    "Never lose track of office debts. ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "Open tabs, track and settle debts all within Slack."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "image",
                        src: "/img-mobile/image-10.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-24",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "export-this",
                        src: "/img-mobile/export-this.svg"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-24",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-wrapper-2",
                                children: "Swear jar"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "pay-for-your-swears",
                                children: "Pay for your swears\xa0and improve the office budget."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-25",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "div-wrapper",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "overlap-group-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            className: "rectangle",
                                            src: "/img-mobile/rectangle-17.png"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-wrapper-4",
                                            children: "@Lambert_slack"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "stats-no-swears",
                                src: "/img-mobile/stats-no-swears-1.png"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-24",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "frame-26",
                        src: "/img-mobile/frame-19.svg"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "heading-settle",
                        children: "Create polls,\xa0roll, or pick random"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "p",
                        children: [
                            "End indecision about lunch, suggest team building activities? ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            "Resolve disagreement once and for all."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-27",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "image-2",
                                src: "/img-mobile/image-11.png"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "frame-wrapper",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "frame-28",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "frame-29",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "overlap-group-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "rectangle-2",
                                                    src: "/img-mobile/rectangle-17-1.png"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "text-wrapper-5",
                                                    children: "@Lambert_slack"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-20",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-20",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "frame-30",
                                src: "/img-mobile/frame-20.svg"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "heading-create",
                                children: "Secret Santa"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "pay-for-your-swears",
                                children: "Pay for your swears\xa0and improve the office budget."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "frame-31",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "overlap-group-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "rectangle-3"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-wrapper-6",
                                    children: "@Lambert_slack"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-32",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-wrapper-7",
                        children: "Add Lambert to your workspace now!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "link-add-to-slack",
                        alt: "Link add to slack",
                        src: "/img-mobile/link-add-to-slack-png-1.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "frame-33",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "frame-34",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "frame-35",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "frame-36",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-wrapper-8",
                                            children: "FAQ"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "frame-37",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "frame-21",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-wrapper-9",
                                                            children: "How do I install Lambert on my Slack workspace?"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "it-s-really-simple",
                                                            children: [
                                                                "It's really simple, justclick\xa0",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    href: authUrl,
                                                                    onClick: addToSlack,
                                                                    className: "text-wrapper-12",
                                                                    children: "Add to slack"
                                                                }),
                                                                " ",
                                                                "and follow the instructions."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "frame-21",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-wrapper-9",
                                                            children: "Where can I get help if this app doesn\u2019t work?"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "p-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-wrapper-10",
                                                                    children: "Reach out to us at "
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-wrapper-11",
                                                                    children: "lambert@lambdaworks.io"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "text-wrapper-10",
                                                                    children: [
                                                                        " ",
                                                                        "and we'll help you out as soon as we can."
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "frame-21",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "text-wrapper-9",
                                                            children: "Can I send suggestions?"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "p-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-wrapper-10",
                                                                    children: "For sure, we\u2019d love to hear what you have to say. Just hit us up at"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "text-wrapper-11",
                                                                    children: [
                                                                        " ",
                                                                        "lambert@lambdaworks.io"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    className: "frame-39",
                                    src: "/img-mobile/frame-25.svg"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "frame-40",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "made-with-by",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-wrapper-10",
                                        children: "Made with \uD83E\uDDE1\xa0\xa0by "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-wrapper-11",
                                        children: "LambdaWorks.io"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "div-align-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "link-support",
                                    children: "Support / Terms of Service / Privacy Policy"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $d36d9d3be820a4d8$export$c7a1df07a9ed91ad = ()=>{
    window.mobileCheck = ()=>{
        let check = false;
        ((a)=>{
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };
    // return window.mobileCheck() ? <SupportMobile /> : <SupportDesktop />;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01de4fb1351cc108$export$78e96a157563a622), {});
};


const $34a83e38fb8b3bfc$var$router = (0, $040dbb9c344a508d$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebb97d3431da5b6f$export$12449a31c6671d53), {})
    },
    {
        path: "/confirmation",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a8d3b589a7d6ca32$export$41b6293a43d01328), {})
    },
    {
        path: "/policy",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e96830ad88001a6e$export$40ee6f678dc3fb2e), {})
    },
    {
        path: "/support",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d36d9d3be820a4d8$export$c7a1df07a9ed91ad), {})
    }
]);
const $34a83e38fb8b3bfc$var$app = document.getElementById("app");
const $34a83e38fb8b3bfc$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot($34a83e38fb8b3bfc$var$app);
$34a83e38fb8b3bfc$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$323e4fc2fa4753fb), {
    router: $34a83e38fb8b3bfc$var$router
}));


//# sourceMappingURL=index.7e0934c5.js.map
